import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaintenance = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M380.9 316.6L393.2 317.2L393.7 332L380.3 325L380.9 316.6ZM351.8 315.1L350.8 314.6L350.7 314.5V309C350.7 308.8 350.7 308.6 350.8 308.4V308V308.3L351.1 310.3L351.5 312.9L351.8 315.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M380.9 316.6L393.2 317.2L393.7 332L380.3 325L380.9 316.6ZM351.8 315.1L350.8 314.6L350.7 314.5V309C350.7 308.8 350.7 308.6 350.8 308.4V308V308.3L351.1 310.3L351.5 312.9L351.8 315.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M443.6 265.3C442.9 265.9 442.8 266.9 443.4 267.7C444 268.4 445.1 268.5 445.8 267.9C446.5 267.2 446.6 266.1 445.9 265.5C445.3 264.7 444.3 264.7 443.6 265.3Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M443.6 265.3C442.9 265.9 442.8 266.9 443.4 267.7C444 268.4 445.1 268.5 445.8 267.9C446.5 267.2 446.6 266.1 445.9 265.5C445.3 264.7 444.3 264.7 443.6 265.3Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M370.3 277.5C369.4 277.3 368.5 277.9 368.3 278.8C368.1 279.7 368.7 280.6 369.6 280.8C370.5 281 371.4 280.4 371.6 279.5C371.8 278.5 371.2 277.6 370.3 277.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M370.3 277.5C369.4 277.3 368.5 277.9 368.3 278.8C368.1 279.7 368.7 280.6 369.6 280.8C370.5 281 371.4 280.4 371.6 279.5C371.8 278.5 371.2 277.6 370.3 277.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M364 277.7C363.7 278.6 362.8 279.1 361.9 278.9C361.4 278.8 361.1 278.5 360.9 278.1V276.4C361.3 275.7 362.1 275.3 362.9 275.6C363.8 275.8 364.3 276.8 364 277.7ZM444.5 263C445.3 262.4 445.4 261.3 444.7 260.6C444.1 259.9 443 259.8 442.3 260.4C441.6 261 441.5 262 442 262.8C442.5 263.6 443.7 263.6 444.5 263Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M364 277.7C363.7 278.6 362.8 279.1 361.9 278.9C361.4 278.8 361.1 278.5 360.9 278.1V276.4C361.3 275.7 362.1 275.3 362.9 275.6C363.8 275.8 364.3 276.8 364 277.7ZM444.5 263C445.3 262.4 445.4 261.3 444.7 260.6C444.1 259.9 443 259.8 442.3 260.4C441.6 261 441.5 262 442 262.8C442.5 263.6 443.7 263.6 444.5 263Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M376.5 274.2C376.6 273.3 376 272.4 375.1 272.3C374.2 272.1 373.3 272.8 373.1 273.7C372.9 274.6 373.6 275.5 374.5 275.7C375.5 275.8 376.3 275.2 376.5 274.2ZM367.4 270.8C366.5 270.6 365.6 271.1 365.3 272C365.1 272.9 365.6 273.8 366.6 274.1C367.5 274.3 368.5 273.8 368.7 272.8C368.9 271.9 368.3 271 367.4 270.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M376.5 274.2C376.6 273.3 376 272.4 375.1 272.3C374.2 272.1 373.3 272.8 373.1 273.7C372.9 274.6 373.6 275.5 374.5 275.7C375.5 275.8 376.3 275.2 376.5 274.2ZM367.4 270.8C366.5 270.6 365.6 271.1 365.3 272C365.1 272.9 365.6 273.8 366.6 274.1C367.5 274.3 368.5 273.8 368.7 272.8C368.9 271.9 368.3 271 367.4 270.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M444.6 253.2C443.9 253.8 443.8 254.8 444.4 255.6C445 256.3 446.1 256.4 446.8 255.8C447.5 255.1 447.6 254 446.9 253.4C446.3 252.6 445.3 252.6 444.6 253.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M444.6 253.2C443.9 253.8 443.8 254.8 444.4 255.6C445 256.3 446.1 256.4 446.8 255.8C447.5 255.1 447.6 254 446.9 253.4C446.3 252.6 445.3 252.6 444.6 253.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 265.4C370.4 265.2 369.5 265.8 369.3 266.7C369.1 267.6 369.7 268.5 370.6 268.7C371.5 268.9 372.4 268.3 372.6 267.4C372.8 266.5 372.2 265.6 371.3 265.4Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 265.4C370.4 265.2 369.5 265.8 369.3 266.7C369.1 267.6 369.7 268.5 370.6 268.7C371.5 268.9 372.4 268.3 372.6 267.4C372.8 266.5 372.2 265.6 371.3 265.4Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 263.5C363 263.2 362.1 263.7 361.8 264.6C361.5 265.5 362 266.5 362.9 266.7C363.8 267 364.8 266.5 365 265.5C365.3 264.7 364.8 263.8 363.9 263.5ZM443.1 250.6C443.7 251.4 444.7 251.5 445.5 250.9C446.3 250.3 446.4 249.2 445.7 248.5C445.1 247.8 444 247.7 443.3 248.3C442.7 248.8 442.5 249.8 443.1 250.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 263.5C363 263.2 362.1 263.7 361.8 264.6C361.5 265.5 362 266.5 362.9 266.7C363.8 267 364.8 266.5 365 265.5C365.3 264.7 364.8 263.8 363.9 263.5ZM443.1 250.6C443.7 251.4 444.7 251.5 445.5 250.9C446.3 250.3 446.4 249.2 445.7 248.5C445.1 247.8 444 247.7 443.3 248.3C442.7 248.8 442.5 249.8 443.1 250.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M374.1 261.6C373.9 262.5 374.6 263.4 375.5 263.6C376.4 263.7 377.3 263.1 377.5 262.2C377.6 261.3 377 260.4 376.1 260.3C375.1 260.1 374.3 260.7 374.1 261.6ZM366.3 259.9C366.1 260.8 366.6 261.7 367.6 262C368.5 262.2 369.5 261.7 369.7 260.7C369.9 259.8 369.3 258.9 368.4 258.7C367.5 258.4 366.6 259 366.3 259.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M374.1 261.6C373.9 262.5 374.6 263.4 375.5 263.6C376.4 263.7 377.3 263.1 377.5 262.2C377.6 261.3 377 260.4 376.1 260.3C375.1 260.1 374.3 260.7 374.1 261.6ZM366.3 259.9C366.1 260.8 366.6 261.7 367.6 262C368.5 262.2 369.5 261.7 369.7 260.7C369.9 259.8 369.3 258.9 368.4 258.7C367.5 258.4 366.6 259 366.3 259.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 258.6C361.8 259.1 361.5 259.5 361 259.7V256.5C361.8 256.8 362.3 257.8 362 258.6ZM444.6 241.1C443.9 241.7 443.8 242.7 444.4 243.5C445 244.2 446.1 244.3 446.8 243.7C447.5 243 447.6 241.9 446.9 241.3C446.3 240.5 445.3 240.5 444.6 241.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 258.6C361.8 259.1 361.5 259.5 361 259.7V256.5C361.8 256.8 362.3 257.8 362 258.6ZM444.6 241.1C443.9 241.7 443.8 242.7 444.4 243.5C445 244.2 446.1 244.3 446.8 243.7C447.5 243 447.6 241.9 446.9 241.3C446.3 240.5 445.3 240.5 444.6 241.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 253.3C370.4 253.1 369.5 253.7 369.3 254.6C369.1 255.5 369.7 256.4 370.6 256.6C371.5 256.8 372.4 256.2 372.6 255.3C372.8 254.4 372.2 253.5 371.3 253.3Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 253.3C370.4 253.1 369.5 253.7 369.3 254.6C369.1 255.5 369.7 256.4 370.6 256.6C371.5 256.8 372.4 256.2 372.6 255.3C372.8 254.4 372.2 253.5 371.3 253.3Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 251.4C363 251.1 362.1 251.6 361.8 252.5C361.5 253.4 362 254.4 362.9 254.6C363.8 254.9 364.8 254.4 365 253.4C365.3 252.6 364.8 251.7 363.9 251.4ZM445.5 238.8C446.3 238.2 446.4 237.1 445.7 236.4C445.1 235.7 444 235.6 443.3 236.2C442.6 236.8 442.5 237.8 443 238.6C443.6 239.3 444.7 239.4 445.5 238.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 251.4C363 251.1 362.1 251.6 361.8 252.5C361.5 253.4 362 254.4 362.9 254.6C363.8 254.9 364.8 254.4 365 253.4C365.3 252.6 364.8 251.7 363.9 251.4ZM445.5 238.8C446.3 238.2 446.4 237.1 445.7 236.4C445.1 235.7 444 235.6 443.3 236.2C442.6 236.8 442.5 237.8 443 238.6C443.6 239.3 444.7 239.4 445.5 238.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M377.5 250.1C377.6 249.2 377 248.3 376.1 248.2C375.2 248 374.3 248.7 374.1 249.6C373.9 250.5 374.6 251.4 375.5 251.6C376.4 251.6 377.3 251 377.5 250.1ZM368.4 246.6C367.5 246.4 366.6 246.9 366.3 247.8C366.1 248.7 366.6 249.6 367.6 249.9C368.5 250.1 369.5 249.6 369.7 248.6C369.8 247.7 369.3 246.8 368.4 246.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M377.5 250.1C377.6 249.2 377 248.3 376.1 248.2C375.2 248 374.3 248.7 374.1 249.6C373.9 250.5 374.6 251.4 375.5 251.6C376.4 251.6 377.3 251 377.5 250.1ZM368.4 246.6C367.5 246.4 366.6 246.9 366.3 247.8C366.1 248.7 366.6 249.6 367.6 249.9C368.5 250.1 369.5 249.6 369.7 248.6C369.8 247.7 369.3 246.8 368.4 246.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 246.6C361.8 247.1 361.5 247.5 361 247.7V244.5C361.8 244.7 362.3 245.7 362 246.6ZM447 229.1C446.3 228.4 445.3 228.4 444.6 229C443.9 229.6 443.8 230.6 444.4 231.4C445 232.1 446.1 232.2 446.8 231.6C447.6 230.9 447.7 229.8 447 229.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 246.6C361.8 247.1 361.5 247.5 361 247.7V244.5C361.8 244.7 362.3 245.7 362 246.6ZM447 229.1C446.3 228.4 445.3 228.4 444.6 229C443.9 229.6 443.8 230.6 444.4 231.4C445 232.1 446.1 232.2 446.8 231.6C447.6 230.9 447.7 229.8 447 229.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M370.6 244.6C371.5 244.8 372.4 244.2 372.6 243.3C372.8 242.4 372.2 241.5 371.3 241.3C370.4 241.1 369.5 241.7 369.3 242.6C369.1 243.4 369.7 244.4 370.6 244.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M370.6 244.6C371.5 244.8 372.4 244.2 372.6 243.3C372.8 242.4 372.2 241.5 371.3 241.3C370.4 241.1 369.5 241.7 369.3 242.6C369.1 243.4 369.7 244.4 370.6 244.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362.9 242.6C363.8 242.9 364.8 242.4 365 241.4C365.3 240.5 364.7 239.5 363.9 239.3C363 239 362.1 239.5 361.8 240.4C361.5 241.4 362 242.3 362.9 242.6ZM445.5 226.7C446.3 226.1 446.4 225 445.7 224.3C445.1 223.6 444 223.5 443.3 224.1C442.6 224.7 442.5 225.7 443 226.5C443.6 227.2 444.7 227.3 445.5 226.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362.9 242.6C363.8 242.9 364.8 242.4 365 241.4C365.3 240.5 364.7 239.5 363.9 239.3C363 239 362.1 239.5 361.8 240.4C361.5 241.4 362 242.3 362.9 242.6ZM445.5 226.7C446.3 226.1 446.4 225 445.7 224.3C445.1 223.6 444 223.5 443.3 224.1C442.6 224.7 442.5 225.7 443 226.5C443.6 227.2 444.7 227.3 445.5 226.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 239.4C376.5 239.5 377.3 238.9 377.5 238C377.6 237.1 377 236.2 376.1 236.1C375.2 235.9 374.3 236.6 374.1 237.5C373.9 238.4 374.5 239.3 375.5 239.4ZM367.6 237.8C368.5 238 369.5 237.5 369.7 236.5C369.9 235.6 369.3 234.7 368.4 234.5C367.5 234.3 366.6 234.8 366.3 235.7C366.1 236.7 366.6 237.6 367.6 237.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 239.4C376.5 239.5 377.3 238.9 377.5 238C377.6 237.1 377 236.2 376.1 236.1C375.2 235.9 374.3 236.6 374.1 237.5C373.9 238.4 374.5 239.3 375.5 239.4ZM367.6 237.8C368.5 238 369.5 237.5 369.7 236.5C369.9 235.6 369.3 234.7 368.4 234.5C367.5 234.3 366.6 234.8 366.3 235.7C366.1 236.7 366.6 237.6 367.6 237.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 234.5C361.8 235 361.5 235.4 361 235.6V232.4C361.8 232.6 362.3 233.6 362 234.5ZM447 217C446.3 216.3 445.3 216.3 444.6 216.9C443.9 217.5 443.8 218.5 444.4 219.3C445 220 446.1 220.1 446.8 219.5C447.6 218.8 447.7 217.7 447 217Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 234.5C361.8 235 361.5 235.4 361 235.6V232.4C361.8 232.6 362.3 233.6 362 234.5ZM447 217C446.3 216.3 445.3 216.3 444.6 216.9C443.9 217.5 443.8 218.5 444.4 219.3C445 220 446.1 220.1 446.8 219.5C447.6 218.8 447.7 217.7 447 217Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 229.1C370.4 228.9 369.5 229.5 369.3 230.4C369.1 231.3 369.7 232.2 370.6 232.4C371.5 232.6 372.4 232 372.6 231.1C372.8 230.2 372.2 229.3 371.3 229.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 229.1C370.4 228.9 369.5 229.5 369.3 230.4C369.1 231.3 369.7 232.2 370.6 232.4C371.5 232.6 372.4 232 372.6 231.1C372.8 230.2 372.2 229.3 371.3 229.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 227.3C363 227 362.1 227.5 361.8 228.4C361.5 229.3 362 230.3 362.9 230.5C363.8 230.8 364.8 230.3 365 229.3C365.3 228.5 364.8 227.5 363.9 227.3ZM445.5 214.6C446.3 214 446.4 212.9 445.7 212.2C445.1 211.5 444 211.4 443.3 212C442.6 212.6 442.5 213.6 443 214.4C443.6 215.1 444.7 215.3 445.5 214.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 227.3C363 227 362.1 227.5 361.8 228.4C361.5 229.3 362 230.3 362.9 230.5C363.8 230.8 364.8 230.3 365 229.3C365.3 228.5 364.8 227.5 363.9 227.3ZM445.5 214.6C446.3 214 446.4 212.9 445.7 212.2C445.1 211.5 444 211.4 443.3 212C442.6 212.6 442.5 213.6 443 214.4C443.6 215.1 444.7 215.3 445.5 214.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 227.3C376.5 227.4 377.3 226.8 377.5 225.9C377.6 225 377 224.1 376.1 224C375.2 223.8 374.3 224.5 374.1 225.4C373.9 226.3 374.5 227.2 375.5 227.3ZM367.6 225.8C368.5 226 369.5 225.5 369.7 224.5C369.9 223.6 369.3 222.7 368.4 222.5C367.5 222.3 366.6 222.8 366.3 223.7C366.1 224.6 366.6 225.5 367.6 225.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 227.3C376.5 227.4 377.3 226.8 377.5 225.9C377.6 225 377 224.1 376.1 224C375.2 223.8 374.3 224.5 374.1 225.4C373.9 226.3 374.5 227.2 375.5 227.3ZM367.6 225.8C368.5 226 369.5 225.5 369.7 224.5C369.9 223.6 369.3 222.7 368.4 222.5C367.5 222.3 366.6 222.8 366.3 223.7C366.1 224.6 366.6 225.5 367.6 225.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 222.4C361.8 222.9 361.5 223.3 361 223.4V220.2C361.8 220.6 362.3 221.5 362 222.4ZM447 205C446.3 204.3 445.3 204.3 444.6 204.9C443.9 205.5 443.8 206.5 444.4 207.3C445 208 446.1 208.1 446.8 207.5C447.6 206.7 447.7 205.6 447 205Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 222.4C361.8 222.9 361.5 223.3 361 223.4V220.2C361.8 220.6 362.3 221.5 362 222.4ZM447 205C446.3 204.3 445.3 204.3 444.6 204.9C443.9 205.5 443.8 206.5 444.4 207.3C445 208 446.1 208.1 446.8 207.5C447.6 206.7 447.7 205.6 447 205Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 217.1C370.4 216.9 369.5 217.5 369.3 218.4C369.1 219.3 369.7 220.2 370.6 220.4C371.5 220.6 372.4 220 372.6 219.1C372.8 218.1 372.2 217.2 371.3 217.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 217.1C370.4 216.9 369.5 217.5 369.3 218.4C369.1 219.3 369.7 220.2 370.6 220.4C371.5 220.6 372.4 220 372.6 219.1C372.8 218.1 372.2 217.2 371.3 217.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 215.2C363 214.9 362.1 215.4 361.8 216.3C361.5 217.2 362 218.2 362.9 218.4C363.8 218.7 364.8 218.2 365 217.2C365.3 216.4 364.8 215.4 363.9 215.2ZM445.5 202.5C446.3 201.9 446.4 200.8 445.7 200.1C445.1 199.4 444 199.3 443.3 199.9C442.6 200.5 442.5 201.5 443 202.3C443.6 203 444.7 203.2 445.5 202.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 215.2C363 214.9 362.1 215.4 361.8 216.3C361.5 217.2 362 218.2 362.9 218.4C363.8 218.7 364.8 218.2 365 217.2C365.3 216.4 364.8 215.4 363.9 215.2ZM445.5 202.5C446.3 201.9 446.4 200.8 445.7 200.1C445.1 199.4 444 199.3 443.3 199.9C442.6 200.5 442.5 201.5 443 202.3C443.6 203 444.7 203.2 445.5 202.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 215.3C376.5 215.4 377.3 214.8 377.5 213.9C377.6 213 377 212.1 376.1 212C375.2 211.8 374.3 212.5 374.1 213.4C373.9 214.2 374.5 215.1 375.5 215.3ZM367.6 213.7C368.5 213.9 369.5 213.4 369.7 212.4C369.9 211.5 369.3 210.6 368.4 210.4C367.5 210.2 366.6 210.7 366.3 211.6C366.1 212.5 366.6 213.4 367.6 213.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 215.3C376.5 215.4 377.3 214.8 377.5 213.9C377.6 213 377 212.1 376.1 212C375.2 211.8 374.3 212.5 374.1 213.4C373.9 214.2 374.5 215.1 375.5 215.3ZM367.6 213.7C368.5 213.9 369.5 213.4 369.7 212.4C369.9 211.5 369.3 210.6 368.4 210.4C367.5 210.2 366.6 210.7 366.3 211.6C366.1 212.5 366.6 213.4 367.6 213.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 210.3C361.8 210.8 361.5 211.2 361 211.4V208.2C361.8 208.5 362.3 209.5 362 210.3ZM447 192.9C446.3 192.2 445.3 192.2 444.6 192.8C443.9 193.4 443.8 194.4 444.4 195.2C445 195.9 446.1 196 446.8 195.4C447.6 194.7 447.7 193.5 447 192.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 210.3C361.8 210.8 361.5 211.2 361 211.4V208.2C361.8 208.5 362.3 209.5 362 210.3ZM447 192.9C446.3 192.2 445.3 192.2 444.6 192.8C443.9 193.4 443.8 194.4 444.4 195.2C445 195.9 446.1 196 446.8 195.4C447.6 194.7 447.7 193.5 447 192.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 205C370.4 204.8 369.5 205.4 369.3 206.3C369.1 207.2 369.7 208.1 370.6 208.3C371.5 208.5 372.4 207.9 372.6 207C372.8 206.1 372.2 205.2 371.3 205Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 205C370.4 204.8 369.5 205.4 369.3 206.3C369.1 207.2 369.7 208.1 370.6 208.3C371.5 208.5 372.4 207.9 372.6 207C372.8 206.1 372.2 205.2 371.3 205Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 203.1C363 202.8 362.1 203.3 361.8 204.2C361.5 205.1 362 206.1 362.9 206.3C363.8 206.6 364.8 206.1 365 205.1C365.3 204.3 364.8 203.4 363.9 203.1ZM445.5 190.5C446.3 189.9 446.4 188.8 445.7 188.1C445.1 187.4 444 187.3 443.3 187.9C442.6 188.5 442.5 189.5 443 190.3C443.6 190.9 444.7 191.1 445.5 190.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 203.1C363 202.8 362.1 203.3 361.8 204.2C361.5 205.1 362 206.1 362.9 206.3C363.8 206.6 364.8 206.1 365 205.1C365.3 204.3 364.8 203.4 363.9 203.1ZM445.5 190.5C446.3 189.9 446.4 188.8 445.7 188.1C445.1 187.4 444 187.3 443.3 187.9C442.6 188.5 442.5 189.5 443 190.3C443.6 190.9 444.7 191.1 445.5 190.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 203.2C376.5 203.3 377.3 202.7 377.5 201.8C377.6 200.9 377 200 376.1 199.9C375.2 199.7 374.3 200.4 374.1 201.3C373.9 202.1 374.5 203 375.5 203.2ZM367.6 201.6C368.5 201.8 369.5 201.3 369.7 200.3C369.9 199.4 369.3 198.5 368.4 198.3C367.5 198.1 366.6 198.6 366.3 199.5C366.1 200.4 366.6 201.4 367.6 201.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 203.2C376.5 203.3 377.3 202.7 377.5 201.8C377.6 200.9 377 200 376.1 199.9C375.2 199.7 374.3 200.4 374.1 201.3C373.9 202.1 374.5 203 375.5 203.2ZM367.6 201.6C368.5 201.8 369.5 201.3 369.7 200.3C369.9 199.4 369.3 198.5 368.4 198.3C367.5 198.1 366.6 198.6 366.3 199.5C366.1 200.4 366.6 201.4 367.6 201.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 198.3C361.8 198.8 361.5 199.2 361 199.3V196.1C361.8 196.4 362.3 197.4 362 198.3ZM447 180C446.3 179.3 445.3 179.3 444.6 179.9C443.9 180.5 443.8 181.5 444.4 182.3C445 183 446.1 183.1 446.8 182.5C447.6 181.8 447.7 180.7 447 180Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 198.3C361.8 198.8 361.5 199.2 361 199.3V196.1C361.8 196.4 362.3 197.4 362 198.3ZM447 180C446.3 179.3 445.3 179.3 444.6 179.9C443.9 180.5 443.8 181.5 444.4 182.3C445 183 446.1 183.1 446.8 182.5C447.6 181.8 447.7 180.7 447 180Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 192.1C370.4 191.9 369.5 192.5 369.3 193.4C369.1 194.3 369.7 195.2 370.6 195.4C371.5 195.6 372.4 195 372.6 194.1C372.8 193.2 372.2 192.3 371.3 192.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 192.1C370.4 191.9 369.5 192.5 369.3 193.4C369.1 194.3 369.7 195.2 370.6 195.4C371.5 195.6 372.4 195 372.6 194.1C372.8 193.2 372.2 192.3 371.3 192.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 190.2C363 189.9 362.1 190.4 361.8 191.3C361.5 192.2 362 193.2 362.9 193.4C363.8 193.7 364.8 193.2 365 192.2C365.3 191.4 364.8 190.5 363.9 190.2ZM445.5 177.6C446.3 177 446.4 175.9 445.7 175.2C445.1 174.5 444 174.4 443.3 175C442.6 175.6 442.5 176.6 443 177.4C443.6 178.1 444.7 178.2 445.5 177.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 190.2C363 189.9 362.1 190.4 361.8 191.3C361.5 192.2 362 193.2 362.9 193.4C363.8 193.7 364.8 193.2 365 192.2C365.3 191.4 364.8 190.5 363.9 190.2ZM445.5 177.6C446.3 177 446.4 175.9 445.7 175.2C445.1 174.5 444 174.4 443.3 175C442.6 175.6 442.5 176.6 443 177.4C443.6 178.1 444.7 178.2 445.5 177.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 190.3C376.5 190.4 377.3 189.8 377.5 188.9C377.6 188 377 187.1 376.1 187C375.2 186.8 374.3 187.5 374.1 188.4C373.9 189.3 374.5 190.1 375.5 190.3ZM367.6 188.7C368.5 188.9 369.5 188.4 369.7 187.4C369.9 186.5 369.3 185.6 368.4 185.4C367.5 185.2 366.6 185.7 366.3 186.6C366.1 187.5 366.6 188.5 367.6 188.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 190.3C376.5 190.4 377.3 189.8 377.5 188.9C377.6 188 377 187.1 376.1 187C375.2 186.8 374.3 187.5 374.1 188.4C373.9 189.3 374.5 190.1 375.5 190.3ZM367.6 188.7C368.5 188.9 369.5 188.4 369.7 187.4C369.9 186.5 369.3 185.6 368.4 185.4C367.5 185.2 366.6 185.7 366.3 186.6C366.1 187.5 366.6 188.5 367.6 188.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 185.4C361.9 185.9 361.5 186.3 361 186.5V183.3C361.8 183.6 362.3 184.5 362 185.4ZM447 168.2C446.3 167.5 445.3 167.5 444.6 168.1C443.9 168.7 443.8 169.7 444.4 170.5C445 171.2 446.1 171.3 446.8 170.7C447.6 170 447.7 168.9 447 168.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 185.4C361.9 185.9 361.5 186.3 361 186.5V183.3C361.8 183.6 362.3 184.5 362 185.4ZM447 168.2C446.3 167.5 445.3 167.5 444.6 168.1C443.9 168.7 443.8 169.7 444.4 170.5C445 171.2 446.1 171.3 446.8 170.7C447.6 170 447.7 168.9 447 168.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 180.3C370.4 180.1 369.5 180.7 369.3 181.6C369.1 182.5 369.7 183.4 370.6 183.6C371.5 183.8 372.4 183.2 372.6 182.3C372.8 181.4 372.2 180.5 371.3 180.3Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 180.3C370.4 180.1 369.5 180.7 369.3 181.6C369.1 182.5 369.7 183.4 370.6 183.6C371.5 183.8 372.4 183.2 372.6 182.3C372.8 181.4 372.2 180.5 371.3 180.3Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 178.4C363 178.1 362.1 178.6 361.8 179.5C361.5 180.4 362 181.4 362.9 181.6C363.8 181.9 364.8 181.4 365 180.4C365.3 179.6 364.8 178.7 363.9 178.4ZM445.5 165.8C446.3 165.2 446.4 164.1 445.7 163.4C445.1 162.7 444 162.6 443.3 163.2C442.6 163.8 442.5 164.8 443 165.6C443.6 166.3 444.7 166.4 445.5 165.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 178.4C363 178.1 362.1 178.6 361.8 179.5C361.5 180.4 362 181.4 362.9 181.6C363.8 181.9 364.8 181.4 365 180.4C365.3 179.6 364.8 178.7 363.9 178.4ZM445.5 165.8C446.3 165.2 446.4 164.1 445.7 163.4C445.1 162.7 444 162.6 443.3 163.2C442.6 163.8 442.5 164.8 443 165.6C443.6 166.3 444.7 166.4 445.5 165.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 178.5C376.5 178.6 377.3 178 377.5 177.1C377.6 176.2 377 175.3 376.1 175.2C375.2 175 374.3 175.7 374.1 176.6C373.9 177.5 374.5 178.4 375.5 178.5ZM367.6 176.9C368.5 177.1 369.5 176.6 369.7 175.6C369.9 174.7 369.3 173.8 368.4 173.6C367.5 173.4 366.6 173.9 366.3 174.8C366.1 175.8 366.6 176.7 367.6 176.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 178.5C376.5 178.6 377.3 178 377.5 177.1C377.6 176.2 377 175.3 376.1 175.2C375.2 175 374.3 175.7 374.1 176.6C373.9 177.5 374.5 178.4 375.5 178.5ZM367.6 176.9C368.5 177.1 369.5 176.6 369.7 175.6C369.9 174.7 369.3 173.8 368.4 173.6C367.5 173.4 366.6 173.9 366.3 174.8C366.1 175.8 366.6 176.7 367.6 176.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 173.6C361.9 174.1 361.5 174.5 361 174.6V171.5C361.8 171.8 362.3 172.7 362 173.6ZM447 156.1C446.3 155.4 445.3 155.4 444.6 156C443.9 156.6 443.8 157.6 444.4 158.4C445 159.1 446.1 159.2 446.8 158.6C447.6 157.9 447.7 156.8 447 156.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 173.6C361.9 174.1 361.5 174.5 361 174.6V171.5C361.8 171.8 362.3 172.7 362 173.6ZM447 156.1C446.3 155.4 445.3 155.4 444.6 156C443.9 156.6 443.8 157.6 444.4 158.4C445 159.1 446.1 159.2 446.8 158.6C447.6 157.9 447.7 156.8 447 156.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 168.2C370.4 168 369.5 168.6 369.3 169.5C369.1 170.4 369.7 171.3 370.6 171.5C371.5 171.7 372.4 171.1 372.6 170.2C372.8 169.3 372.2 168.4 371.3 168.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 168.2C370.4 168 369.5 168.6 369.3 169.5C369.1 170.4 369.7 171.3 370.6 171.5C371.5 171.7 372.4 171.1 372.6 170.2C372.8 169.3 372.2 168.4 371.3 168.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 166.4C363 166.1 362.1 166.6 361.8 167.5C361.5 168.4 362 169.4 362.9 169.6C363.8 169.9 364.8 169.4 365 168.4C365.3 167.6 364.8 166.6 363.9 166.4ZM445.5 153.7C446.3 153.1 446.4 152 445.7 151.3C445.1 150.6 444 150.5 443.3 151.1C442.6 151.7 442.5 152.7 443 153.5C443.6 154.2 444.7 154.4 445.5 153.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 166.4C363 166.1 362.1 166.6 361.8 167.5C361.5 168.4 362 169.4 362.9 169.6C363.8 169.9 364.8 169.4 365 168.4C365.3 167.6 364.8 166.6 363.9 166.4ZM445.5 153.7C446.3 153.1 446.4 152 445.7 151.3C445.1 150.6 444 150.5 443.3 151.1C442.6 151.7 442.5 152.7 443 153.5C443.6 154.2 444.7 154.4 445.5 153.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 166.4C376.5 166.5 377.3 165.9 377.5 165C377.6 164.1 377 163.2 376.1 163.1C375.2 162.9 374.3 163.6 374.1 164.5C373.9 165.4 374.5 166.3 375.5 166.4ZM367.6 164.8C368.5 165 369.5 164.5 369.7 163.5C369.9 162.6 369.3 161.7 368.4 161.5C367.5 161.3 366.6 161.8 366.3 162.7C366.1 163.7 366.6 164.6 367.6 164.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 166.4C376.5 166.5 377.3 165.9 377.5 165C377.6 164.1 377 163.2 376.1 163.1C375.2 162.9 374.3 163.6 374.1 164.5C373.9 165.4 374.5 166.3 375.5 166.4ZM367.6 164.8C368.5 165 369.5 164.5 369.7 163.5C369.9 162.6 369.3 161.7 368.4 161.5C367.5 161.3 366.6 161.8 366.3 162.7C366.1 163.7 366.6 164.6 367.6 164.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 161.5C361.9 162 361.5 162.4 361 162.5V159.4C361.8 159.7 362.3 160.6 362 161.5ZM447 144C446.3 143.3 445.3 143.3 444.6 143.9C443.9 144.5 443.8 145.5 444.4 146.3C445 147 446.1 147.1 446.8 146.5C447.6 145.8 447.7 144.7 447 144Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 161.5C361.9 162 361.5 162.4 361 162.5V159.4C361.8 159.7 362.3 160.6 362 161.5ZM447 144C446.3 143.3 445.3 143.3 444.6 143.9C443.9 144.5 443.8 145.5 444.4 146.3C445 147 446.1 147.1 446.8 146.5C447.6 145.8 447.7 144.7 447 144Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371.3 156.1C370.4 155.9 369.5 156.5 369.3 157.4C369.1 158.3 369.7 159.2 370.6 159.4C371.5 159.6 372.4 159 372.6 158.1C372.8 157.2 372.2 156.3 371.3 156.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371.3 156.1C370.4 155.9 369.5 156.5 369.3 157.4C369.1 158.3 369.7 159.2 370.6 159.4C371.5 159.6 372.4 159 372.6 158.1C372.8 157.2 372.2 156.3 371.3 156.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M363.9 154.2C363 153.9 362.1 154.4 361.8 155.3C361.5 156.2 362 157.2 362.9 157.4C363.8 157.7 364.8 157.2 365 156.2C365.3 155.4 364.8 154.5 363.9 154.2ZM445.5 141.6C446.3 141 446.4 139.9 445.7 139.2C445.1 138.5 444 138.4 443.3 139C442.6 139.6 442.5 140.6 443 141.4C443.6 142.1 444.7 142.2 445.5 141.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M363.9 154.2C363 153.9 362.1 154.4 361.8 155.3C361.5 156.2 362 157.2 362.9 157.4C363.8 157.7 364.8 157.2 365 156.2C365.3 155.4 364.8 154.5 363.9 154.2ZM445.5 141.6C446.3 141 446.4 139.9 445.7 139.2C445.1 138.5 444 138.4 443.3 139C442.6 139.6 442.5 140.6 443 141.4C443.6 142.1 444.7 142.2 445.5 141.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 154.3C376.5 154.4 377.3 153.8 377.5 152.9C377.6 152 377 151.1 376.1 151C375.2 150.8 374.3 151.5 374.1 152.4C373.9 153.3 374.5 154.1 375.5 154.3ZM367.6 152.7C368.5 152.9 369.5 152.4 369.7 151.4C369.9 150.5 369.3 149.6 368.4 149.4C367.5 149.2 366.6 149.7 366.3 150.6C366.1 151.5 366.6 152.5 367.6 152.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 154.3C376.5 154.4 377.3 153.8 377.5 152.9C377.6 152 377 151.1 376.1 151C375.2 150.8 374.3 151.5 374.1 152.4C373.9 153.3 374.5 154.1 375.5 154.3ZM367.6 152.7C368.5 152.9 369.5 152.4 369.7 151.4C369.9 150.5 369.3 149.6 368.4 149.4C367.5 149.2 366.6 149.7 366.3 150.6C366.1 151.5 366.6 152.5 367.6 152.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362 149.4C361.8 150 361.4 150.4 360.8 150.5C360.5 149.4 360 148.4 359.2 147.6C359.7 147.2 360.3 147.1 360.9 147.3C361.8 147.5 362.3 148.5 362 149.4ZM444.6 131.8C443.9 132.4 443.8 133.4 444.4 134.2C445 134.9 446.1 135 446.8 134.4C447.5 133.7 447.6 132.6 446.9 132C446.3 131.3 445.3 131.2 444.6 131.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362 149.4C361.8 150 361.4 150.4 360.8 150.5C360.5 149.4 360 148.4 359.2 147.6C359.7 147.2 360.3 147.1 360.9 147.3C361.8 147.5 362.3 148.5 362 149.4ZM444.6 131.8C443.9 132.4 443.8 133.4 444.4 134.2C445 134.9 446.1 135 446.8 134.4C447.5 133.7 447.6 132.6 446.9 132C446.3 131.3 445.3 131.2 444.6 131.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M370.6 147.4C371.5 147.6 372.4 147 372.6 146.1C372.8 145.2 372.2 144.3 371.3 144.1C370.4 143.9 369.5 144.5 369.3 145.4C369.1 146.2 369.7 147.2 370.6 147.4Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M370.6 147.4C371.5 147.6 372.4 147 372.6 146.1C372.8 145.2 372.2 144.3 371.3 144.1C370.4 143.9 369.5 144.5 369.3 145.4C369.1 146.2 369.7 147.2 370.6 147.4Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362.9 145.4C363.8 145.7 364.8 145.2 365 144.2C365.3 143.3 364.7 142.3 363.9 142.1C363 141.8 362.1 142.3 361.8 143.2C361.5 144.2 362 145.1 362.9 145.4ZM355.4 142.7C356.3 143.1 357.3 142.6 357.6 141.8C357.9 140.9 357.5 139.9 356.7 139.6C355.9 139.2 354.9 139.6 354.5 140.5C354.1 141.3 354.5 142.3 355.4 142.7ZM445.5 129.5C446.3 128.9 446.4 127.8 445.7 127.1C445.1 126.4 444 126.3 443.3 126.9C442.6 127.5 442.5 128.5 443 129.3C443.6 130 444.7 130.1 445.5 129.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362.9 145.4C363.8 145.7 364.8 145.2 365 144.2C365.3 143.3 364.7 142.3 363.9 142.1C363 141.8 362.1 142.3 361.8 143.2C361.5 144.2 362 145.1 362.9 145.4ZM355.4 142.7C356.3 143.1 357.3 142.6 357.6 141.8C357.9 140.9 357.5 139.9 356.7 139.6C355.9 139.2 354.9 139.6 354.5 140.5C354.1 141.3 354.5 142.3 355.4 142.7ZM445.5 129.5C446.3 128.9 446.4 127.8 445.7 127.1C445.1 126.4 444 126.3 443.3 126.9C442.6 127.5 442.5 128.5 443 129.3C443.6 130 444.7 130.1 445.5 129.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M375.5 142.2C376.5 142.3 377.3 141.7 377.5 140.8C377.6 139.9 377 139 376.1 138.9C375.2 138.7 374.3 139.4 374.1 140.3C373.9 141.2 374.5 142.1 375.5 142.2ZM367.6 140.6C368.5 140.8 369.5 140.3 369.7 139.3C369.9 138.4 369.3 137.5 368.4 137.3C367.5 137.1 366.6 137.6 366.3 138.5C366.1 139.5 366.6 140.4 367.6 140.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M375.5 142.2C376.5 142.3 377.3 141.7 377.5 140.8C377.6 139.9 377 139 376.1 138.9C375.2 138.7 374.3 139.4 374.1 140.3C373.9 141.2 374.5 142.1 375.5 142.2ZM367.6 140.6C368.5 140.8 369.5 140.3 369.7 139.3C369.9 138.4 369.3 137.5 368.4 137.3C367.5 137.1 366.6 137.6 366.3 138.5C366.1 139.5 366.6 140.4 367.6 140.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M359.8 138.4C360.7 138.7 361.7 138.2 362 137.3C362.3 136.4 361.8 135.4 360.9 135.1C360 134.8 359.1 135.3 358.7 136.1C358.4 137.1 358.9 138 359.8 138.4ZM352.3 135.3C353.2 135.7 354.2 135.3 354.6 134.5C355 133.6 354.6 132.6 353.8 132.2C353 131.8 352 132.1 351.5 133C351 133.8 351.4 134.9 352.3 135.3Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M359.8 138.4C360.7 138.7 361.7 138.2 362 137.3C362.3 136.4 361.8 135.4 360.9 135.1C360 134.8 359.1 135.3 358.7 136.1C358.4 137.1 358.9 138 359.8 138.4ZM352.3 135.3C353.2 135.7 354.2 135.3 354.6 134.5C355 133.6 354.6 132.6 353.8 132.2C353 131.8 352 132.1 351.5 133C351 133.8 351.4 134.9 352.3 135.3Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M433 154.2C432 153.5 430.7 153.3 429.6 153.8C417.1 158.3 401.7 160 387.9 158.6H387.8C386.9 158.6 385.9 159 385.2 159.6C384.5 160.3 384.1 161.3 384.1 162.3V254.2C384.1 256.2 385.7 257.8 387.7 257.9C404.6 258.9 421.9 256.8 431.9 252.1C432.6 251.8 433.2 251.3 433.5 250.7C433.9 250.1 434.1 249.4 434.1 248.6L434.5 157.1C434.6 156 434 155 433 154.2ZM394.9 253.8C394.9 252.6 395.9 251.7 397 251.7C398.2 251.7 399.1 252.7 399.1 253.8C399.1 255 398.1 255.9 397 255.9C395.8 255.9 394.9 255 394.9 253.8ZM418.5 160.8C418.5 159.7 419.4 158.8 420.5 158.8C421.6 158.8 422.5 159.7 422.5 160.8C422.5 162 421.6 162.8 420.5 162.8C419.4 162.9 418.5 161.9 418.5 160.8ZM427.1 168.1C425.6 168.1 424.4 166.9 424.4 165.4C424.4 163.9 425.6 162.7 427.1 162.7C428.6 162.7 429.8 163.9 429.8 165.4C429.8 166.9 428.5 168.1 427.1 168.1ZM276.8 252.3V265.2L326.9 236.3V223.4L276.8 252.3ZM307 245.2C307 245.6 306.8 246 306.4 246.2L296.6 251.9C296.4 252 296.2 252.1 296 252.1C295.8 252.1 295.6 252 295.4 251.9C295 251.7 294.8 251.3 294.8 250.8V244.6C294.8 244.2 295.1 243.8 295.4 243.5L305.2 237.8C305.6 237.6 306 237.6 306.4 237.8C306.8 238 307 238.4 307 238.9V245.2ZM283.3 126.4C283.3 127.8 280 130.4 274.6 130.4C274 130.4 273.5 130.4 272.8 130.3C268.4 129.8 265.7 127.7 265.7 126.5C265.7 125.1 269 122.5 274.4 122.5C277.4 122.5 279.8 123.3 281.2 124.2C282.6 125 283.3 125.8 283.3 126.4ZM283 130.6V163.6C283 164.7 279.8 166.7 274.6 166.7C269.4 166.7 266.2 164.7 266.2 163.6V130.6C266.7 130.9 267.3 131.1 267.8 131.3C269.2 131.8 270.7 132.1 272.4 132.3C273.1 132.4 273.8 132.4 274.5 132.4C277.9 132.4 280.8 131.8 283 130.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M433 154.2C432 153.5 430.7 153.3 429.6 153.8C417.1 158.3 401.7 160 387.9 158.6H387.8C386.9 158.6 385.9 159 385.2 159.6C384.5 160.3 384.1 161.3 384.1 162.3V254.2C384.1 256.2 385.7 257.8 387.7 257.9C404.6 258.9 421.9 256.8 431.9 252.1C432.6 251.8 433.2 251.3 433.5 250.7C433.9 250.1 434.1 249.4 434.1 248.6L434.5 157.1C434.6 156 434 155 433 154.2ZM394.9 253.8C394.9 252.6 395.9 251.7 397 251.7C398.2 251.7 399.1 252.7 399.1 253.8C399.1 255 398.1 255.9 397 255.9C395.8 255.9 394.9 255 394.9 253.8ZM418.5 160.8C418.5 159.7 419.4 158.8 420.5 158.8C421.6 158.8 422.5 159.7 422.5 160.8C422.5 162 421.6 162.8 420.5 162.8C419.4 162.9 418.5 161.9 418.5 160.8ZM427.1 168.1C425.6 168.1 424.4 166.9 424.4 165.4C424.4 163.9 425.6 162.7 427.1 162.7C428.6 162.7 429.8 163.9 429.8 165.4C429.8 166.9 428.5 168.1 427.1 168.1ZM276.8 252.3V265.2L326.9 236.3V223.4L276.8 252.3ZM307 245.2C307 245.6 306.8 246 306.4 246.2L296.6 251.9C296.4 252 296.2 252.1 296 252.1C295.8 252.1 295.6 252 295.4 251.9C295 251.7 294.8 251.3 294.8 250.8V244.6C294.8 244.2 295.1 243.8 295.4 243.5L305.2 237.8C305.6 237.6 306 237.6 306.4 237.8C306.8 238 307 238.4 307 238.9V245.2ZM283.3 126.4C283.3 127.8 280 130.4 274.6 130.4C274 130.4 273.5 130.4 272.8 130.3C268.4 129.8 265.7 127.7 265.7 126.5C265.7 125.1 269 122.5 274.4 122.5C277.4 122.5 279.8 123.3 281.2 124.2C282.6 125 283.3 125.8 283.3 126.4ZM283 130.6V163.6C283 164.7 279.8 166.7 274.6 166.7C269.4 166.7 266.2 164.7 266.2 163.6V130.6C266.7 130.9 267.3 131.1 267.8 131.3C269.2 131.8 270.7 132.1 272.4 132.3C273.1 132.4 273.8 132.4 274.5 132.4C277.9 132.4 280.8 131.8 283 130.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.9 364.5C215.8 363.6 215.6 362.8 215.5 362C215.1 360 214.7 357.9 214.2 355.9C213.9 354.7 213.6 353.6 213.3 352.5C212.2 348.8 210.9 345.2 209.3 341.7C208.9 340.8 208.5 339.8 208 338.9C207.5 337.9 207.1 337 206.6 336C206.1 335.1 205.6 334.1 205.1 333.2C202.7 329.1 200 325.1 197 321.4C195.7 319.8 194.4 318.3 193 316.8C192 315.7 191 314.7 190 313.7C190 313.6 189.9 313.6 189.9 313.6C187.7 311.5 185.4 309.5 183 307.6C177.8 303.5 172.2 300 166.2 297.1C165.3 296.6 164.3 296.2 163.4 295.8C160.4 294.5 157.3 293.3 154.2 292.3C153.4 292 152.5 291.8 151.7 291.5C145.8 289.8 139.7 288.8 133.4 288.4C132.9 288.4 132.4 288.3 132 288.3H130.9C130.1 288.3 129.4 288.2 128.6 288.2H127.4C126 288.2 124.5 288.2 123.1 288.3C122 288.3 120.9 288.4 119.8 288.5C117.6 288.7 115.5 288.9 113.4 289.3C113 289.4 112.6 289.4 112.3 289.5C108.4 290.1 104.7 291 101 292.2C99.8999 292.5 98.7999 292.9 97.7999 293.3C97.6999 293.3 97.4999 293.4 97.3999 293.4C96.3999 293.8 95.3999 294.1 94.3999 294.6C61.2999 307.8 37.8999 340.1 37.8999 377.9C37.8999 427.4 77.9999 467.5 127.5 467.5C169 467.5 203.8 439.3 214.1 401.1C214.7 398.8 215.2 396.5 215.7 394.2V393.9C215.9 392.8 216.1 391.8 216.2 390.7C216.4 389.3 216.6 387.9 216.7 386.4C217 383.6 217.1 380.7 217.1 377.8C216.9 373.3 216.5 368.8 215.9 364.5ZM138.8 367.6C146.7 359.7 149.6 352.1 150.8 345.1C151.3 341.9 152.7 338.8 155.2 336.3C156.3 335.2 157.6 334.2 159 333.5C159.5 333.3 159.9 333 160.4 332.9C160.6 332.8 160.9 332.7 161.1 332.6C161.8 332.4 162.4 332.2 163.1 332.1C163.2 332.1 163.3 332.1 163.4 332C164 331.9 164.5 331.8 165.1 331.8H166.6L161.2 341.1C159.1 344.7 160.3 349.3 163.9 351.4C165.1 352.1 166.4 352.4 167.7 352.4C168.3 352.4 169 352.3 169.6 352.1L170.5 351.8C171.4 351.4 172.2 350.9 172.9 350.2C173.4 349.7 173.8 349.2 174.1 348.6L179.5 339.3C183.1 345.3 182.4 353.2 177.2 358.4C174.6 361 171.4 362.4 168.1 362.8C161.2 364 153.6 367 145.9 374.7L145.4 375.2L138.3 368.1L138.8 367.6ZM73.0999 332.6C81.6999 328.6 91.9999 323.6 94.1999 325.8L95.9999 327.6C96.8999 328.4 97.1999 328.8 97.1999 328.8L98.3999 330H95.9999V332.4H93.5999V334.8H91.1999V337.2H88.7999V339.6H86.3999V342H83.9999L81.1999 344.8L96.7999 360.4L90.2999 366.9L66.8999 343.5C65.4999 341.8 64.4999 336.7 73.0999 332.6ZM122.4 378.3L111.9 388.8L111.6 388.5L106 382.9L116.5 372.4L122.1 378L122.4 378.3ZM120.8 385.8C122.8 386 124.5 386.2 126 386.6C126.9 386.8 127.8 387.1 128.6 387.4L131 389.8L133.1 391.9L135.2 394C137.3 396 137.3 399.4 135.2 401.4C133.2 403.4 129.8 403.4 127.8 401.4L125.7 399.3L123.6 397.2L116.5 390.1L115.5 389L118.9 385.6H119C119.4 385.6 119.7 385.7 120.1 385.7C120.4 385.7 120.6 385.8 120.9 385.8H120.8ZM88.9999 440.1C84.9999 440.1 80.9999 438.6 77.9999 435.5C71.8999 429.4 71.8999 419.5 77.9999 413.5C80.4999 410.9 83.7999 409.5 87.0999 409.1C93.9999 407.9 101.5 404.9 109.3 397.2L112.8 393.8L119.9 400.9L116.4 404.4C108.5 412.3 105.6 419.9 104.4 426.9C103.9 430.1 102.5 433.2 99.9999 435.7C96.9999 438.6 92.9999 440.1 88.9999 440.1ZM179.3 425.3C174 430.5 169.6 425.5 167.1 422C165.2 419.4 161.6 414.9 159.8 412.7C159.2 411.9 158.8 411.5 158.8 411.5C156.8 409.1 155.1 407.4 152.9 405.3C152.9 405.3 152.9 405.2 152.8 405.2L147.3 399.7C142.4 395 138.6 391.8 135.4 389.5C134.5 388.9 133.6 388.3 132.8 387.8C128 384.9 125.1 384.5 122.5 384.4H121.9C121.7 384.4 121.4 384.3 121.1 384.3C120.8 384.3 120.5 384.3 120.2 384.2H119.8C119.3 384.2 118.8 384.1 118.2 384.1H118L123.7 378.4L122.8 377.5L116.5 371.2L105.2 382.5L104.8 382.9C104.2 382.8 104.5 382.9 104.1 382.8C102.5 383.9 100.2 383.7 98.6999 382.3L91.3999 374.9C89.6999 373.2 89.6999 370.6 91.3999 368.9L102.5 357.7L97.8999 353.1H100.2V350.7H102.6V348.4H105V346H107.4V343.6H109.8V341.3L112.2 343.6C113.2 344.6 114.5 346 114.7 346C114.9 346 116.5 350.8 117.3 353.1L122.6 358.4C122.7 358.5 122.8 358.7 122.9 358.8L123 358.9L131.7 368.5L132.6 369.5L134.6 371.7L141.4 379.1L143.4 381.3L143.6 381.5C147.5 385.6 150.9 389.4 154 392.8C158.4 397.6 162 401.5 165.6 404.5C165.6 404.5 172.6 410.3 176.1 412.8C179.5 415.6 184.5 420 179.3 425.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.9 364.5C215.8 363.6 215.6 362.8 215.5 362C215.1 360 214.7 357.9 214.2 355.9C213.9 354.7 213.6 353.6 213.3 352.5C212.2 348.8 210.9 345.2 209.3 341.7C208.9 340.8 208.5 339.8 208 338.9C207.5 337.9 207.1 337 206.6 336C206.1 335.1 205.6 334.1 205.1 333.2C202.7 329.1 200 325.1 197 321.4C195.7 319.8 194.4 318.3 193 316.8C192 315.7 191 314.7 190 313.7C190 313.6 189.9 313.6 189.9 313.6C187.7 311.5 185.4 309.5 183 307.6C177.8 303.5 172.2 300 166.2 297.1C165.3 296.6 164.3 296.2 163.4 295.8C160.4 294.5 157.3 293.3 154.2 292.3C153.4 292 152.5 291.8 151.7 291.5C145.8 289.8 139.7 288.8 133.4 288.4C132.9 288.4 132.4 288.3 132 288.3H130.9C130.1 288.3 129.4 288.2 128.6 288.2H127.4C126 288.2 124.5 288.2 123.1 288.3C122 288.3 120.9 288.4 119.8 288.5C117.6 288.7 115.5 288.9 113.4 289.3C113 289.4 112.6 289.4 112.3 289.5C108.4 290.1 104.7 291 101 292.2C99.8999 292.5 98.7999 292.9 97.7999 293.3C97.6999 293.3 97.4999 293.4 97.3999 293.4C96.3999 293.8 95.3999 294.1 94.3999 294.6C61.2999 307.8 37.8999 340.1 37.8999 377.9C37.8999 427.4 77.9999 467.5 127.5 467.5C169 467.5 203.8 439.3 214.1 401.1C214.7 398.8 215.2 396.5 215.7 394.2V393.9C215.9 392.8 216.1 391.8 216.2 390.7C216.4 389.3 216.6 387.9 216.7 386.4C217 383.6 217.1 380.7 217.1 377.8C216.9 373.3 216.5 368.8 215.9 364.5ZM138.8 367.6C146.7 359.7 149.6 352.1 150.8 345.1C151.3 341.9 152.7 338.8 155.2 336.3C156.3 335.2 157.6 334.2 159 333.5C159.5 333.3 159.9 333 160.4 332.9C160.6 332.8 160.9 332.7 161.1 332.6C161.8 332.4 162.4 332.2 163.1 332.1C163.2 332.1 163.3 332.1 163.4 332C164 331.9 164.5 331.8 165.1 331.8H166.6L161.2 341.1C159.1 344.7 160.3 349.3 163.9 351.4C165.1 352.1 166.4 352.4 167.7 352.4C168.3 352.4 169 352.3 169.6 352.1L170.5 351.8C171.4 351.4 172.2 350.9 172.9 350.2C173.4 349.7 173.8 349.2 174.1 348.6L179.5 339.3C183.1 345.3 182.4 353.2 177.2 358.4C174.6 361 171.4 362.4 168.1 362.8C161.2 364 153.6 367 145.9 374.7L145.4 375.2L138.3 368.1L138.8 367.6ZM73.0999 332.6C81.6999 328.6 91.9999 323.6 94.1999 325.8L95.9999 327.6C96.8999 328.4 97.1999 328.8 97.1999 328.8L98.3999 330H95.9999V332.4H93.5999V334.8H91.1999V337.2H88.7999V339.6H86.3999V342H83.9999L81.1999 344.8L96.7999 360.4L90.2999 366.9L66.8999 343.5C65.4999 341.8 64.4999 336.7 73.0999 332.6ZM122.4 378.3L111.9 388.8L111.6 388.5L106 382.9L116.5 372.4L122.1 378L122.4 378.3ZM120.8 385.8C122.8 386 124.5 386.2 126 386.6C126.9 386.8 127.8 387.1 128.6 387.4L131 389.8L133.1 391.9L135.2 394C137.3 396 137.3 399.4 135.2 401.4C133.2 403.4 129.8 403.4 127.8 401.4L125.7 399.3L123.6 397.2L116.5 390.1L115.5 389L118.9 385.6H119C119.4 385.6 119.7 385.7 120.1 385.7C120.4 385.7 120.6 385.8 120.9 385.8H120.8ZM88.9999 440.1C84.9999 440.1 80.9999 438.6 77.9999 435.5C71.8999 429.4 71.8999 419.5 77.9999 413.5C80.4999 410.9 83.7999 409.5 87.0999 409.1C93.9999 407.9 101.5 404.9 109.3 397.2L112.8 393.8L119.9 400.9L116.4 404.4C108.5 412.3 105.6 419.9 104.4 426.9C103.9 430.1 102.5 433.2 99.9999 435.7C96.9999 438.6 92.9999 440.1 88.9999 440.1ZM179.3 425.3C174 430.5 169.6 425.5 167.1 422C165.2 419.4 161.6 414.9 159.8 412.7C159.2 411.9 158.8 411.5 158.8 411.5C156.8 409.1 155.1 407.4 152.9 405.3C152.9 405.3 152.9 405.2 152.8 405.2L147.3 399.7C142.4 395 138.6 391.8 135.4 389.5C134.5 388.9 133.6 388.3 132.8 387.8C128 384.9 125.1 384.5 122.5 384.4H121.9C121.7 384.4 121.4 384.3 121.1 384.3C120.8 384.3 120.5 384.3 120.2 384.2H119.8C119.3 384.2 118.8 384.1 118.2 384.1H118L123.7 378.4L122.8 377.5L116.5 371.2L105.2 382.5L104.8 382.9C104.2 382.8 104.5 382.9 104.1 382.8C102.5 383.9 100.2 383.7 98.6999 382.3L91.3999 374.9C89.6999 373.2 89.6999 370.6 91.3999 368.9L102.5 357.7L97.8999 353.1H100.2V350.7H102.6V348.4H105V346H107.4V343.6H109.8V341.3L112.2 343.6C113.2 344.6 114.5 346 114.7 346C114.9 346 116.5 350.8 117.3 353.1L122.6 358.4C122.7 358.5 122.8 358.7 122.9 358.8L123 358.9L131.7 368.5L132.6 369.5L134.6 371.7L141.4 379.1L143.4 381.3L143.6 381.5C147.5 385.6 150.9 389.4 154 392.8C158.4 397.6 162 401.5 165.6 404.5C165.6 404.5 172.6 410.3 176.1 412.8C179.5 415.6 184.5 420 179.3 425.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.1 418.1C171 419.2 171 420.9 172.1 422C173.2 423.1 174.9 423.1 176 422C177.1 420.9 177.1 419.2 176 418.1C175 417.1 173.2 417 172.1 418.1ZM99.0999 420.1L94.8999 418.4L92.9999 414.3L88.8999 416.1L84.6999 414.5L82.9999 418.7L78.8999 420.5L80.6999 424.6L79.0999 428.9L83.2999 430.5L85.0999 434.6L89.2999 432.8L93.4999 434.5L95.0999 430.3L99.2999 428.4L97.4999 424.3L99.0999 420.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.1 418.1C171 419.2 171 420.9 172.1 422C173.2 423.1 174.9 423.1 176 422C177.1 420.9 177.1 419.2 176 418.1C175 417.1 173.2 417 172.1 418.1ZM99.0999 420.1L94.8999 418.4L92.9999 414.3L88.8999 416.1L84.6999 414.5L82.9999 418.7L78.8999 420.5L80.6999 424.6L79.0999 428.9L83.2999 430.5L85.0999 434.6L89.2999 432.8L93.4999 434.5L95.0999 430.3L99.2999 428.4L97.4999 424.3L99.0999 420.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 218.4C77.7941 218.4 78.6 217.594 78.6 216.6C78.6 215.606 77.7941 214.8 76.8 214.8C75.8059 214.8 75 215.606 75 216.6C75 217.594 75.8059 218.4 76.8 218.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 218.4C77.7941 218.4 78.6 217.594 78.6 216.6C78.6 215.606 77.7941 214.8 76.8 214.8C75.8059 214.8 75 215.606 75 216.6C75 217.594 75.8059 218.4 76.8 218.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 227.3C77.7941 227.3 78.6 226.494 78.6 225.5C78.6 224.506 77.7941 223.7 76.8 223.7C75.8059 223.7 75 224.506 75 225.5C75 226.494 75.8059 227.3 76.8 227.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 227.3C77.7941 227.3 78.6 226.494 78.6 225.5C78.6 224.506 77.7941 223.7 76.8 223.7C75.8059 223.7 75 224.506 75 225.5C75 226.494 75.8059 227.3 76.8 227.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 236.2C77.7941 236.2 78.6 235.394 78.6 234.4C78.6 233.406 77.7941 232.6 76.8 232.6C75.8059 232.6 75 233.406 75 234.4C75 235.394 75.8059 236.2 76.8 236.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 236.2C77.7941 236.2 78.6 235.394 78.6 234.4C78.6 233.406 77.7941 232.6 76.8 232.6C75.8059 232.6 75 233.406 75 234.4C75 235.394 75.8059 236.2 76.8 236.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 245.1C77.7941 245.1 78.6 244.294 78.6 243.3C78.6 242.306 77.7941 241.5 76.8 241.5C75.8059 241.5 75 242.306 75 243.3C75 244.294 75.8059 245.1 76.8 245.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 245.1C77.7941 245.1 78.6 244.294 78.6 243.3C78.6 242.306 77.7941 241.5 76.8 241.5C75.8059 241.5 75 242.306 75 243.3C75 244.294 75.8059 245.1 76.8 245.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 254C77.7941 254 78.6 253.194 78.6 252.2C78.6 251.206 77.7941 250.4 76.8 250.4C75.8059 250.4 75 251.206 75 252.2C75 253.194 75.8059 254 76.8 254Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 254C77.7941 254 78.6 253.194 78.6 252.2C78.6 251.206 77.7941 250.4 76.8 250.4C75.8059 250.4 75 251.206 75 252.2C75 253.194 75.8059 254 76.8 254Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 262.9C77.7941 262.9 78.6 262.094 78.6 261.1C78.6 260.106 77.7941 259.3 76.8 259.3C75.8059 259.3 75 260.106 75 261.1C75 262.094 75.8059 262.9 76.8 262.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 262.9C77.7941 262.9 78.6 262.094 78.6 261.1C78.6 260.106 77.7941 259.3 76.8 259.3C75.8059 259.3 75 260.106 75 261.1C75 262.094 75.8059 262.9 76.8 262.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 271.9C77.7941 271.9 78.6 271.094 78.6 270.1C78.6 269.106 77.7941 268.3 76.8 268.3C75.8059 268.3 75 269.106 75 270.1C75 271.094 75.8059 271.9 76.8 271.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 271.9C77.7941 271.9 78.6 271.094 78.6 270.1C78.6 269.106 77.7941 268.3 76.8 268.3C75.8059 268.3 75 269.106 75 270.1C75 271.094 75.8059 271.9 76.8 271.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 280.8C77.7941 280.8 78.6 279.994 78.6 279C78.6 278.006 77.7941 277.2 76.8 277.2C75.8059 277.2 75 278.006 75 279C75 279.994 75.8059 280.8 76.8 280.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.8 280.8C77.7941 280.8 78.6 279.994 78.6 279C78.6 278.006 77.7941 277.2 76.8 277.2C75.8059 277.2 75 278.006 75 279C75 279.994 75.8059 280.8 76.8 280.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 222.8C82.194 222.8 82.9999 221.994 82.9999 221C82.9999 220.006 82.194 219.2 81.1999 219.2C80.2058 219.2 79.3999 220.006 79.3999 221C79.3999 221.994 80.2058 222.8 81.1999 222.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 222.8C82.194 222.8 82.9999 221.994 82.9999 221C82.9999 220.006 82.194 219.2 81.1999 219.2C80.2058 219.2 79.3999 220.006 79.3999 221C79.3999 221.994 80.2058 222.8 81.1999 222.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 231.7C82.194 231.7 82.9999 230.894 82.9999 229.9C82.9999 228.906 82.194 228.1 81.1999 228.1C80.2058 228.1 79.3999 228.906 79.3999 229.9C79.3999 230.894 80.2058 231.7 81.1999 231.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 231.7C82.194 231.7 82.9999 230.894 82.9999 229.9C82.9999 228.906 82.194 228.1 81.1999 228.1C80.2058 228.1 79.3999 228.906 79.3999 229.9C79.3999 230.894 80.2058 231.7 81.1999 231.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 240.7C82.194 240.7 82.9999 239.894 82.9999 238.9C82.9999 237.906 82.194 237.1 81.1999 237.1C80.2058 237.1 79.3999 237.906 79.3999 238.9C79.3999 239.894 80.2058 240.7 81.1999 240.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 240.7C82.194 240.7 82.9999 239.894 82.9999 238.9C82.9999 237.906 82.194 237.1 81.1999 237.1C80.2058 237.1 79.3999 237.906 79.3999 238.9C79.3999 239.894 80.2058 240.7 81.1999 240.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 249.6C82.194 249.6 82.9999 248.794 82.9999 247.8C82.9999 246.806 82.194 246 81.1999 246C80.2058 246 79.3999 246.806 79.3999 247.8C79.3999 248.794 80.2058 249.6 81.1999 249.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 249.6C82.194 249.6 82.9999 248.794 82.9999 247.8C82.9999 246.806 82.194 246 81.1999 246C80.2058 246 79.3999 246.806 79.3999 247.8C79.3999 248.794 80.2058 249.6 81.1999 249.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 258.4C82.194 258.4 82.9999 257.594 82.9999 256.6C82.9999 255.606 82.194 254.8 81.1999 254.8C80.2058 254.8 79.3999 255.606 79.3999 256.6C79.3999 257.594 80.2058 258.4 81.1999 258.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 258.4C82.194 258.4 82.9999 257.594 82.9999 256.6C82.9999 255.606 82.194 254.8 81.1999 254.8C80.2058 254.8 79.3999 255.606 79.3999 256.6C79.3999 257.594 80.2058 258.4 81.1999 258.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 267.3C82.194 267.3 82.9999 266.494 82.9999 265.5C82.9999 264.506 82.194 263.7 81.1999 263.7C80.2058 263.7 79.3999 264.506 79.3999 265.5C79.3999 266.494 80.2058 267.3 81.1999 267.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 267.3C82.194 267.3 82.9999 266.494 82.9999 265.5C82.9999 264.506 82.194 263.7 81.1999 263.7C80.2058 263.7 79.3999 264.506 79.3999 265.5C79.3999 266.494 80.2058 267.3 81.1999 267.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 276.3C82.194 276.3 82.9999 275.494 82.9999 274.5C82.9999 273.506 82.194 272.7 81.1999 272.7C80.2058 272.7 79.3999 273.506 79.3999 274.5C79.3999 275.494 80.2058 276.3 81.1999 276.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.1999 276.3C82.194 276.3 82.9999 275.494 82.9999 274.5C82.9999 273.506 82.194 272.7 81.1999 272.7C80.2058 272.7 79.3999 273.506 79.3999 274.5C79.3999 275.494 80.2058 276.3 81.1999 276.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 227.3C86.694 227.3 87.4999 226.494 87.4999 225.5C87.4999 224.506 86.694 223.7 85.6999 223.7C84.7058 223.7 83.8999 224.506 83.8999 225.5C83.8999 226.494 84.7058 227.3 85.6999 227.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 227.3C86.694 227.3 87.4999 226.494 87.4999 225.5C87.4999 224.506 86.694 223.7 85.6999 223.7C84.7058 223.7 83.8999 224.506 83.8999 225.5C83.8999 226.494 84.7058 227.3 85.6999 227.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 236.2C86.694 236.2 87.4999 235.394 87.4999 234.4C87.4999 233.406 86.694 232.6 85.6999 232.6C84.7058 232.6 83.8999 233.406 83.8999 234.4C83.8999 235.394 84.7058 236.2 85.6999 236.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 236.2C86.694 236.2 87.4999 235.394 87.4999 234.4C87.4999 233.406 86.694 232.6 85.6999 232.6C84.7058 232.6 83.8999 233.406 83.8999 234.4C83.8999 235.394 84.7058 236.2 85.6999 236.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 245.2C86.694 245.2 87.4999 244.394 87.4999 243.4C87.4999 242.406 86.694 241.6 85.6999 241.6C84.7058 241.6 83.8999 242.406 83.8999 243.4C83.8999 244.394 84.7058 245.2 85.6999 245.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 245.2C86.694 245.2 87.4999 244.394 87.4999 243.4C87.4999 242.406 86.694 241.6 85.6999 241.6C84.7058 241.6 83.8999 242.406 83.8999 243.4C83.8999 244.394 84.7058 245.2 85.6999 245.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 254.1C86.694 254.1 87.4999 253.294 87.4999 252.3C87.4999 251.306 86.694 250.5 85.6999 250.5C84.7058 250.5 83.8999 251.306 83.8999 252.3C83.8999 253.294 84.7058 254.1 85.6999 254.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 254.1C86.694 254.1 87.4999 253.294 87.4999 252.3C87.4999 251.306 86.694 250.5 85.6999 250.5C84.7058 250.5 83.8999 251.306 83.8999 252.3C83.8999 253.294 84.7058 254.1 85.6999 254.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 262.9C86.694 262.9 87.4999 262.094 87.4999 261.1C87.4999 260.106 86.694 259.3 85.6999 259.3C84.7058 259.3 83.8999 260.106 83.8999 261.1C83.8999 262.094 84.7058 262.9 85.6999 262.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 262.9C86.694 262.9 87.4999 262.094 87.4999 261.1C87.4999 260.106 86.694 259.3 85.6999 259.3C84.7058 259.3 83.8999 260.106 83.8999 261.1C83.8999 262.094 84.7058 262.9 85.6999 262.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 271.8C86.694 271.8 87.4999 270.994 87.4999 270C87.4999 269.006 86.694 268.2 85.6999 268.2C84.7058 268.2 83.8999 269.006 83.8999 270C83.8999 270.994 84.7058 271.8 85.6999 271.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 271.8C86.694 271.8 87.4999 270.994 87.4999 270C87.4999 269.006 86.694 268.2 85.6999 268.2C84.7058 268.2 83.8999 269.006 83.8999 270C83.8999 270.994 84.7058 271.8 85.6999 271.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 280.8C86.694 280.8 87.4999 279.994 87.4999 279C87.4999 278.006 86.694 277.2 85.6999 277.2C84.7058 277.2 83.8999 278.006 83.8999 279C83.8999 279.994 84.7058 280.8 85.6999 280.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6999 280.8C86.694 280.8 87.4999 279.994 87.4999 279C87.4999 278.006 86.694 277.2 85.6999 277.2C84.7058 277.2 83.8999 278.006 83.8999 279C83.8999 279.994 84.7058 280.8 85.6999 280.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 240.6C117.894 240.6 118.7 239.794 118.7 238.8C118.7 237.806 117.894 237 116.9 237C115.906 237 115.1 237.806 115.1 238.8C115.1 239.794 115.906 240.6 116.9 240.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 240.6C117.894 240.6 118.7 239.794 118.7 238.8C118.7 237.806 117.894 237 116.9 237C115.906 237 115.1 237.806 115.1 238.8C115.1 239.794 115.906 240.6 116.9 240.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 187C197.549 187 198.4 186.149 198.4 185.1C198.4 184.051 197.549 183.2 196.5 183.2C195.451 183.2 194.6 184.051 194.6 185.1C194.6 186.149 195.451 187 196.5 187Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 187C197.549 187 198.4 186.149 198.4 185.1C198.4 184.051 197.549 183.2 196.5 183.2C195.451 183.2 194.6 184.051 194.6 185.1C194.6 186.149 195.451 187 196.5 187Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 196.4C197.549 196.4 198.4 195.549 198.4 194.5C198.4 193.451 197.549 192.6 196.5 192.6C195.451 192.6 194.6 193.451 194.6 194.5C194.6 195.549 195.451 196.4 196.5 196.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 196.4C197.549 196.4 198.4 195.549 198.4 194.5C198.4 193.451 197.549 192.6 196.5 192.6C195.451 192.6 194.6 193.451 194.6 194.5C194.6 195.549 195.451 196.4 196.5 196.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 205.9C197.549 205.9 198.4 205.049 198.4 204C198.4 202.951 197.549 202.1 196.5 202.1C195.451 202.1 194.6 202.951 194.6 204C194.6 205.049 195.451 205.9 196.5 205.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 205.9C197.549 205.9 198.4 205.049 198.4 204C198.4 202.951 197.549 202.1 196.5 202.1C195.451 202.1 194.6 202.951 194.6 204C194.6 205.049 195.451 205.9 196.5 205.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 215.3C197.549 215.3 198.4 214.449 198.4 213.4C198.4 212.351 197.549 211.5 196.5 211.5C195.451 211.5 194.6 212.351 194.6 213.4C194.6 214.449 195.451 215.3 196.5 215.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 215.3C197.549 215.3 198.4 214.449 198.4 213.4C198.4 212.351 197.549 211.5 196.5 211.5C195.451 211.5 194.6 212.351 194.6 213.4C194.6 214.449 195.451 215.3 196.5 215.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 224.7C197.549 224.7 198.4 223.849 198.4 222.8C198.4 221.751 197.549 220.9 196.5 220.9C195.451 220.9 194.6 221.751 194.6 222.8C194.6 223.849 195.451 224.7 196.5 224.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 224.7C197.549 224.7 198.4 223.849 198.4 222.8C198.4 221.751 197.549 220.9 196.5 220.9C195.451 220.9 194.6 221.751 194.6 222.8C194.6 223.849 195.451 224.7 196.5 224.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 234.1C197.549 234.1 198.4 233.249 198.4 232.2C198.4 231.151 197.549 230.3 196.5 230.3C195.451 230.3 194.6 231.151 194.6 232.2C194.6 233.249 195.451 234.1 196.5 234.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.5 234.1C197.549 234.1 198.4 233.249 198.4 232.2C198.4 231.151 197.549 230.3 196.5 230.3C195.451 230.3 194.6 231.151 194.6 232.2C194.6 233.249 195.451 234.1 196.5 234.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 191.7C202.349 191.7 203.2 190.849 203.2 189.8C203.2 188.751 202.349 187.9 201.3 187.9C200.251 187.9 199.4 188.751 199.4 189.8C199.4 190.849 200.251 191.7 201.3 191.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 191.7C202.349 191.7 203.2 190.849 203.2 189.8C203.2 188.751 202.349 187.9 201.3 187.9C200.251 187.9 199.4 188.751 199.4 189.8C199.4 190.849 200.251 191.7 201.3 191.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 201.2C202.349 201.2 203.2 200.349 203.2 199.3C203.2 198.251 202.349 197.4 201.3 197.4C200.251 197.4 199.4 198.251 199.4 199.3C199.4 200.349 200.251 201.2 201.3 201.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 201.2C202.349 201.2 203.2 200.349 203.2 199.3C203.2 198.251 202.349 197.4 201.3 197.4C200.251 197.4 199.4 198.251 199.4 199.3C199.4 200.349 200.251 201.2 201.3 201.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 210.7C202.349 210.7 203.2 209.849 203.2 208.8C203.2 207.751 202.349 206.9 201.3 206.9C200.251 206.9 199.4 207.751 199.4 208.8C199.4 209.849 200.251 210.7 201.3 210.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 210.7C202.349 210.7 203.2 209.849 203.2 208.8C203.2 207.751 202.349 206.9 201.3 206.9C200.251 206.9 199.4 207.751 199.4 208.8C199.4 209.849 200.251 210.7 201.3 210.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 220.1C202.349 220.1 203.2 219.249 203.2 218.2C203.2 217.151 202.349 216.3 201.3 216.3C200.251 216.3 199.4 217.151 199.4 218.2C199.4 219.249 200.251 220.1 201.3 220.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 220.1C202.349 220.1 203.2 219.249 203.2 218.2C203.2 217.151 202.349 216.3 201.3 216.3C200.251 216.3 199.4 217.151 199.4 218.2C199.4 219.249 200.251 220.1 201.3 220.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 229.5C202.349 229.5 203.2 228.649 203.2 227.6C203.2 226.551 202.349 225.7 201.3 225.7C200.251 225.7 199.4 226.551 199.4 227.6C199.4 228.649 200.251 229.5 201.3 229.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.3 229.5C202.349 229.5 203.2 228.649 203.2 227.6C203.2 226.551 202.349 225.7 201.3 225.7C200.251 225.7 199.4 226.551 199.4 227.6C199.4 228.649 200.251 229.5 201.3 229.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 196.4C206.949 196.4 207.8 195.549 207.8 194.5C207.8 193.451 206.949 192.6 205.9 192.6C204.851 192.6 204 193.451 204 194.5C204 195.549 204.851 196.4 205.9 196.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 196.4C206.949 196.4 207.8 195.549 207.8 194.5C207.8 193.451 206.949 192.6 205.9 192.6C204.851 192.6 204 193.451 204 194.5C204 195.549 204.851 196.4 205.9 196.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 205.8C206.949 205.8 207.8 204.949 207.8 203.9C207.8 202.851 206.949 202 205.9 202C204.851 202 204 202.851 204 203.9C204 204.949 204.851 205.8 205.9 205.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 205.8C206.949 205.8 207.8 204.949 207.8 203.9C207.8 202.851 206.949 202 205.9 202C204.851 202 204 202.851 204 203.9C204 204.949 204.851 205.8 205.9 205.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 215.3C206.949 215.3 207.8 214.449 207.8 213.4C207.8 212.351 206.949 211.5 205.9 211.5C204.851 211.5 204 212.351 204 213.4C204 214.449 204.851 215.3 205.9 215.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 215.3C206.949 215.3 207.8 214.449 207.8 213.4C207.8 212.351 206.949 211.5 205.9 211.5C204.851 211.5 204 212.351 204 213.4C204 214.449 204.851 215.3 205.9 215.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 224.7C206.949 224.7 207.8 223.849 207.8 222.8C207.8 221.751 206.949 220.9 205.9 220.9C204.851 220.9 204 221.751 204 222.8C204 223.849 204.851 224.7 205.9 224.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 224.7C206.949 224.7 207.8 223.849 207.8 222.8C207.8 221.751 206.949 220.9 205.9 220.9C204.851 220.9 204 221.751 204 222.8C204 223.849 204.851 224.7 205.9 224.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 234.1C206.949 234.1 207.8 233.249 207.8 232.2C207.8 231.151 206.949 230.3 205.9 230.3C204.851 230.3 204 231.151 204 232.2C204 233.249 204.851 234.1 205.9 234.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M205.9 234.1C206.949 234.1 207.8 233.249 207.8 232.2C207.8 231.151 206.949 230.3 205.9 230.3C204.851 230.3 204 231.151 204 232.2C204 233.249 204.851 234.1 205.9 234.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 201.2C211.749 201.2 212.6 200.349 212.6 199.3C212.6 198.251 211.749 197.4 210.7 197.4C209.65 197.4 208.8 198.251 208.8 199.3C208.8 200.349 209.65 201.2 210.7 201.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 201.2C211.749 201.2 212.6 200.349 212.6 199.3C212.6 198.251 211.749 197.4 210.7 197.4C209.65 197.4 208.8 198.251 208.8 199.3C208.8 200.349 209.65 201.2 210.7 201.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 210.6C211.749 210.6 212.6 209.749 212.6 208.7C212.6 207.651 211.749 206.8 210.7 206.8C209.65 206.8 208.8 207.651 208.8 208.7C208.8 209.749 209.65 210.6 210.7 210.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 210.6C211.749 210.6 212.6 209.749 212.6 208.7C212.6 207.651 211.749 206.8 210.7 206.8C209.65 206.8 208.8 207.651 208.8 208.7C208.8 209.749 209.65 210.6 210.7 210.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 220.1C211.749 220.1 212.6 219.249 212.6 218.2C212.6 217.151 211.749 216.3 210.7 216.3C209.65 216.3 208.8 217.151 208.8 218.2C208.8 219.249 209.65 220.1 210.7 220.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 220.1C211.749 220.1 212.6 219.249 212.6 218.2C212.6 217.151 211.749 216.3 210.7 216.3C209.65 216.3 208.8 217.151 208.8 218.2C208.8 219.249 209.65 220.1 210.7 220.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 229.5C211.749 229.5 212.6 228.649 212.6 227.6C212.6 226.551 211.749 225.7 210.7 225.7C209.65 225.7 208.8 226.551 208.8 227.6C208.8 228.649 209.65 229.5 210.7 229.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 229.5C211.749 229.5 212.6 228.649 212.6 227.6C212.6 226.551 211.749 225.7 210.7 225.7C209.65 225.7 208.8 226.551 208.8 227.6C208.8 228.649 209.65 229.5 210.7 229.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 238.9C211.749 238.9 212.6 238.049 212.6 237C212.6 235.951 211.749 235.1 210.7 235.1C209.65 235.1 208.8 235.951 208.8 237C208.8 238.049 209.65 238.9 210.7 238.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.7 238.9C211.749 238.9 212.6 238.049 212.6 237C212.6 235.951 211.749 235.1 210.7 235.1C209.65 235.1 208.8 235.951 208.8 237C208.8 238.049 209.65 238.9 210.7 238.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 205.8C216.349 205.8 217.2 204.949 217.2 203.9C217.2 202.851 216.349 202 215.3 202C214.251 202 213.4 202.851 213.4 203.9C213.4 204.949 214.251 205.8 215.3 205.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 205.8C216.349 205.8 217.2 204.949 217.2 203.9C217.2 202.851 216.349 202 215.3 202C214.251 202 213.4 202.851 213.4 203.9C213.4 204.949 214.251 205.8 215.3 205.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 215.2C216.349 215.2 217.2 214.349 217.2 213.3C217.2 212.251 216.349 211.4 215.3 211.4C214.251 211.4 213.4 212.251 213.4 213.3C213.4 214.349 214.251 215.2 215.3 215.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 215.2C216.349 215.2 217.2 214.349 217.2 213.3C217.2 212.251 216.349 211.4 215.3 211.4C214.251 211.4 213.4 212.251 213.4 213.3C213.4 214.349 214.251 215.2 215.3 215.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 224.7C216.349 224.7 217.2 223.849 217.2 222.8C217.2 221.751 216.349 220.9 215.3 220.9C214.251 220.9 213.4 221.751 213.4 222.8C213.4 223.849 214.251 224.7 215.3 224.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 224.7C216.349 224.7 217.2 223.849 217.2 222.8C217.2 221.751 216.349 220.9 215.3 220.9C214.251 220.9 213.4 221.751 213.4 222.8C213.4 223.849 214.251 224.7 215.3 224.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 234.2C216.349 234.2 217.2 233.349 217.2 232.3C217.2 231.251 216.349 230.4 215.3 230.4C214.251 230.4 213.4 231.251 213.4 232.3C213.4 233.349 214.251 234.2 215.3 234.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 234.2C216.349 234.2 217.2 233.349 217.2 232.3C217.2 231.251 216.349 230.4 215.3 230.4C214.251 230.4 213.4 231.251 213.4 232.3C213.4 233.349 214.251 234.2 215.3 234.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 243.6C216.349 243.6 217.2 242.749 217.2 241.7C217.2 240.651 216.349 239.8 215.3 239.8C214.251 239.8 213.4 240.651 213.4 241.7C213.4 242.749 214.251 243.6 215.3 243.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.3 243.6C216.349 243.6 217.2 242.749 217.2 241.7C217.2 240.651 216.349 239.8 215.3 239.8C214.251 239.8 213.4 240.651 213.4 241.7C213.4 242.749 214.251 243.6 215.3 243.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 201.1C221.049 201.1 221.9 200.249 221.9 199.2C221.9 198.151 221.049 197.3 220 197.3C218.951 197.3 218.1 198.151 218.1 199.2C218.1 200.249 218.951 201.1 220 201.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 201.1C221.049 201.1 221.9 200.249 221.9 199.2C221.9 198.151 221.049 197.3 220 197.3C218.951 197.3 218.1 198.151 218.1 199.2C218.1 200.249 218.951 201.1 220 201.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 210.5C221.049 210.5 221.9 209.649 221.9 208.6C221.9 207.551 221.049 206.7 220 206.7C218.951 206.7 218.1 207.551 218.1 208.6C218.1 209.649 218.951 210.5 220 210.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 210.5C221.049 210.5 221.9 209.649 221.9 208.6C221.9 207.551 221.049 206.7 220 206.7C218.951 206.7 218.1 207.551 218.1 208.6C218.1 209.649 218.951 210.5 220 210.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 220C221.049 220 221.9 219.149 221.9 218.1C221.9 217.051 221.049 216.2 220 216.2C218.951 216.2 218.1 217.051 218.1 218.1C218.1 219.149 218.951 220 220 220Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 220C221.049 220 221.9 219.149 221.9 218.1C221.9 217.051 221.049 216.2 220 216.2C218.951 216.2 218.1 217.051 218.1 218.1C218.1 219.149 218.951 220 220 220Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 229.4C221.049 229.4 221.9 228.549 221.9 227.5C221.9 226.451 221.049 225.6 220 225.6C218.951 225.6 218.1 226.451 218.1 227.5C218.1 228.549 218.951 229.4 220 229.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 229.4C221.049 229.4 221.9 228.549 221.9 227.5C221.9 226.451 221.049 225.6 220 225.6C218.951 225.6 218.1 226.451 218.1 227.5C218.1 228.549 218.951 229.4 220 229.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 238.8C221.049 238.8 221.9 237.949 221.9 236.9C221.9 235.851 221.049 235 220 235C218.951 235 218.1 235.851 218.1 236.9C218.1 237.949 218.951 238.8 220 238.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 238.8C221.049 238.8 221.9 237.949 221.9 236.9C221.9 235.851 221.049 235 220 235C218.951 235 218.1 235.851 218.1 236.9C218.1 237.949 218.951 238.8 220 238.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 248.2C221.049 248.2 221.9 247.349 221.9 246.3C221.9 245.251 221.049 244.4 220 244.4C218.951 244.4 218.1 245.251 218.1 246.3C218.1 247.349 218.951 248.2 220 248.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220 248.2C221.049 248.2 221.9 247.349 221.9 246.3C221.9 245.251 221.049 244.4 220 244.4C218.951 244.4 218.1 245.251 218.1 246.3C218.1 247.349 218.951 248.2 220 248.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 205.9C225.849 205.9 226.7 205.049 226.7 204C226.7 202.951 225.849 202.1 224.8 202.1C223.751 202.1 222.9 202.951 222.9 204C222.9 205.049 223.751 205.9 224.8 205.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 205.9C225.849 205.9 226.7 205.049 226.7 204C226.7 202.951 225.849 202.1 224.8 202.1C223.751 202.1 222.9 202.951 222.9 204C222.9 205.049 223.751 205.9 224.8 205.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 215.3C225.849 215.3 226.7 214.449 226.7 213.4C226.7 212.351 225.849 211.5 224.8 211.5C223.751 211.5 222.9 212.351 222.9 213.4C222.9 214.449 223.751 215.3 224.8 215.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 215.3C225.849 215.3 226.7 214.449 226.7 213.4C226.7 212.351 225.849 211.5 224.8 211.5C223.751 211.5 222.9 212.351 222.9 213.4C222.9 214.449 223.751 215.3 224.8 215.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 224.8C225.849 224.8 226.7 223.949 226.7 222.9C226.7 221.851 225.849 221 224.8 221C223.751 221 222.9 221.851 222.9 222.9C222.9 223.949 223.751 224.8 224.8 224.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 224.8C225.849 224.8 226.7 223.949 226.7 222.9C226.7 221.851 225.849 221 224.8 221C223.751 221 222.9 221.851 222.9 222.9C222.9 223.949 223.751 224.8 224.8 224.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 234.2C225.849 234.2 226.7 233.349 226.7 232.3C226.7 231.251 225.849 230.4 224.8 230.4C223.751 230.4 222.9 231.251 222.9 232.3C222.9 233.349 223.751 234.2 224.8 234.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 234.2C225.849 234.2 226.7 233.349 226.7 232.3C226.7 231.251 225.849 230.4 224.8 230.4C223.751 230.4 222.9 231.251 222.9 232.3C222.9 233.349 223.751 234.2 224.8 234.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 243.6C225.849 243.6 226.7 242.749 226.7 241.7C226.7 240.651 225.849 239.8 224.8 239.8C223.751 239.8 222.9 240.651 222.9 241.7C222.9 242.749 223.751 243.6 224.8 243.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.8 243.6C225.849 243.6 226.7 242.749 226.7 241.7C226.7 240.651 225.849 239.8 224.8 239.8C223.751 239.8 222.9 240.651 222.9 241.7C222.9 242.749 223.751 243.6 224.8 243.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 210.5C230.449 210.5 231.3 209.649 231.3 208.6C231.3 207.551 230.449 206.7 229.4 206.7C228.351 206.7 227.5 207.551 227.5 208.6C227.5 209.649 228.351 210.5 229.4 210.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 210.5C230.449 210.5 231.3 209.649 231.3 208.6C231.3 207.551 230.449 206.7 229.4 206.7C228.351 206.7 227.5 207.551 227.5 208.6C227.5 209.649 228.351 210.5 229.4 210.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 219.9C230.449 219.9 231.3 219.049 231.3 218C231.3 216.951 230.449 216.1 229.4 216.1C228.351 216.1 227.5 216.951 227.5 218C227.5 219.049 228.351 219.9 229.4 219.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 219.9C230.449 219.9 231.3 219.049 231.3 218C231.3 216.951 230.449 216.1 229.4 216.1C228.351 216.1 227.5 216.951 227.5 218C227.5 219.049 228.351 219.9 229.4 219.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 229.4C230.449 229.4 231.3 228.549 231.3 227.5C231.3 226.451 230.449 225.6 229.4 225.6C228.351 225.6 227.5 226.451 227.5 227.5C227.5 228.549 228.351 229.4 229.4 229.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 229.4C230.449 229.4 231.3 228.549 231.3 227.5C231.3 226.451 230.449 225.6 229.4 225.6C228.351 225.6 227.5 226.451 227.5 227.5C227.5 228.549 228.351 229.4 229.4 229.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 238.8C230.449 238.8 231.3 237.949 231.3 236.9C231.3 235.851 230.449 235 229.4 235C228.351 235 227.5 235.851 227.5 236.9C227.5 237.949 228.351 238.8 229.4 238.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 238.8C230.449 238.8 231.3 237.949 231.3 236.9C231.3 235.851 230.449 235 229.4 235C228.351 235 227.5 235.851 227.5 236.9C227.5 237.949 228.351 238.8 229.4 238.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 248.2C230.449 248.2 231.3 247.349 231.3 246.3C231.3 245.251 230.449 244.4 229.4 244.4C228.351 244.4 227.5 245.251 227.5 246.3C227.5 247.349 228.351 248.2 229.4 248.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.4 248.2C230.449 248.2 231.3 247.349 231.3 246.3C231.3 245.251 230.449 244.4 229.4 244.4C228.351 244.4 227.5 245.251 227.5 246.3C227.5 247.349 228.351 248.2 229.4 248.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 215.3C235.249 215.3 236.1 214.449 236.1 213.4C236.1 212.351 235.249 211.5 234.2 211.5C233.15 211.5 232.3 212.351 232.3 213.4C232.3 214.449 233.15 215.3 234.2 215.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 215.3C235.249 215.3 236.1 214.449 236.1 213.4C236.1 212.351 235.249 211.5 234.2 211.5C233.15 211.5 232.3 212.351 232.3 213.4C232.3 214.449 233.15 215.3 234.2 215.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 224.7C235.249 224.7 236.1 223.849 236.1 222.8C236.1 221.751 235.249 220.9 234.2 220.9C233.15 220.9 232.3 221.751 232.3 222.8C232.3 223.849 233.15 224.7 234.2 224.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 224.7C235.249 224.7 236.1 223.849 236.1 222.8C236.1 221.751 235.249 220.9 234.2 220.9C233.15 220.9 232.3 221.751 232.3 222.8C232.3 223.849 233.15 224.7 234.2 224.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 234.2C235.249 234.2 236.1 233.349 236.1 232.3C236.1 231.251 235.249 230.4 234.2 230.4C233.15 230.4 232.3 231.251 232.3 232.3C232.3 233.349 233.15 234.2 234.2 234.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 234.2C235.249 234.2 236.1 233.349 236.1 232.3C236.1 231.251 235.249 230.4 234.2 230.4C233.15 230.4 232.3 231.251 232.3 232.3C232.3 233.349 233.15 234.2 234.2 234.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 243.6C235.249 243.6 236.1 242.749 236.1 241.7C236.1 240.651 235.249 239.8 234.2 239.8C233.15 239.8 232.3 240.651 232.3 241.7C232.3 242.749 233.15 243.6 234.2 243.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 243.6C235.249 243.6 236.1 242.749 236.1 241.7C236.1 240.651 235.249 239.8 234.2 239.8C233.15 239.8 232.3 240.651 232.3 241.7C232.3 242.749 233.15 243.6 234.2 243.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 253C235.249 253 236.1 252.149 236.1 251.1C236.1 250.051 235.249 249.2 234.2 249.2C233.15 249.2 232.3 250.051 232.3 251.1C232.3 252.149 233.15 253 234.2 253Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.2 253C235.249 253 236.1 252.149 236.1 251.1C236.1 250.051 235.249 249.2 234.2 249.2C233.15 249.2 232.3 250.051 232.3 251.1C232.3 252.149 233.15 253 234.2 253Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 220C239.949 220 240.8 219.149 240.8 218.1C240.8 217.051 239.949 216.2 238.9 216.2C237.851 216.2 237 217.051 237 218.1C237 219.149 237.851 220 238.9 220Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 220C239.949 220 240.8 219.149 240.8 218.1C240.8 217.051 239.949 216.2 238.9 216.2C237.851 216.2 237 217.051 237 218.1C237 219.149 237.851 220 238.9 220Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 229.5C239.949 229.5 240.8 228.649 240.8 227.6C240.8 226.551 239.949 225.7 238.9 225.7C237.851 225.7 237 226.551 237 227.6C237 228.649 237.851 229.5 238.9 229.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 229.5C239.949 229.5 240.8 228.649 240.8 227.6C240.8 226.551 239.949 225.7 238.9 225.7C237.851 225.7 237 226.551 237 227.6C237 228.649 237.851 229.5 238.9 229.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 238.9C239.949 238.9 240.8 238.049 240.8 237C240.8 235.951 239.949 235.1 238.9 235.1C237.851 235.1 237 235.951 237 237C237 238.049 237.851 238.9 238.9 238.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 238.9C239.949 238.9 240.8 238.049 240.8 237C240.8 235.951 239.949 235.1 238.9 235.1C237.851 235.1 237 235.951 237 237C237 238.049 237.851 238.9 238.9 238.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 248.3C239.949 248.3 240.8 247.449 240.8 246.4C240.8 245.351 239.949 244.5 238.9 244.5C237.851 244.5 237 245.351 237 246.4C237 247.449 237.851 248.3 238.9 248.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 248.3C239.949 248.3 240.8 247.449 240.8 246.4C240.8 245.351 239.949 244.5 238.9 244.5C237.851 244.5 237 245.351 237 246.4C237 247.449 237.851 248.3 238.9 248.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 257.7C239.949 257.7 240.8 256.849 240.8 255.8C240.8 254.751 239.949 253.9 238.9 253.9C237.851 253.9 237 254.751 237 255.8C237 256.849 237.851 257.7 238.9 257.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.9 257.7C239.949 257.7 240.8 256.849 240.8 255.8C240.8 254.751 239.949 253.9 238.9 253.9C237.851 253.9 237 254.751 237 255.8C237 256.849 237.851 257.7 238.9 257.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 215.4C244.749 215.4 245.6 214.549 245.6 213.5C245.6 212.451 244.749 211.6 243.7 211.6C242.65 211.6 241.8 212.451 241.8 213.5C241.8 214.549 242.65 215.4 243.7 215.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 215.4C244.749 215.4 245.6 214.549 245.6 213.5C245.6 212.451 244.749 211.6 243.7 211.6C242.65 211.6 241.8 212.451 241.8 213.5C241.8 214.549 242.65 215.4 243.7 215.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 224.8C244.749 224.8 245.6 223.949 245.6 222.9C245.6 221.851 244.749 221 243.7 221C242.65 221 241.8 221.851 241.8 222.9C241.8 223.949 242.65 224.8 243.7 224.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 224.8C244.749 224.8 245.6 223.949 245.6 222.9C245.6 221.851 244.749 221 243.7 221C242.65 221 241.8 221.851 241.8 222.9C241.8 223.949 242.65 224.8 243.7 224.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 234.3C244.749 234.3 245.6 233.449 245.6 232.4C245.6 231.351 244.749 230.5 243.7 230.5C242.65 230.5 241.8 231.351 241.8 232.4C241.8 233.449 242.65 234.3 243.7 234.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 234.3C244.749 234.3 245.6 233.449 245.6 232.4C245.6 231.351 244.749 230.5 243.7 230.5C242.65 230.5 241.8 231.351 241.8 232.4C241.8 233.449 242.65 234.3 243.7 234.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 243.7C244.749 243.7 245.6 242.849 245.6 241.8C245.6 240.751 244.749 239.9 243.7 239.9C242.65 239.9 241.8 240.751 241.8 241.8C241.8 242.849 242.65 243.7 243.7 243.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 243.7C244.749 243.7 245.6 242.849 245.6 241.8C245.6 240.751 244.749 239.9 243.7 239.9C242.65 239.9 241.8 240.751 241.8 241.8C241.8 242.849 242.65 243.7 243.7 243.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 253.1C244.749 253.1 245.6 252.249 245.6 251.2C245.6 250.151 244.749 249.3 243.7 249.3C242.65 249.3 241.8 250.151 241.8 251.2C241.8 252.249 242.65 253.1 243.7 253.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.7 253.1C244.749 253.1 245.6 252.249 245.6 251.2C245.6 250.151 244.749 249.3 243.7 249.3C242.65 249.3 241.8 250.151 241.8 251.2C241.8 252.249 242.65 253.1 243.7 253.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 261.5C196.449 261.5 197.3 260.649 197.3 259.6C197.3 258.551 196.449 257.7 195.4 257.7C194.351 257.7 193.5 258.551 193.5 259.6C193.5 260.649 194.351 261.5 195.4 261.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 261.5C196.449 261.5 197.3 260.649 197.3 259.6C197.3 258.551 196.449 257.7 195.4 257.7C194.351 257.7 193.5 258.551 193.5 259.6C193.5 260.649 194.351 261.5 195.4 261.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 270.9C196.449 270.9 197.3 270.049 197.3 269C197.3 267.951 196.449 267.1 195.4 267.1C194.351 267.1 193.5 267.951 193.5 269C193.5 270.049 194.351 270.9 195.4 270.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 270.9C196.449 270.9 197.3 270.049 197.3 269C197.3 267.951 196.449 267.1 195.4 267.1C194.351 267.1 193.5 267.951 193.5 269C193.5 270.049 194.351 270.9 195.4 270.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 280.4C196.449 280.4 197.3 279.549 197.3 278.5C197.3 277.451 196.449 276.6 195.4 276.6C194.351 276.6 193.5 277.451 193.5 278.5C193.5 279.549 194.351 280.4 195.4 280.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 280.4C196.449 280.4 197.3 279.549 197.3 278.5C197.3 277.451 196.449 276.6 195.4 276.6C194.351 276.6 193.5 277.451 193.5 278.5C193.5 279.549 194.351 280.4 195.4 280.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 289.8C196.449 289.8 197.3 288.949 197.3 287.9C197.3 286.851 196.449 286 195.4 286C194.351 286 193.5 286.851 193.5 287.9C193.5 288.949 194.351 289.8 195.4 289.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 289.8C196.449 289.8 197.3 288.949 197.3 287.9C197.3 286.851 196.449 286 195.4 286C194.351 286 193.5 286.851 193.5 287.9C193.5 288.949 194.351 289.8 195.4 289.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 266.3C201.249 266.3 202.1 265.449 202.1 264.4C202.1 263.351 201.249 262.5 200.2 262.5C199.15 262.5 198.3 263.351 198.3 264.4C198.3 265.449 199.15 266.3 200.2 266.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 266.3C201.249 266.3 202.1 265.449 202.1 264.4C202.1 263.351 201.249 262.5 200.2 262.5C199.15 262.5 198.3 263.351 198.3 264.4C198.3 265.449 199.15 266.3 200.2 266.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 275.7C201.249 275.7 202.1 274.849 202.1 273.8C202.1 272.751 201.249 271.9 200.2 271.9C199.15 271.9 198.3 272.751 198.3 273.8C198.3 274.849 199.15 275.7 200.2 275.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 275.7C201.249 275.7 202.1 274.849 202.1 273.8C202.1 272.751 201.249 271.9 200.2 271.9C199.15 271.9 198.3 272.751 198.3 273.8C198.3 274.849 199.15 275.7 200.2 275.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 285.2C201.249 285.2 202.1 284.349 202.1 283.3C202.1 282.251 201.249 281.4 200.2 281.4C199.15 281.4 198.3 282.251 198.3 283.3C198.3 284.349 199.15 285.2 200.2 285.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 285.2C201.249 285.2 202.1 284.349 202.1 283.3C202.1 282.251 201.249 281.4 200.2 281.4C199.15 281.4 198.3 282.251 198.3 283.3C198.3 284.349 199.15 285.2 200.2 285.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 294.6C201.249 294.6 202.1 293.749 202.1 292.7C202.1 291.651 201.249 290.8 200.2 290.8C199.15 290.8 198.3 291.651 198.3 292.7C198.3 293.749 199.15 294.6 200.2 294.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 294.6C201.249 294.6 202.1 293.749 202.1 292.7C202.1 291.651 201.249 290.8 200.2 290.8C199.15 290.8 198.3 291.651 198.3 292.7C198.3 293.749 199.15 294.6 200.2 294.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 271C205.849 271 206.7 270.149 206.7 269.1C206.7 268.051 205.849 267.2 204.8 267.2C203.751 267.2 202.9 268.051 202.9 269.1C202.9 270.149 203.751 271 204.8 271Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 271C205.849 271 206.7 270.149 206.7 269.1C206.7 268.051 205.849 267.2 204.8 267.2C203.751 267.2 202.9 268.051 202.9 269.1C202.9 270.149 203.751 271 204.8 271Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 280.4C205.849 280.4 206.7 279.549 206.7 278.5C206.7 277.451 205.849 276.6 204.8 276.6C203.751 276.6 202.9 277.451 202.9 278.5C202.9 279.549 203.751 280.4 204.8 280.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 280.4C205.849 280.4 206.7 279.549 206.7 278.5C206.7 277.451 205.849 276.6 204.8 276.6C203.751 276.6 202.9 277.451 202.9 278.5C202.9 279.549 203.751 280.4 204.8 280.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 289.9C205.849 289.9 206.7 289.049 206.7 288C206.7 286.951 205.849 286.1 204.8 286.1C203.751 286.1 202.9 286.951 202.9 288C202.9 289.049 203.751 289.9 204.8 289.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 289.9C205.849 289.9 206.7 289.049 206.7 288C206.7 286.951 205.849 286.1 204.8 286.1C203.751 286.1 202.9 286.951 202.9 288C202.9 289.049 203.751 289.9 204.8 289.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 299.3C205.849 299.3 206.7 298.449 206.7 297.4C206.7 296.351 205.849 295.5 204.8 295.5C203.751 295.5 202.9 296.351 202.9 297.4C202.9 298.449 203.751 299.3 204.8 299.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 299.3C205.849 299.3 206.7 298.449 206.7 297.4C206.7 296.351 205.849 295.5 204.8 295.5C203.751 295.5 202.9 296.351 202.9 297.4C202.9 298.449 203.751 299.3 204.8 299.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 275.7C210.65 275.7 211.5 274.849 211.5 273.8C211.5 272.751 210.65 271.9 209.6 271.9C208.551 271.9 207.7 272.751 207.7 273.8C207.7 274.849 208.551 275.7 209.6 275.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 275.7C210.65 275.7 211.5 274.849 211.5 273.8C211.5 272.751 210.65 271.9 209.6 271.9C208.551 271.9 207.7 272.751 207.7 273.8C207.7 274.849 208.551 275.7 209.6 275.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.9 261.6C205.949 261.6 206.8 260.749 206.8 259.7C206.8 258.651 205.949 257.8 204.9 257.8C203.851 257.8 203 258.651 203 259.7C203 260.749 203.851 261.6 204.9 261.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.9 261.6C205.949 261.6 206.8 260.749 206.8 259.7C206.8 258.651 205.949 257.8 204.9 257.8C203.851 257.8 203 258.651 203 259.7C203 260.749 203.851 261.6 204.9 261.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 266.3C210.65 266.3 211.5 265.449 211.5 264.4C211.5 263.351 210.65 262.5 209.6 262.5C208.551 262.5 207.7 263.351 207.7 264.4C207.7 265.449 208.551 266.3 209.6 266.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 266.3C210.65 266.3 211.5 265.449 211.5 264.4C211.5 263.351 210.65 262.5 209.6 262.5C208.551 262.5 207.7 263.351 207.7 264.4C207.7 265.449 208.551 266.3 209.6 266.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 271C215.349 271 216.2 270.149 216.2 269.1C216.2 268.051 215.349 267.2 214.3 267.2C213.251 267.2 212.4 268.051 212.4 269.1C212.4 270.149 213.251 271 214.3 271Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 271C215.349 271 216.2 270.149 216.2 269.1C216.2 268.051 215.349 267.2 214.3 267.2C213.251 267.2 212.4 268.051 212.4 269.1C212.4 270.149 213.251 271 214.3 271Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 285.1C210.65 285.1 211.5 284.249 211.5 283.2C211.5 282.151 210.65 281.3 209.6 281.3C208.551 281.3 207.7 282.151 207.7 283.2C207.7 284.249 208.551 285.1 209.6 285.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 285.1C210.65 285.1 211.5 284.249 211.5 283.2C211.5 282.151 210.65 281.3 209.6 281.3C208.551 281.3 207.7 282.151 207.7 283.2C207.7 284.249 208.551 285.1 209.6 285.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 294.6C210.65 294.6 211.5 293.749 211.5 292.7C211.5 291.651 210.65 290.8 209.6 290.8C208.551 290.8 207.7 291.651 207.7 292.7C207.7 293.749 208.551 294.6 209.6 294.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 294.6C210.65 294.6 211.5 293.749 211.5 292.7C211.5 291.651 210.65 290.8 209.6 290.8C208.551 290.8 207.7 291.651 207.7 292.7C207.7 293.749 208.551 294.6 209.6 294.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 304C210.65 304 211.5 303.149 211.5 302.1C211.5 301.051 210.65 300.2 209.6 300.2C208.551 300.2 207.7 301.051 207.7 302.1C207.7 303.149 208.551 304 209.6 304Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 304C210.65 304 211.5 303.149 211.5 302.1C211.5 301.051 210.65 300.2 209.6 300.2C208.551 300.2 207.7 301.051 207.7 302.1C207.7 303.149 208.551 304 209.6 304Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 280.4C215.249 280.4 216.1 279.549 216.1 278.5C216.1 277.451 215.249 276.6 214.2 276.6C213.15 276.6 212.3 277.451 212.3 278.5C212.3 279.549 213.15 280.4 214.2 280.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 280.4C215.249 280.4 216.1 279.549 216.1 278.5C216.1 277.451 215.249 276.6 214.2 276.6C213.15 276.6 212.3 277.451 212.3 278.5C212.3 279.549 213.15 280.4 214.2 280.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 289.8C215.249 289.8 216.1 288.949 216.1 287.9C216.1 286.851 215.249 286 214.2 286C213.15 286 212.3 286.851 212.3 287.9C212.3 288.949 213.15 289.8 214.2 289.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 289.8C215.249 289.8 216.1 288.949 216.1 287.9C216.1 286.851 215.249 286 214.2 286C213.15 286 212.3 286.851 212.3 287.9C212.3 288.949 213.15 289.8 214.2 289.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 299.3C215.249 299.3 216.1 298.449 216.1 297.4C216.1 296.351 215.249 295.5 214.2 295.5C213.15 295.5 212.3 296.351 212.3 297.4C212.3 298.449 213.15 299.3 214.2 299.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 299.3C215.249 299.3 216.1 298.449 216.1 297.4C216.1 296.351 215.249 295.5 214.2 295.5C213.15 295.5 212.3 296.351 212.3 297.4C212.3 298.449 213.15 299.3 214.2 299.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 308.7C215.249 308.7 216.1 307.849 216.1 306.8C216.1 305.751 215.249 304.9 214.2 304.9C213.15 304.9 212.3 305.751 212.3 306.8C212.3 307.849 213.15 308.7 214.2 308.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 308.7C215.249 308.7 216.1 307.849 216.1 306.8C216.1 305.751 215.249 304.9 214.2 304.9C213.15 304.9 212.3 305.751 212.3 306.8C212.3 307.849 213.15 308.7 214.2 308.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 275.7C219.949 275.7 220.8 274.849 220.8 273.8C220.8 272.751 219.949 271.9 218.9 271.9C217.851 271.9 217 272.751 217 273.8C217 274.849 217.851 275.7 218.9 275.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 275.7C219.949 275.7 220.8 274.849 220.8 273.8C220.8 272.751 219.949 271.9 218.9 271.9C217.851 271.9 217 272.751 217 273.8C217 274.849 217.851 275.7 218.9 275.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 285.1C219.949 285.1 220.8 284.249 220.8 283.2C220.8 282.151 219.949 281.3 218.9 281.3C217.851 281.3 217 282.151 217 283.2C217 284.249 217.851 285.1 218.9 285.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 285.1C219.949 285.1 220.8 284.249 220.8 283.2C220.8 282.151 219.949 281.3 218.9 281.3C217.851 281.3 217 282.151 217 283.2C217 284.249 217.851 285.1 218.9 285.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 294.6C219.949 294.6 220.8 293.749 220.8 292.7C220.8 291.651 219.949 290.8 218.9 290.8C217.851 290.8 217 291.651 217 292.7C217 293.749 217.851 294.6 218.9 294.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 294.6C219.949 294.6 220.8 293.749 220.8 292.7C220.8 291.651 219.949 290.8 218.9 290.8C217.851 290.8 217 291.651 217 292.7C217 293.749 217.851 294.6 218.9 294.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 304C219.949 304 220.8 303.149 220.8 302.1C220.8 301.051 219.949 300.2 218.9 300.2C217.851 300.2 217 301.051 217 302.1C217 303.149 217.851 304 218.9 304Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 304C219.949 304 220.8 303.149 220.8 302.1C220.8 301.051 219.949 300.2 218.9 300.2C217.851 300.2 217 301.051 217 302.1C217 303.149 217.851 304 218.9 304Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 313.4C219.949 313.4 220.8 312.549 220.8 311.5C220.8 310.451 219.949 309.6 218.9 309.6C217.851 309.6 217 310.451 217 311.5C217 312.549 217.851 313.4 218.9 313.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 313.4C219.949 313.4 220.8 312.549 220.8 311.5C220.8 310.451 219.949 309.6 218.9 309.6C217.851 309.6 217 310.451 217 311.5C217 312.549 217.851 313.4 218.9 313.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 280.4C224.749 280.4 225.6 279.549 225.6 278.5C225.6 277.451 224.749 276.6 223.7 276.6C222.65 276.6 221.8 277.451 221.8 278.5C221.8 279.549 222.65 280.4 223.7 280.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 280.4C224.749 280.4 225.6 279.549 225.6 278.5C225.6 277.451 224.749 276.6 223.7 276.6C222.65 276.6 221.8 277.451 221.8 278.5C221.8 279.549 222.65 280.4 223.7 280.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 289.8C224.749 289.8 225.6 288.949 225.6 287.9C225.6 286.851 224.749 286 223.7 286C222.65 286 221.8 286.851 221.8 287.9C221.8 288.949 222.65 289.8 223.7 289.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 289.8C224.749 289.8 225.6 288.949 225.6 287.9C225.6 286.851 224.749 286 223.7 286C222.65 286 221.8 286.851 221.8 287.9C221.8 288.949 222.65 289.8 223.7 289.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 299.3C224.749 299.3 225.6 298.449 225.6 297.4C225.6 296.351 224.749 295.5 223.7 295.5C222.65 295.5 221.8 296.351 221.8 297.4C221.8 298.449 222.65 299.3 223.7 299.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 299.3C224.749 299.3 225.6 298.449 225.6 297.4C225.6 296.351 224.749 295.5 223.7 295.5C222.65 295.5 221.8 296.351 221.8 297.4C221.8 298.449 222.65 299.3 223.7 299.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 308.7C224.749 308.7 225.6 307.849 225.6 306.8C225.6 305.751 224.749 304.9 223.7 304.9C222.65 304.9 221.8 305.751 221.8 306.8C221.8 307.849 222.65 308.7 223.7 308.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 308.7C224.749 308.7 225.6 307.849 225.6 306.8C225.6 305.751 224.749 304.9 223.7 304.9C222.65 304.9 221.8 305.751 221.8 306.8C221.8 307.849 222.65 308.7 223.7 308.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 318.1C224.749 318.1 225.6 317.249 225.6 316.2C225.6 315.151 224.749 314.3 223.7 314.3C222.65 314.3 221.8 315.151 221.8 316.2C221.8 317.249 222.65 318.1 223.7 318.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 318.1C224.749 318.1 225.6 317.249 225.6 316.2C225.6 315.151 224.749 314.3 223.7 314.3C222.65 314.3 221.8 315.151 221.8 316.2C221.8 317.249 222.65 318.1 223.7 318.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 285.1C229.349 285.1 230.2 284.249 230.2 283.2C230.2 282.151 229.349 281.3 228.3 281.3C227.251 281.3 226.4 282.151 226.4 283.2C226.4 284.249 227.251 285.1 228.3 285.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 285.1C229.349 285.1 230.2 284.249 230.2 283.2C230.2 282.151 229.349 281.3 228.3 281.3C227.251 281.3 226.4 282.151 226.4 283.2C226.4 284.249 227.251 285.1 228.3 285.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 294.5C229.349 294.5 230.2 293.649 230.2 292.6C230.2 291.551 229.349 290.7 228.3 290.7C227.251 290.7 226.4 291.551 226.4 292.6C226.4 293.649 227.251 294.5 228.3 294.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 294.5C229.349 294.5 230.2 293.649 230.2 292.6C230.2 291.551 229.349 290.7 228.3 290.7C227.251 290.7 226.4 291.551 226.4 292.6C226.4 293.649 227.251 294.5 228.3 294.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 304C229.349 304 230.2 303.149 230.2 302.1C230.2 301.051 229.349 300.2 228.3 300.2C227.251 300.2 226.4 301.051 226.4 302.1C226.4 303.149 227.251 304 228.3 304Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 304C229.349 304 230.2 303.149 230.2 302.1C230.2 301.051 229.349 300.2 228.3 300.2C227.251 300.2 226.4 301.051 226.4 302.1C226.4 303.149 227.251 304 228.3 304Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 313.4C229.349 313.4 230.2 312.549 230.2 311.5C230.2 310.451 229.349 309.6 228.3 309.6C227.251 309.6 226.4 310.451 226.4 311.5C226.4 312.549 227.251 313.4 228.3 313.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 313.4C229.349 313.4 230.2 312.549 230.2 311.5C230.2 310.451 229.349 309.6 228.3 309.6C227.251 309.6 226.4 310.451 226.4 311.5C226.4 312.549 227.251 313.4 228.3 313.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 322.8C229.349 322.8 230.2 321.949 230.2 320.9C230.2 319.851 229.349 319 228.3 319C227.251 319 226.4 319.851 226.4 320.9C226.4 321.949 227.251 322.8 228.3 322.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 322.8C229.349 322.8 230.2 321.949 230.2 320.9C230.2 319.851 229.349 319 228.3 319C227.251 319 226.4 319.851 226.4 320.9C226.4 321.949 227.251 322.8 228.3 322.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 289.8C234.15 289.8 235 288.949 235 287.9C235 286.851 234.15 286 233.1 286C232.051 286 231.2 286.851 231.2 287.9C231.2 288.949 232.051 289.8 233.1 289.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 289.8C234.15 289.8 235 288.949 235 287.9C235 286.851 234.15 286 233.1 286C232.051 286 231.2 286.851 231.2 287.9C231.2 288.949 232.051 289.8 233.1 289.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.5 275.8C229.549 275.8 230.4 274.949 230.4 273.9C230.4 272.851 229.549 272 228.5 272C227.451 272 226.6 272.851 226.6 273.9C226.6 274.949 227.451 275.8 228.5 275.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.5 275.8C229.549 275.8 230.4 274.949 230.4 273.9C230.4 272.851 229.549 272 228.5 272C227.451 272 226.6 272.851 226.6 273.9C226.6 274.949 227.451 275.8 228.5 275.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 280.5C234.15 280.5 235 279.649 235 278.6C235 277.551 234.15 276.7 233.1 276.7C232.051 276.7 231.2 277.551 231.2 278.6C231.2 279.649 232.051 280.5 233.1 280.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 280.5C234.15 280.5 235 279.649 235 278.6C235 277.551 234.15 276.7 233.1 276.7C232.051 276.7 231.2 277.551 231.2 278.6C231.2 279.649 232.051 280.5 233.1 280.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 285.2C238.949 285.2 239.8 284.349 239.8 283.3C239.8 282.251 238.949 281.4 237.9 281.4C236.851 281.4 236 282.251 236 283.3C236 284.349 236.851 285.2 237.9 285.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 285.2C238.949 285.2 239.8 284.349 239.8 283.3C239.8 282.251 238.949 281.4 237.9 281.4C236.851 281.4 236 282.251 236 283.3C236 284.349 236.851 285.2 237.9 285.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 299.2C234.15 299.2 235 298.349 235 297.3C235 296.251 234.15 295.4 233.1 295.4C232.051 295.4 231.2 296.251 231.2 297.3C231.2 298.349 232.051 299.2 233.1 299.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 299.2C234.15 299.2 235 298.349 235 297.3C235 296.251 234.15 295.4 233.1 295.4C232.051 295.4 231.2 296.251 231.2 297.3C231.2 298.349 232.051 299.2 233.1 299.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 308.7C234.15 308.7 235 307.849 235 306.8C235 305.751 234.15 304.9 233.1 304.9C232.051 304.9 231.2 305.751 231.2 306.8C231.2 307.849 232.051 308.7 233.1 308.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 308.7C234.15 308.7 235 307.849 235 306.8C235 305.751 234.15 304.9 233.1 304.9C232.051 304.9 231.2 305.751 231.2 306.8C231.2 307.849 232.051 308.7 233.1 308.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 318.1C234.15 318.1 235 317.249 235 316.2C235 315.151 234.15 314.3 233.1 314.3C232.051 314.3 231.2 315.151 231.2 316.2C231.2 317.249 232.051 318.1 233.1 318.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 318.1C234.15 318.1 235 317.249 235 316.2C235 315.151 234.15 314.3 233.1 314.3C232.051 314.3 231.2 315.151 231.2 316.2C231.2 317.249 232.051 318.1 233.1 318.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 327.5C234.15 327.5 235 326.649 235 325.6C235 324.551 234.15 323.7 233.1 323.7C232.051 323.7 231.2 324.551 231.2 325.6C231.2 326.649 232.051 327.5 233.1 327.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 327.5C234.15 327.5 235 326.649 235 325.6C235 324.551 234.15 323.7 233.1 323.7C232.051 323.7 231.2 324.551 231.2 325.6C231.2 326.649 232.051 327.5 233.1 327.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 294.6C238.849 294.6 239.7 293.749 239.7 292.7C239.7 291.651 238.849 290.8 237.8 290.8C236.751 290.8 235.9 291.651 235.9 292.7C235.9 293.749 236.751 294.6 237.8 294.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 294.6C238.849 294.6 239.7 293.749 239.7 292.7C239.7 291.651 238.849 290.8 237.8 290.8C236.751 290.8 235.9 291.651 235.9 292.7C235.9 293.749 236.751 294.6 237.8 294.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 304.1C238.849 304.1 239.7 303.249 239.7 302.2C239.7 301.151 238.849 300.3 237.8 300.3C236.751 300.3 235.9 301.151 235.9 302.2C235.9 303.249 236.751 304.1 237.8 304.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 304.1C238.849 304.1 239.7 303.249 239.7 302.2C239.7 301.151 238.849 300.3 237.8 300.3C236.751 300.3 235.9 301.151 235.9 302.2C235.9 303.249 236.751 304.1 237.8 304.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 313.5C238.849 313.5 239.7 312.649 239.7 311.6C239.7 310.551 238.849 309.7 237.8 309.7C236.751 309.7 235.9 310.551 235.9 311.6C235.9 312.649 236.751 313.5 237.8 313.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 313.5C238.849 313.5 239.7 312.649 239.7 311.6C239.7 310.551 238.849 309.7 237.8 309.7C236.751 309.7 235.9 310.551 235.9 311.6C235.9 312.649 236.751 313.5 237.8 313.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 322.9C238.849 322.9 239.7 322.049 239.7 321C239.7 319.951 238.849 319.1 237.8 319.1C236.751 319.1 235.9 319.951 235.9 321C235.9 322.049 236.751 322.9 237.8 322.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 322.9C238.849 322.9 239.7 322.049 239.7 321C239.7 319.951 238.849 319.1 237.8 319.1C236.751 319.1 235.9 319.951 235.9 321C235.9 322.049 236.751 322.9 237.8 322.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 299.3C196.449 299.3 197.3 298.449 197.3 297.4C197.3 296.351 196.449 295.5 195.4 295.5C194.351 295.5 193.5 296.351 193.5 297.4C193.5 298.449 194.351 299.3 195.4 299.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 299.3C196.449 299.3 197.3 298.449 197.3 297.4C197.3 296.351 196.449 295.5 195.4 295.5C194.351 295.5 193.5 296.351 193.5 297.4C193.5 298.449 194.351 299.3 195.4 299.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 308.7C196.449 308.7 197.3 307.849 197.3 306.8C197.3 305.751 196.449 304.9 195.4 304.9C194.351 304.9 193.5 305.751 193.5 306.8C193.5 307.849 194.351 308.7 195.4 308.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 308.7C196.449 308.7 197.3 307.849 197.3 306.8C197.3 305.751 196.449 304.9 195.4 304.9C194.351 304.9 193.5 305.751 193.5 306.8C193.5 307.849 194.351 308.7 195.4 308.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 304C201.249 304 202.1 303.149 202.1 302.1C202.1 301.051 201.249 300.2 200.2 300.2C199.15 300.2 198.3 301.051 198.3 302.1C198.3 303.149 199.15 304 200.2 304Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 304C201.249 304 202.1 303.149 202.1 302.1C202.1 301.051 201.249 300.2 200.2 300.2C199.15 300.2 198.3 301.051 198.3 302.1C198.3 303.149 199.15 304 200.2 304Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 313.4C201.249 313.4 202.1 312.549 202.1 311.5C202.1 310.451 201.249 309.6 200.2 309.6C199.15 309.6 198.3 310.451 198.3 311.5C198.3 312.549 199.15 313.4 200.2 313.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.2 313.4C201.249 313.4 202.1 312.549 202.1 311.5C202.1 310.451 201.249 309.6 200.2 309.6C199.15 309.6 198.3 310.451 198.3 311.5C198.3 312.549 199.15 313.4 200.2 313.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 308.7C205.849 308.7 206.7 307.849 206.7 306.8C206.7 305.751 205.849 304.9 204.8 304.9C203.751 304.9 202.9 305.751 202.9 306.8C202.9 307.849 203.751 308.7 204.8 308.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 308.7C205.849 308.7 206.7 307.849 206.7 306.8C206.7 305.751 205.849 304.9 204.8 304.9C203.751 304.9 202.9 305.751 202.9 306.8C202.9 307.849 203.751 308.7 204.8 308.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 318.1C205.849 318.1 206.7 317.249 206.7 316.2C206.7 315.151 205.849 314.3 204.8 314.3C203.751 314.3 202.9 315.151 202.9 316.2C202.9 317.249 203.751 318.1 204.8 318.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.8 318.1C205.849 318.1 206.7 317.249 206.7 316.2C206.7 315.151 205.849 314.3 204.8 314.3C203.751 314.3 202.9 315.151 202.9 316.2C202.9 317.249 203.751 318.1 204.8 318.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 313.5C210.65 313.5 211.5 312.649 211.5 311.6C211.5 310.551 210.65 309.7 209.6 309.7C208.551 309.7 207.7 310.551 207.7 311.6C207.7 312.649 208.551 313.5 209.6 313.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 313.5C210.65 313.5 211.5 312.649 211.5 311.6C211.5 310.551 210.65 309.7 209.6 309.7C208.551 309.7 207.7 310.551 207.7 311.6C207.7 312.649 208.551 313.5 209.6 313.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 322.9C210.65 322.9 211.5 322.049 211.5 321C211.5 319.951 210.65 319.1 209.6 319.1C208.551 319.1 207.7 319.951 207.7 321C207.7 322.049 208.551 322.9 209.6 322.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 322.9C210.65 322.9 211.5 322.049 211.5 321C211.5 319.951 210.65 319.1 209.6 319.1C208.551 319.1 207.7 319.951 207.7 321C207.7 322.049 208.551 322.9 209.6 322.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 318.1C215.249 318.1 216.1 317.249 216.1 316.2C216.1 315.151 215.249 314.3 214.2 314.3C213.15 314.3 212.3 315.151 212.3 316.2C212.3 317.249 213.15 318.1 214.2 318.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 318.1C215.249 318.1 216.1 317.249 216.1 316.2C216.1 315.151 215.249 314.3 214.2 314.3C213.15 314.3 212.3 315.151 212.3 316.2C212.3 317.249 213.15 318.1 214.2 318.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 327.5C215.249 327.5 216.1 326.649 216.1 325.6C216.1 324.551 215.249 323.7 214.2 323.7C213.15 323.7 212.3 324.551 212.3 325.6C212.3 326.649 213.15 327.5 214.2 327.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.2 327.5C215.249 327.5 216.1 326.649 216.1 325.6C216.1 324.551 215.249 323.7 214.2 323.7C213.15 323.7 212.3 324.551 212.3 325.6C212.3 326.649 213.15 327.5 214.2 327.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 322.8C219.949 322.8 220.8 321.949 220.8 320.9C220.8 319.851 219.949 319 218.9 319C217.851 319 217 319.851 217 320.9C217 321.949 217.851 322.8 218.9 322.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 322.8C219.949 322.8 220.8 321.949 220.8 320.9C220.8 319.851 219.949 319 218.9 319C217.851 319 217 319.851 217 320.9C217 321.949 217.851 322.8 218.9 322.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 332.2C219.949 332.2 220.8 331.349 220.8 330.3C220.8 329.251 219.949 328.4 218.9 328.4C217.851 328.4 217 329.251 217 330.3C217 331.349 217.851 332.2 218.9 332.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.9 332.2C219.949 332.2 220.8 331.349 220.8 330.3C220.8 329.251 219.949 328.4 218.9 328.4C217.851 328.4 217 329.251 217 330.3C217 331.349 217.851 332.2 218.9 332.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 327.6C224.749 327.6 225.6 326.749 225.6 325.7C225.6 324.651 224.749 323.8 223.7 323.8C222.65 323.8 221.8 324.651 221.8 325.7C221.8 326.749 222.65 327.6 223.7 327.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 327.6C224.749 327.6 225.6 326.749 225.6 325.7C225.6 324.651 224.749 323.8 223.7 323.8C222.65 323.8 221.8 324.651 221.8 325.7C221.8 326.749 222.65 327.6 223.7 327.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 337C224.749 337 225.6 336.149 225.6 335.1C225.6 334.051 224.749 333.2 223.7 333.2C222.65 333.2 221.8 334.051 221.8 335.1C221.8 336.149 222.65 337 223.7 337Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 337C224.749 337 225.6 336.149 225.6 335.1C225.6 334.051 224.749 333.2 223.7 333.2C222.65 333.2 221.8 334.051 221.8 335.1C221.8 336.149 222.65 337 223.7 337Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 332.2C229.349 332.2 230.2 331.349 230.2 330.3C230.2 329.251 229.349 328.4 228.3 328.4C227.251 328.4 226.4 329.251 226.4 330.3C226.4 331.349 227.251 332.2 228.3 332.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.3 332.2C229.349 332.2 230.2 331.349 230.2 330.3C230.2 329.251 229.349 328.4 228.3 328.4C227.251 328.4 226.4 329.251 226.4 330.3C226.4 331.349 227.251 332.2 228.3 332.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 337C234.15 337 235 336.149 235 335.1C235 334.051 234.15 333.2 233.1 333.2C232.051 333.2 231.2 334.051 231.2 335.1C231.2 336.149 232.051 337 233.1 337Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 337C234.15 337 235 336.149 235 335.1C235 334.051 234.15 333.2 233.1 333.2C232.051 333.2 231.2 334.051 231.2 335.1C231.2 336.149 232.051 337 233.1 337Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 341.7C238.849 341.7 239.7 340.849 239.7 339.8C239.7 338.751 238.849 337.9 237.8 337.9C236.751 337.9 235.9 338.751 235.9 339.8C235.9 340.849 236.751 341.7 237.8 341.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 341.7C238.849 341.7 239.7 340.849 239.7 339.8C239.7 338.751 238.849 337.9 237.8 337.9C236.751 337.9 235.9 338.751 235.9 339.8C235.9 340.849 236.751 341.7 237.8 341.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 332.3C238.849 332.3 239.7 331.449 239.7 330.4C239.7 329.351 238.849 328.5 237.8 328.5C236.751 328.5 235.9 329.351 235.9 330.4C235.9 331.449 236.751 332.3 237.8 332.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.8 332.3C238.849 332.3 239.7 331.449 239.7 330.4C239.7 329.351 238.849 328.5 237.8 328.5C236.751 328.5 235.9 329.351 235.9 330.4C235.9 331.449 236.751 332.3 237.8 332.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 289.9C243.65 289.9 244.5 289.049 244.5 288C244.5 286.951 243.65 286.1 242.6 286.1C241.551 286.1 240.7 286.951 240.7 288C240.7 289.049 241.551 289.9 242.6 289.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 289.9C243.65 289.9 244.5 289.049 244.5 288C244.5 286.951 243.65 286.1 242.6 286.1C241.551 286.1 240.7 286.951 240.7 288C240.7 289.049 241.551 289.9 242.6 289.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 299.3C243.65 299.3 244.5 298.449 244.5 297.4C244.5 296.351 243.65 295.5 242.6 295.5C241.551 295.5 240.7 296.351 240.7 297.4C240.7 298.449 241.551 299.3 242.6 299.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 299.3C243.65 299.3 244.5 298.449 244.5 297.4C244.5 296.351 243.65 295.5 242.6 295.5C241.551 295.5 240.7 296.351 240.7 297.4C240.7 298.449 241.551 299.3 242.6 299.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 308.8C243.65 308.8 244.5 307.949 244.5 306.9C244.5 305.851 243.65 305 242.6 305C241.551 305 240.7 305.851 240.7 306.9C240.7 307.949 241.551 308.8 242.6 308.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 308.8C243.65 308.8 244.5 307.949 244.5 306.9C244.5 305.851 243.65 305 242.6 305C241.551 305 240.7 305.851 240.7 306.9C240.7 307.949 241.551 308.8 242.6 308.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 318.2C243.65 318.2 244.5 317.349 244.5 316.3C244.5 315.251 243.65 314.4 242.6 314.4C241.551 314.4 240.7 315.251 240.7 316.3C240.7 317.349 241.551 318.2 242.6 318.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 318.2C243.65 318.2 244.5 317.349 244.5 316.3C244.5 315.251 243.65 314.4 242.6 314.4C241.551 314.4 240.7 315.251 240.7 316.3C240.7 317.349 241.551 318.2 242.6 318.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 327.6C243.65 327.6 244.5 326.749 244.5 325.7C244.5 324.651 243.65 323.8 242.6 323.8C241.551 323.8 240.7 324.651 240.7 325.7C240.7 326.749 241.551 327.6 242.6 327.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 327.6C243.65 327.6 244.5 326.749 244.5 325.7C244.5 324.651 243.65 323.8 242.6 323.8C241.551 323.8 240.7 324.651 240.7 325.7C240.7 326.749 241.551 327.6 242.6 327.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 337C243.65 337 244.5 336.149 244.5 335.1C244.5 334.051 243.65 333.2 242.6 333.2C241.551 333.2 240.7 334.051 240.7 335.1C240.7 336.149 241.551 337 242.6 337Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 337C243.65 337 244.5 336.149 244.5 335.1C244.5 334.051 243.65 333.2 242.6 333.2C241.551 333.2 240.7 334.051 240.7 335.1C240.7 336.149 241.551 337 242.6 337Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 346.4C243.65 346.4 244.5 345.549 244.5 344.5C244.5 343.451 243.65 342.6 242.6 342.6C241.551 342.6 240.7 343.451 240.7 344.5C240.7 345.549 241.551 346.4 242.6 346.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 346.4C243.65 346.4 244.5 345.549 244.5 344.5C244.5 343.451 243.65 342.6 242.6 342.6C241.551 342.6 240.7 343.451 240.7 344.5C240.7 345.549 241.551 346.4 242.6 346.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.9 337C205.949 337 206.8 336.149 206.8 335.1C206.8 334.051 205.949 333.2 204.9 333.2C203.851 333.2 203 334.051 203 335.1C203 336.149 203.851 337 204.9 337Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.9 337C205.949 337 206.8 336.149 206.8 335.1C206.8 334.051 205.949 333.2 204.9 333.2C203.851 333.2 203 334.051 203 335.1C203 336.149 203.851 337 204.9 337Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 341.7C210.65 341.7 211.5 340.849 211.5 339.8C211.5 338.751 210.65 337.9 209.6 337.9C208.551 337.9 207.7 338.751 207.7 339.8C207.7 340.849 208.551 341.7 209.6 341.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 341.7C210.65 341.7 211.5 340.849 211.5 339.8C211.5 338.751 210.65 337.9 209.6 337.9C208.551 337.9 207.7 338.751 207.7 339.8C207.7 340.849 208.551 341.7 209.6 341.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.9 327.6C205.949 327.6 206.8 326.749 206.8 325.7C206.8 324.651 205.949 323.8 204.9 323.8C203.851 323.8 203 324.651 203 325.7C203 326.749 203.851 327.6 204.9 327.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.9 327.6C205.949 327.6 206.8 326.749 206.8 325.7C206.8 324.651 205.949 323.8 204.9 323.8C203.851 323.8 203 324.651 203 325.7C203 326.749 203.851 327.6 204.9 327.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 332.2C210.65 332.2 211.5 331.349 211.5 330.3C211.5 329.251 210.65 328.4 209.6 328.4C208.551 328.4 207.7 329.251 207.7 330.3C207.7 331.349 208.551 332.2 209.6 332.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.6 332.2C210.65 332.2 211.5 331.349 211.5 330.3C211.5 329.251 210.65 328.4 209.6 328.4C208.551 328.4 207.7 329.251 207.7 330.3C207.7 331.349 208.551 332.2 209.6 332.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 318.2C196.449 318.2 197.3 317.349 197.3 316.3C197.3 315.251 196.449 314.4 195.4 314.4C194.351 314.4 193.5 315.251 193.5 316.3C193.5 317.349 194.351 318.2 195.4 318.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.4 318.2C196.449 318.2 197.3 317.349 197.3 316.3C197.3 315.251 196.449 314.4 195.4 314.4C194.351 314.4 193.5 315.251 193.5 316.3C193.5 317.349 194.351 318.2 195.4 318.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.1 322.9C201.15 322.9 202 322.049 202 321C202 319.951 201.15 319.1 200.1 319.1C199.051 319.1 198.2 319.951 198.2 321C198.2 322.049 199.051 322.9 200.1 322.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M200.1 322.9C201.15 322.9 202 322.049 202 321C202 319.951 201.15 319.1 200.1 319.1C199.051 319.1 198.2 319.951 198.2 321C198.2 322.049 199.051 322.9 200.1 322.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.4 337C215.449 337 216.3 336.149 216.3 335.1C216.3 334.051 215.449 333.2 214.4 333.2C213.351 333.2 212.5 334.051 212.5 335.1C212.5 336.149 213.351 337 214.4 337Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.4 337C215.449 337 216.3 336.149 216.3 335.1C216.3 334.051 215.449 333.2 214.4 333.2C213.351 333.2 212.5 334.051 212.5 335.1C212.5 336.149 213.351 337 214.4 337Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 346.4C215.349 346.4 216.2 345.549 216.2 344.5C216.2 343.451 215.349 342.6 214.3 342.6C213.251 342.6 212.4 343.451 212.4 344.5C212.4 345.549 213.251 346.4 214.3 346.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 346.4C215.349 346.4 216.2 345.549 216.2 344.5C216.2 343.451 215.349 342.6 214.3 342.6C213.251 342.6 212.4 343.451 212.4 344.5C212.4 345.549 213.251 346.4 214.3 346.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 355.8C215.349 355.8 216.2 354.949 216.2 353.9C216.2 352.851 215.349 352 214.3 352C213.251 352 212.4 352.851 212.4 353.9C212.4 354.949 213.251 355.8 214.3 355.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 355.8C215.349 355.8 216.2 354.949 216.2 353.9C216.2 352.851 215.349 352 214.3 352C213.251 352 212.4 352.851 212.4 353.9C212.4 354.949 213.251 355.8 214.3 355.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 365.3C215.349 365.3 216.2 364.449 216.2 363.4C216.2 362.351 215.349 361.5 214.3 361.5C213.251 361.5 212.4 362.351 212.4 363.4C212.4 364.449 213.251 365.3 214.3 365.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.3 365.3C215.349 365.3 216.2 364.449 216.2 363.4C216.2 362.351 215.349 361.5 214.3 361.5C213.251 361.5 212.4 362.351 212.4 363.4C212.4 364.449 213.251 365.3 214.3 365.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 341.7C220.049 341.7 220.9 340.849 220.9 339.8C220.9 338.751 220.049 337.9 219 337.9C217.951 337.9 217.1 338.751 217.1 339.8C217.1 340.849 217.951 341.7 219 341.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 341.7C220.049 341.7 220.9 340.849 220.9 339.8C220.9 338.751 220.049 337.9 219 337.9C217.951 337.9 217.1 338.751 217.1 339.8C217.1 340.849 217.951 341.7 219 341.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 351.1C220.049 351.1 220.9 350.249 220.9 349.2C220.9 348.151 220.049 347.3 219 347.3C217.951 347.3 217.1 348.151 217.1 349.2C217.1 350.249 217.951 351.1 219 351.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 351.1C220.049 351.1 220.9 350.249 220.9 349.2C220.9 348.151 220.049 347.3 219 347.3C217.951 347.3 217.1 348.151 217.1 349.2C217.1 350.249 217.951 351.1 219 351.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 360.6C220.049 360.6 220.9 359.749 220.9 358.7C220.9 357.651 220.049 356.8 219 356.8C217.951 356.8 217.1 357.651 217.1 358.7C217.1 359.749 217.951 360.6 219 360.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 360.6C220.049 360.6 220.9 359.749 220.9 358.7C220.9 357.651 220.049 356.8 219 356.8C217.951 356.8 217.1 357.651 217.1 358.7C217.1 359.749 217.951 360.6 219 360.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 370C220.049 370 220.9 369.149 220.9 368.1C220.9 367.051 220.049 366.2 219 366.2C217.951 366.2 217.1 367.051 217.1 368.1C217.1 369.149 217.951 370 219 370Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 370C220.049 370 220.9 369.149 220.9 368.1C220.9 367.051 220.049 366.2 219 366.2C217.951 366.2 217.1 367.051 217.1 368.1C217.1 369.149 217.951 370 219 370Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 379.4C220.049 379.4 220.9 378.549 220.9 377.5C220.9 376.451 220.049 375.6 219 375.6C217.951 375.6 217.1 376.451 217.1 377.5C217.1 378.549 217.951 379.4 219 379.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 379.4C220.049 379.4 220.9 378.549 220.9 377.5C220.9 376.451 220.049 375.6 219 375.6C217.951 375.6 217.1 376.451 217.1 377.5C217.1 378.549 217.951 379.4 219 379.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 388.8C220.049 388.8 220.9 387.949 220.9 386.9C220.9 385.851 220.049 385 219 385C217.951 385 217.1 385.851 217.1 386.9C217.1 387.949 217.951 388.8 219 388.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219 388.8C220.049 388.8 220.9 387.949 220.9 386.9C220.9 385.851 220.049 385 219 385C217.951 385 217.1 385.851 217.1 386.9C217.1 387.949 217.951 388.8 219 388.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 346.4C224.749 346.4 225.6 345.549 225.6 344.5C225.6 343.451 224.749 342.6 223.7 342.6C222.65 342.6 221.8 343.451 221.8 344.5C221.8 345.549 222.65 346.4 223.7 346.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 346.4C224.749 346.4 225.6 345.549 225.6 344.5C225.6 343.451 224.749 342.6 223.7 342.6C222.65 342.6 221.8 343.451 221.8 344.5C221.8 345.549 222.65 346.4 223.7 346.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 355.8C224.749 355.8 225.6 354.949 225.6 353.9C225.6 352.851 224.749 352 223.7 352C222.65 352 221.8 352.851 221.8 353.9C221.8 354.949 222.65 355.8 223.7 355.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 355.8C224.749 355.8 225.6 354.949 225.6 353.9C225.6 352.851 224.749 352 223.7 352C222.65 352 221.8 352.851 221.8 353.9C221.8 354.949 222.65 355.8 223.7 355.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 365.3C224.749 365.3 225.6 364.449 225.6 363.4C225.6 362.351 224.749 361.5 223.7 361.5C222.65 361.5 221.8 362.351 221.8 363.4C221.8 364.449 222.65 365.3 223.7 365.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 365.3C224.749 365.3 225.6 364.449 225.6 363.4C225.6 362.351 224.749 361.5 223.7 361.5C222.65 361.5 221.8 362.351 221.8 363.4C221.8 364.449 222.65 365.3 223.7 365.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 374.7C224.749 374.7 225.6 373.849 225.6 372.8C225.6 371.751 224.749 370.9 223.7 370.9C222.65 370.9 221.8 371.751 221.8 372.8C221.8 373.849 222.65 374.7 223.7 374.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 374.7C224.749 374.7 225.6 373.849 225.6 372.8C225.6 371.751 224.749 370.9 223.7 370.9C222.65 370.9 221.8 371.751 221.8 372.8C221.8 373.849 222.65 374.7 223.7 374.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 384.1C224.749 384.1 225.6 383.249 225.6 382.2C225.6 381.151 224.749 380.3 223.7 380.3C222.65 380.3 221.8 381.151 221.8 382.2C221.8 383.249 222.65 384.1 223.7 384.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 384.1C224.749 384.1 225.6 383.249 225.6 382.2C225.6 381.151 224.749 380.3 223.7 380.3C222.65 380.3 221.8 381.151 221.8 382.2C221.8 383.249 222.65 384.1 223.7 384.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 393.6C224.749 393.6 225.6 392.749 225.6 391.7C225.6 390.651 224.749 389.8 223.7 389.8C222.65 389.8 221.8 390.651 221.8 391.7C221.8 392.749 222.65 393.6 223.7 393.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.7 393.6C224.749 393.6 225.6 392.749 225.6 391.7C225.6 390.651 224.749 389.8 223.7 389.8C222.65 389.8 221.8 390.651 221.8 391.7C221.8 392.749 222.65 393.6 223.7 393.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 351.1C229.449 351.1 230.3 350.249 230.3 349.2C230.3 348.151 229.449 347.3 228.4 347.3C227.351 347.3 226.5 348.151 226.5 349.2C226.5 350.249 227.351 351.1 228.4 351.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 351.1C229.449 351.1 230.3 350.249 230.3 349.2C230.3 348.151 229.449 347.3 228.4 347.3C227.351 347.3 226.5 348.151 226.5 349.2C226.5 350.249 227.351 351.1 228.4 351.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 360.5C229.449 360.5 230.3 359.649 230.3 358.6C230.3 357.551 229.449 356.7 228.4 356.7C227.351 356.7 226.5 357.551 226.5 358.6C226.5 359.649 227.351 360.5 228.4 360.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 360.5C229.449 360.5 230.3 359.649 230.3 358.6C230.3 357.551 229.449 356.7 228.4 356.7C227.351 356.7 226.5 357.551 226.5 358.6C226.5 359.649 227.351 360.5 228.4 360.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 370C229.449 370 230.3 369.149 230.3 368.1C230.3 367.051 229.449 366.2 228.4 366.2C227.351 366.2 226.5 367.051 226.5 368.1C226.5 369.149 227.351 370 228.4 370Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 370C229.449 370 230.3 369.149 230.3 368.1C230.3 367.051 229.449 366.2 228.4 366.2C227.351 366.2 226.5 367.051 226.5 368.1C226.5 369.149 227.351 370 228.4 370Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 379.4C229.449 379.4 230.3 378.549 230.3 377.5C230.3 376.451 229.449 375.6 228.4 375.6C227.351 375.6 226.5 376.451 226.5 377.5C226.5 378.549 227.351 379.4 228.4 379.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 379.4C229.449 379.4 230.3 378.549 230.3 377.5C230.3 376.451 229.449 375.6 228.4 375.6C227.351 375.6 226.5 376.451 226.5 377.5C226.5 378.549 227.351 379.4 228.4 379.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 388.8C229.449 388.8 230.3 387.949 230.3 386.9C230.3 385.851 229.449 385 228.4 385C227.351 385 226.5 385.851 226.5 386.9C226.5 387.949 227.351 388.8 228.4 388.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.4 388.8C229.449 388.8 230.3 387.949 230.3 386.9C230.3 385.851 229.449 385 228.4 385C227.351 385 226.5 385.851 226.5 386.9C226.5 387.949 227.351 388.8 228.4 388.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 355.8C234.15 355.8 235 354.949 235 353.9C235 352.851 234.15 352 233.1 352C232.051 352 231.2 352.851 231.2 353.9C231.2 354.949 232.051 355.8 233.1 355.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 355.8C234.15 355.8 235 354.949 235 353.9C235 352.851 234.15 352 233.1 352C232.051 352 231.2 352.851 231.2 353.9C231.2 354.949 232.051 355.8 233.1 355.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.5 341.8C229.549 341.8 230.4 340.949 230.4 339.9C230.4 338.851 229.549 338 228.5 338C227.451 338 226.6 338.851 226.6 339.9C226.6 340.949 227.451 341.8 228.5 341.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.5 341.8C229.549 341.8 230.4 340.949 230.4 339.9C230.4 338.851 229.549 338 228.5 338C227.451 338 226.6 338.851 226.6 339.9C226.6 340.949 227.451 341.8 228.5 341.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.2 346.5C234.249 346.5 235.1 345.649 235.1 344.6C235.1 343.551 234.249 342.7 233.2 342.7C232.15 342.7 231.3 343.551 231.3 344.6C231.3 345.649 232.15 346.5 233.2 346.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.2 346.5C234.249 346.5 235.1 345.649 235.1 344.6C235.1 343.551 234.249 342.7 233.2 342.7C232.15 342.7 231.3 343.551 231.3 344.6C231.3 345.649 232.15 346.5 233.2 346.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 351.2C238.949 351.2 239.8 350.349 239.8 349.3C239.8 348.251 238.949 347.4 237.9 347.4C236.851 347.4 236 348.251 236 349.3C236 350.349 236.851 351.2 237.9 351.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 351.2C238.949 351.2 239.8 350.349 239.8 349.3C239.8 348.251 238.949 347.4 237.9 347.4C236.851 347.4 236 348.251 236 349.3C236 350.349 236.851 351.2 237.9 351.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 365.2C234.15 365.2 235 364.349 235 363.3C235 362.251 234.15 361.4 233.1 361.4C232.051 361.4 231.2 362.251 231.2 363.3C231.2 364.349 232.051 365.2 233.1 365.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 365.2C234.15 365.2 235 364.349 235 363.3C235 362.251 234.15 361.4 233.1 361.4C232.051 361.4 231.2 362.251 231.2 363.3C231.2 364.349 232.051 365.2 233.1 365.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 374.7C234.15 374.7 235 373.849 235 372.8C235 371.751 234.15 370.9 233.1 370.9C232.051 370.9 231.2 371.751 231.2 372.8C231.2 373.849 232.051 374.7 233.1 374.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 374.7C234.15 374.7 235 373.849 235 372.8C235 371.751 234.15 370.9 233.1 370.9C232.051 370.9 231.2 371.751 231.2 372.8C231.2 373.849 232.051 374.7 233.1 374.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 384.1C234.15 384.1 235 383.249 235 382.2C235 381.151 234.15 380.3 233.1 380.3C232.051 380.3 231.2 381.151 231.2 382.2C231.2 383.249 232.051 384.1 233.1 384.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 384.1C234.15 384.1 235 383.249 235 382.2C235 381.151 234.15 380.3 233.1 380.3C232.051 380.3 231.2 381.151 231.2 382.2C231.2 383.249 232.051 384.1 233.1 384.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 393.5C234.15 393.5 235 392.649 235 391.6C235 390.551 234.15 389.7 233.1 389.7C232.051 389.7 231.2 390.551 231.2 391.6C231.2 392.649 232.051 393.5 233.1 393.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.1 393.5C234.15 393.5 235 392.649 235 391.6C235 390.551 234.15 389.7 233.1 389.7C232.051 389.7 231.2 390.551 231.2 391.6C231.2 392.649 232.051 393.5 233.1 393.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 360.6C238.949 360.6 239.8 359.749 239.8 358.7C239.8 357.651 238.949 356.8 237.9 356.8C236.851 356.8 236 357.651 236 358.7C236 359.749 236.851 360.6 237.9 360.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 360.6C238.949 360.6 239.8 359.749 239.8 358.7C239.8 357.651 238.949 356.8 237.9 356.8C236.851 356.8 236 357.651 236 358.7C236 359.749 236.851 360.6 237.9 360.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 370.1C238.949 370.1 239.8 369.249 239.8 368.2C239.8 367.151 238.949 366.3 237.9 366.3C236.851 366.3 236 367.151 236 368.2C236 369.249 236.851 370.1 237.9 370.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 370.1C238.949 370.1 239.8 369.249 239.8 368.2C239.8 367.151 238.949 366.3 237.9 366.3C236.851 366.3 236 367.151 236 368.2C236 369.249 236.851 370.1 237.9 370.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 379.5C238.949 379.5 239.8 378.649 239.8 377.6C239.8 376.551 238.949 375.7 237.9 375.7C236.851 375.7 236 376.551 236 377.6C236 378.649 236.851 379.5 237.9 379.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 379.5C238.949 379.5 239.8 378.649 239.8 377.6C239.8 376.551 238.949 375.7 237.9 375.7C236.851 375.7 236 376.551 236 377.6C236 378.649 236.851 379.5 237.9 379.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 388.9C238.949 388.9 239.8 388.049 239.8 387C239.8 385.951 238.949 385.1 237.9 385.1C236.851 385.1 236 385.951 236 387C236 388.049 236.851 388.9 237.9 388.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 388.9C238.949 388.9 239.8 388.049 239.8 387C239.8 385.951 238.949 385.1 237.9 385.1C236.851 385.1 236 385.951 236 387C236 388.049 236.851 388.9 237.9 388.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 398.3C238.949 398.3 239.8 397.449 239.8 396.4C239.8 395.351 238.949 394.5 237.9 394.5C236.851 394.5 236 395.351 236 396.4C236 397.449 236.851 398.3 237.9 398.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.9 398.3C238.949 398.3 239.8 397.449 239.8 396.4C239.8 395.351 238.949 394.5 237.9 394.5C236.851 394.5 236 395.351 236 396.4C236 397.449 236.851 398.3 237.9 398.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 355.9C243.65 355.9 244.5 355.049 244.5 354C244.5 352.951 243.65 352.1 242.6 352.1C241.551 352.1 240.7 352.951 240.7 354C240.7 355.049 241.551 355.9 242.6 355.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 355.9C243.65 355.9 244.5 355.049 244.5 354C244.5 352.951 243.65 352.1 242.6 352.1C241.551 352.1 240.7 352.951 240.7 354C240.7 355.049 241.551 355.9 242.6 355.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 365.3C243.65 365.3 244.5 364.449 244.5 363.4C244.5 362.351 243.65 361.5 242.6 361.5C241.551 361.5 240.7 362.351 240.7 363.4C240.7 364.449 241.551 365.3 242.6 365.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 365.3C243.65 365.3 244.5 364.449 244.5 363.4C244.5 362.351 243.65 361.5 242.6 361.5C241.551 361.5 240.7 362.351 240.7 363.4C240.7 364.449 241.551 365.3 242.6 365.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 374.8C243.65 374.8 244.5 373.949 244.5 372.9C244.5 371.851 243.65 371 242.6 371C241.551 371 240.7 371.851 240.7 372.9C240.7 373.949 241.551 374.8 242.6 374.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 374.8C243.65 374.8 244.5 373.949 244.5 372.9C244.5 371.851 243.65 371 242.6 371C241.551 371 240.7 371.851 240.7 372.9C240.7 373.949 241.551 374.8 242.6 374.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 384.2C243.65 384.2 244.5 383.349 244.5 382.3C244.5 381.251 243.65 380.4 242.6 380.4C241.551 380.4 240.7 381.251 240.7 382.3C240.7 383.349 241.551 384.2 242.6 384.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 384.2C243.65 384.2 244.5 383.349 244.5 382.3C244.5 381.251 243.65 380.4 242.6 380.4C241.551 380.4 240.7 381.251 240.7 382.3C240.7 383.349 241.551 384.2 242.6 384.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 393.6C243.65 393.6 244.5 392.749 244.5 391.7C244.5 390.651 243.65 389.8 242.6 389.8C241.551 389.8 240.7 390.651 240.7 391.7C240.7 392.749 241.551 393.6 242.6 393.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 393.6C243.65 393.6 244.5 392.749 244.5 391.7C244.5 390.651 243.65 389.8 242.6 389.8C241.551 389.8 240.7 390.651 240.7 391.7C240.7 392.749 241.551 393.6 242.6 393.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 403C243.65 403 244.5 402.149 244.5 401.1C244.5 400.051 243.65 399.2 242.6 399.2C241.551 399.2 240.7 400.051 240.7 401.1C240.7 402.149 241.551 403 242.6 403Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M242.6 403C243.65 403 244.5 402.149 244.5 401.1C244.5 400.051 243.65 399.2 242.6 399.2C241.551 399.2 240.7 400.051 240.7 401.1C240.7 402.149 241.551 403 242.6 403Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 249.5C117.894 249.5 118.7 248.694 118.7 247.7C118.7 246.706 117.894 245.9 116.9 245.9C115.906 245.9 115.1 246.706 115.1 247.7C115.1 248.694 115.906 249.5 116.9 249.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 249.5C117.894 249.5 118.7 248.694 118.7 247.7C118.7 246.706 117.894 245.9 116.9 245.9C115.906 245.9 115.1 246.706 115.1 247.7C115.1 248.694 115.906 249.5 116.9 249.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 258.5C117.894 258.5 118.7 257.694 118.7 256.7C118.7 255.706 117.894 254.9 116.9 254.9C115.906 254.9 115.1 255.706 115.1 256.7C115.1 257.694 115.906 258.5 116.9 258.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 258.5C117.894 258.5 118.7 257.694 118.7 256.7C118.7 255.706 117.894 254.9 116.9 254.9C115.906 254.9 115.1 255.706 115.1 256.7C115.1 257.694 115.906 258.5 116.9 258.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 267.4C117.894 267.4 118.7 266.594 118.7 265.6C118.7 264.606 117.894 263.8 116.9 263.8C115.906 263.8 115.1 264.606 115.1 265.6C115.1 266.594 115.906 267.4 116.9 267.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 267.4C117.894 267.4 118.7 266.594 118.7 265.6C118.7 264.606 117.894 263.8 116.9 263.8C115.906 263.8 115.1 264.606 115.1 265.6C115.1 266.594 115.906 267.4 116.9 267.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 276.2C117.894 276.2 118.7 275.394 118.7 274.4C118.7 273.406 117.894 272.6 116.9 272.6C115.906 272.6 115.1 273.406 115.1 274.4C115.1 275.394 115.906 276.2 116.9 276.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 276.2C117.894 276.2 118.7 275.394 118.7 274.4C118.7 273.406 117.894 272.6 116.9 272.6C115.906 272.6 115.1 273.406 115.1 274.4C115.1 275.394 115.906 276.2 116.9 276.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 285.1C117.894 285.1 118.7 284.294 118.7 283.3C118.7 282.306 117.894 281.5 116.9 281.5C115.906 281.5 115.1 282.306 115.1 283.3C115.1 284.294 115.906 285.1 116.9 285.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.9 285.1C117.894 285.1 118.7 284.294 118.7 283.3C118.7 282.306 117.894 281.5 116.9 281.5C115.906 281.5 115.1 282.306 115.1 283.3C115.1 284.294 115.906 285.1 116.9 285.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 245.1C113.394 245.1 114.2 244.294 114.2 243.3C114.2 242.306 113.394 241.5 112.4 241.5C111.406 241.5 110.6 242.306 110.6 243.3C110.6 244.294 111.406 245.1 112.4 245.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 245.1C113.394 245.1 114.2 244.294 114.2 243.3C114.2 242.306 113.394 241.5 112.4 241.5C111.406 241.5 110.6 242.306 110.6 243.3C110.6 244.294 111.406 245.1 112.4 245.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 254C113.394 254 114.2 253.194 114.2 252.2C114.2 251.206 113.394 250.4 112.4 250.4C111.406 250.4 110.6 251.206 110.6 252.2C110.6 253.194 111.406 254 112.4 254Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 254C113.394 254 114.2 253.194 114.2 252.2C114.2 251.206 113.394 250.4 112.4 250.4C111.406 250.4 110.6 251.206 110.6 252.2C110.6 253.194 111.406 254 112.4 254Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 280.8C113.394 280.8 114.2 279.994 114.2 279C114.2 278.006 113.394 277.2 112.4 277.2C111.406 277.2 110.6 278.006 110.6 279C110.6 279.994 111.406 280.8 112.4 280.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 280.8C113.394 280.8 114.2 279.994 114.2 279C114.2 278.006 113.394 277.2 112.4 277.2C111.406 277.2 110.6 278.006 110.6 279C110.6 279.994 111.406 280.8 112.4 280.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 289.7C113.394 289.7 114.2 288.894 114.2 287.9C114.2 286.906 113.394 286.1 112.4 286.1C111.406 286.1 110.6 286.906 110.6 287.9C110.6 288.894 111.406 289.7 112.4 289.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.4 289.7C113.394 289.7 114.2 288.894 114.2 287.9C114.2 286.906 113.394 286.1 112.4 286.1C111.406 286.1 110.6 286.906 110.6 287.9C110.6 288.894 111.406 289.7 112.4 289.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 245C122.294 245 123.1 244.194 123.1 243.2C123.1 242.206 122.294 241.4 121.3 241.4C120.306 241.4 119.5 242.206 119.5 243.2C119.5 244.194 120.306 245 121.3 245Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 245C122.294 245 123.1 244.194 123.1 243.2C123.1 242.206 122.294 241.4 121.3 241.4C120.306 241.4 119.5 242.206 119.5 243.2C119.5 244.194 120.306 245 121.3 245Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 253.9C122.294 253.9 123.1 253.094 123.1 252.1C123.1 251.106 122.294 250.3 121.3 250.3C120.306 250.3 119.5 251.106 119.5 252.1C119.5 253.094 120.306 253.9 121.3 253.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 253.9C122.294 253.9 123.1 253.094 123.1 252.1C123.1 251.106 122.294 250.3 121.3 250.3C120.306 250.3 119.5 251.106 119.5 252.1C119.5 253.094 120.306 253.9 121.3 253.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 262.9C122.294 262.9 123.1 262.094 123.1 261.1C123.1 260.106 122.294 259.3 121.3 259.3C120.306 259.3 119.5 260.106 119.5 261.1C119.5 262.094 120.306 262.9 121.3 262.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 262.9C122.294 262.9 123.1 262.094 123.1 261.1C123.1 260.106 122.294 259.3 121.3 259.3C120.306 259.3 119.5 260.106 119.5 261.1C119.5 262.094 120.306 262.9 121.3 262.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 271.8C122.294 271.8 123.1 270.994 123.1 270C123.1 269.006 122.294 268.2 121.3 268.2C120.306 268.2 119.5 269.006 119.5 270C119.5 270.994 120.306 271.8 121.3 271.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 271.8C122.294 271.8 123.1 270.994 123.1 270C123.1 269.006 122.294 268.2 121.3 268.2C120.306 268.2 119.5 269.006 119.5 270C119.5 270.994 120.306 271.8 121.3 271.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 280.6C122.294 280.6 123.1 279.794 123.1 278.8C123.1 277.806 122.294 277 121.3 277C120.306 277 119.5 277.806 119.5 278.8C119.5 279.794 120.306 280.6 121.3 280.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 280.6C122.294 280.6 123.1 279.794 123.1 278.8C123.1 277.806 122.294 277 121.3 277C120.306 277 119.5 277.806 119.5 278.8C119.5 279.794 120.306 280.6 121.3 280.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 289.5C122.294 289.5 123.1 288.694 123.1 287.7C123.1 286.706 122.294 285.9 121.3 285.9C120.306 285.9 119.5 286.706 119.5 287.7C119.5 288.694 120.306 289.5 121.3 289.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.3 289.5C122.294 289.5 123.1 288.694 123.1 287.7C123.1 286.706 122.294 285.9 121.3 285.9C120.306 285.9 119.5 286.706 119.5 287.7C119.5 288.694 120.306 289.5 121.3 289.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 249.5C126.794 249.5 127.6 248.694 127.6 247.7C127.6 246.706 126.794 245.9 125.8 245.9C124.806 245.9 124 246.706 124 247.7C124 248.694 124.806 249.5 125.8 249.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 249.5C126.794 249.5 127.6 248.694 127.6 247.7C127.6 246.706 126.794 245.9 125.8 245.9C124.806 245.9 124 246.706 124 247.7C124 248.694 124.806 249.5 125.8 249.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 258.4C126.794 258.4 127.6 257.594 127.6 256.6C127.6 255.606 126.794 254.8 125.8 254.8C124.806 254.8 124 255.606 124 256.6C124 257.594 124.806 258.4 125.8 258.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 258.4C126.794 258.4 127.6 257.594 127.6 256.6C127.6 255.606 126.794 254.8 125.8 254.8C124.806 254.8 124 255.606 124 256.6C124 257.594 124.806 258.4 125.8 258.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 267.4C126.794 267.4 127.6 266.594 127.6 265.6C127.6 264.606 126.794 263.8 125.8 263.8C124.806 263.8 124 264.606 124 265.6C124 266.594 124.806 267.4 125.8 267.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 267.4C126.794 267.4 127.6 266.594 127.6 265.6C127.6 264.606 126.794 263.8 125.8 263.8C124.806 263.8 124 264.606 124 265.6C124 266.594 124.806 267.4 125.8 267.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 276.3C126.794 276.3 127.6 275.494 127.6 274.5C127.6 273.506 126.794 272.7 125.8 272.7C124.806 272.7 124 273.506 124 274.5C124 275.494 124.806 276.3 125.8 276.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 276.3C126.794 276.3 127.6 275.494 127.6 274.5C127.6 273.506 126.794 272.7 125.8 272.7C124.806 272.7 124 273.506 124 274.5C124 275.494 124.806 276.3 125.8 276.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 285.1C126.794 285.1 127.6 284.294 127.6 283.3C127.6 282.306 126.794 281.5 125.8 281.5C124.806 281.5 124 282.306 124 283.3C124 284.294 124.806 285.1 125.8 285.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.8 285.1C126.794 285.1 127.6 284.294 127.6 283.3C127.6 282.306 126.794 281.5 125.8 281.5C124.806 281.5 124 282.306 124 283.3C124 284.294 124.806 285.1 125.8 285.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 231.7C91.0939 231.7 91.8998 230.894 91.8998 229.9C91.8998 228.906 91.0939 228.1 90.0998 228.1C89.1057 228.1 88.2998 228.906 88.2998 229.9C88.2998 230.894 89.1057 231.7 90.0998 231.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 231.7C91.0939 231.7 91.8998 230.894 91.8998 229.9C91.8998 228.906 91.0939 228.1 90.0998 228.1C89.1057 228.1 88.2998 228.906 88.2998 229.9C88.2998 230.894 89.1057 231.7 90.0998 231.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 240.6C91.0939 240.6 91.8998 239.794 91.8998 238.8C91.8998 237.806 91.0939 237 90.0998 237C89.1057 237 88.2998 237.806 88.2998 238.8C88.2998 239.794 89.1057 240.6 90.0998 240.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 240.6C91.0939 240.6 91.8998 239.794 91.8998 238.8C91.8998 237.806 91.0939 237 90.0998 237C89.1057 237 88.2998 237.806 88.2998 238.8C88.2998 239.794 89.1057 240.6 90.0998 240.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 249.6C91.0939 249.6 91.8998 248.794 91.8998 247.8C91.8998 246.806 91.0939 246 90.0998 246C89.1057 246 88.2998 246.806 88.2998 247.8C88.2998 248.794 89.1057 249.6 90.0998 249.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 249.6C91.0939 249.6 91.8998 248.794 91.8998 247.8C91.8998 246.806 91.0939 246 90.0998 246C89.1057 246 88.2998 246.806 88.2998 247.8C88.2998 248.794 89.1057 249.6 90.0998 249.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 276.3C91.0939 276.3 91.8998 275.494 91.8998 274.5C91.8998 273.506 91.0939 272.7 90.0998 272.7C89.1057 272.7 88.2998 273.506 88.2998 274.5C88.2998 275.494 89.1057 276.3 90.0998 276.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 276.3C91.0939 276.3 91.8998 275.494 91.8998 274.5C91.8998 273.506 91.0939 272.7 90.0998 272.7C89.1057 272.7 88.2998 273.506 88.2998 274.5C88.2998 275.494 89.1057 276.3 90.0998 276.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 285.2C91.0939 285.2 91.8998 284.394 91.8998 283.4C91.8998 282.406 91.0939 281.6 90.0998 281.6C89.1057 281.6 88.2998 282.406 88.2998 283.4C88.2998 284.394 89.1057 285.2 90.0998 285.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.0998 285.2C91.0939 285.2 91.8998 284.394 91.8998 283.4C91.8998 282.406 91.0939 281.6 90.0998 281.6C89.1057 281.6 88.2998 282.406 88.2998 283.4C88.2998 284.394 89.1057 285.2 90.0998 285.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 227.3C95.5939 227.3 96.3998 226.494 96.3998 225.5C96.3998 224.506 95.5939 223.7 94.5998 223.7C93.6057 223.7 92.7998 224.506 92.7998 225.5C92.7998 226.494 93.6057 227.3 94.5998 227.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 227.3C95.5939 227.3 96.3998 226.494 96.3998 225.5C96.3998 224.506 95.5939 223.7 94.5998 223.7C93.6057 223.7 92.7998 224.506 92.7998 225.5C92.7998 226.494 93.6057 227.3 94.5998 227.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 236.2C95.5939 236.2 96.3998 235.394 96.3998 234.4C96.3998 233.406 95.5939 232.6 94.5998 232.6C93.6057 232.6 92.7998 233.406 92.7998 234.4C92.7998 235.394 93.6057 236.2 94.5998 236.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 236.2C95.5939 236.2 96.3998 235.394 96.3998 234.4C96.3998 233.406 95.5939 232.6 94.5998 232.6C93.6057 232.6 92.7998 233.406 92.7998 234.4C92.7998 235.394 93.6057 236.2 94.5998 236.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 245.1C95.5939 245.1 96.3998 244.294 96.3998 243.3C96.3998 242.306 95.5939 241.5 94.5998 241.5C93.6057 241.5 92.7998 242.306 92.7998 243.3C92.7998 244.294 93.6057 245.1 94.5998 245.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 245.1C95.5939 245.1 96.3998 244.294 96.3998 243.3C96.3998 242.306 95.5939 241.5 94.5998 241.5C93.6057 241.5 92.7998 242.306 92.7998 243.3C92.7998 244.294 93.6057 245.1 94.5998 245.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 280.8C95.5939 280.8 96.3998 279.994 96.3998 279C96.3998 278.006 95.5939 277.2 94.5998 277.2C93.6057 277.2 92.7998 278.006 92.7998 279C92.7998 279.994 93.6057 280.8 94.5998 280.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 280.8C95.5939 280.8 96.3998 279.994 96.3998 279C96.3998 278.006 95.5939 277.2 94.5998 277.2C93.6057 277.2 92.7998 278.006 92.7998 279C92.7998 279.994 93.6057 280.8 94.5998 280.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 289.7C95.5939 289.7 96.3998 288.894 96.3998 287.9C96.3998 286.906 95.5939 286.1 94.5998 286.1C93.6057 286.1 92.7998 286.906 92.7998 287.9C92.7998 288.894 93.6057 289.7 94.5998 289.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.5998 289.7C95.5939 289.7 96.3998 288.894 96.3998 287.9C96.3998 286.906 95.5939 286.1 94.5998 286.1C93.6057 286.1 92.7998 286.906 92.7998 287.9C92.7998 288.894 93.6057 289.7 94.5998 289.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0002 231.7C99.9943 231.7 100.8 230.894 100.8 229.9C100.8 228.906 99.9943 228.1 99.0002 228.1C98.0061 228.1 97.2002 228.906 97.2002 229.9C97.2002 230.894 98.0061 231.7 99.0002 231.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0002 231.7C99.9943 231.7 100.8 230.894 100.8 229.9C100.8 228.906 99.9943 228.1 99.0002 228.1C98.0061 228.1 97.2002 228.906 97.2002 229.9C97.2002 230.894 98.0061 231.7 99.0002 231.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0002 240.6C99.9943 240.6 100.8 239.794 100.8 238.8C100.8 237.806 99.9943 237 99.0002 237C98.0061 237 97.2002 237.806 97.2002 238.8C97.2002 239.794 98.0061 240.6 99.0002 240.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0002 240.6C99.9943 240.6 100.8 239.794 100.8 238.8C100.8 237.806 99.9943 237 99.0002 237C98.0061 237 97.2002 237.806 97.2002 238.8C97.2002 239.794 98.0061 240.6 99.0002 240.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0002 285.2C99.9943 285.2 100.8 284.394 100.8 283.4C100.8 282.406 99.9943 281.6 99.0002 281.6C98.0061 281.6 97.2002 282.406 97.2002 283.4C97.2002 284.394 98.0061 285.2 99.0002 285.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.0002 285.2C99.9943 285.2 100.8 284.394 100.8 283.4C100.8 282.406 99.9943 281.6 99.0002 281.6C98.0061 281.6 97.2002 282.406 97.2002 283.4C97.2002 284.394 98.0061 285.2 99.0002 285.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 236.2C104.494 236.2 105.3 235.394 105.3 234.4C105.3 233.406 104.494 232.6 103.5 232.6C102.506 232.6 101.7 233.406 101.7 234.4C101.7 235.394 102.506 236.2 103.5 236.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 236.2C104.494 236.2 105.3 235.394 105.3 234.4C105.3 233.406 104.494 232.6 103.5 232.6C102.506 232.6 101.7 233.406 101.7 234.4C101.7 235.394 102.506 236.2 103.5 236.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 245.1C104.494 245.1 105.3 244.294 105.3 243.3C105.3 242.306 104.494 241.5 103.5 241.5C102.506 241.5 101.7 242.306 101.7 243.3C101.7 244.294 102.506 245.1 103.5 245.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 245.1C104.494 245.1 105.3 244.294 105.3 243.3C105.3 242.306 104.494 241.5 103.5 241.5C102.506 241.5 101.7 242.306 101.7 243.3C101.7 244.294 102.506 245.1 103.5 245.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 280.7C104.494 280.7 105.3 279.894 105.3 278.9C105.3 277.906 104.494 277.1 103.5 277.1C102.506 277.1 101.7 277.906 101.7 278.9C101.7 279.894 102.506 280.7 103.5 280.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 280.7C104.494 280.7 105.3 279.894 105.3 278.9C105.3 277.906 104.494 277.1 103.5 277.1C102.506 277.1 101.7 277.906 101.7 278.9C101.7 279.894 102.506 280.7 103.5 280.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 289.7C104.494 289.7 105.3 288.894 105.3 287.9C105.3 286.906 104.494 286.1 103.5 286.1C102.506 286.1 101.7 286.906 101.7 287.9C101.7 288.894 102.506 289.7 103.5 289.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.5 289.7C104.494 289.7 105.3 288.894 105.3 287.9C105.3 286.906 104.494 286.1 103.5 286.1C102.506 286.1 101.7 286.906 101.7 287.9C101.7 288.894 102.506 289.7 103.5 289.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.9 240.6C108.894 240.6 109.7 239.794 109.7 238.8C109.7 237.806 108.894 237 107.9 237C106.906 237 106.1 237.806 106.1 238.8C106.1 239.794 106.906 240.6 107.9 240.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.9 240.6C108.894 240.6 109.7 239.794 109.7 238.8C109.7 237.806 108.894 237 107.9 237C106.906 237 106.1 237.806 106.1 238.8C106.1 239.794 106.906 240.6 107.9 240.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M341.8 136.9C341.9 136.4 341.8 135.8 341.5 135.4C340.9 134.8 339.9 134.7 339 135.3L341.8 136.9ZM348.2 139.2C349 139.7 350.1 139.4 350.6 138.6C351 137.8 350.8 136.7 350 136.3C349.2 135.8 348.2 136.1 347.7 136.9C347.1 137.6 347.3 138.7 348.2 139.2ZM341.4 131.9C340.8 132.6 340.8 133.7 341.6 134.4C342.4 135.1 343.5 135 344 134.2C344.6 133.5 344.5 132.4 343.8 131.8C343.1 131.2 342.1 131.2 341.4 131.9ZM347.1 128.4C346.4 127.9 345.3 128 344.7 128.8C344.1 129.5 344.3 130.6 345.1 131.2C345.9 131.8 347 131.5 347.5 130.7C348 129.9 347.8 128.9 347.1 128.4ZM339.1 123.2C338.3 123.8 338.2 124.9 338.9 125.6C339.6 126.4 340.7 126.4 341.3 125.7C342 125 342 124 341.4 123.3C340.9 122.8 339.9 122.6 339.1 123.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M341.8 136.9C341.9 136.4 341.8 135.8 341.5 135.4C340.9 134.8 339.9 134.7 339 135.3L341.8 136.9ZM348.2 139.2C349 139.7 350.1 139.4 350.6 138.6C351 137.8 350.8 136.7 350 136.3C349.2 135.8 348.2 136.1 347.7 136.9C347.1 137.6 347.3 138.7 348.2 139.2ZM341.4 131.9C340.8 132.6 340.8 133.7 341.6 134.4C342.4 135.1 343.5 135 344 134.2C344.6 133.5 344.5 132.4 343.8 131.8C343.1 131.2 342.1 131.2 341.4 131.9ZM347.1 128.4C346.4 127.9 345.3 128 344.7 128.8C344.1 129.5 344.3 130.6 345.1 131.2C345.9 131.8 347 131.5 347.5 130.7C348 129.9 347.8 128.9 347.1 128.4ZM339.1 123.2C338.3 123.8 338.2 124.9 338.9 125.6C339.6 126.4 340.7 126.4 341.3 125.7C342 125 342 124 341.4 123.3C340.9 122.8 339.9 122.6 339.1 123.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453.3 107.3C453.3 90.5 426.9 77.4 393.3 77.4C359.6 77.4 333.3 90.5 333.3 107.3V131.9L334.1 132.4L336.3 133.7V134.1C336.4 134.1 336.6 134 336.7 133.9C337.2 133.6 337.6 132.9 337.5 132.4C337.5 131.8 337 131.1 336.3 130.9V127.9C336.3 128 336.3 128 336.4 128.1C336.9 129 338 129.2 338.8 128.7C339.6 128.2 339.8 127.1 339.4 126.4C339 125.7 338 125.3 337.1 125.7C336.7 125.9 336.5 126.1 336.3 126.5V122C337.1 121.8 337.6 121 337.5 120.3C337.5 119.7 337 119 336.3 118.8V116.8C341.8 125.2 354.7 132.1 372.1 135.3C378.9 136.6 386 137.2 393.3 137.2C420.3 137.2 442.5 128.8 450.3 116.8V120.8C449.6 120.6 448.9 120.9 448.5 121.5C448 122.2 448.2 123.2 448.9 123.8C449.3 124.1 449.8 124.2 450.3 124.1V125.5C449.9 125.6 449.5 125.9 449.3 126.3C448.9 127 449.1 128 449.9 128.6C450 128.7 450.2 128.8 450.4 128.8V132.9C449.7 132.7 449 133 448.6 133.6C448.1 134.3 448.3 135.3 449 135.9C449.4 136.2 449.9 136.3 450.4 136.2V137.6C450 137.7 449.6 138 449.4 138.4C449 139.1 449.2 140.1 450 140.7C450.1 140.8 450.3 140.9 450.5 140.9V145.1C449.8 144.9 449.1 145.2 448.7 145.8C448.2 146.5 448.4 147.5 449.1 148.1C449.5 148.4 450 148.5 450.5 148.4V149.8C450.1 149.9 449.7 150.2 449.5 150.6C449.1 151.3 449.3 152.3 450.1 152.9C450.2 153 450.4 153.1 450.6 153.1V157.2C449.9 157 449.2 157.3 448.8 157.9C448.3 158.6 448.5 159.6 449.2 160.2C449.6 160.5 450.1 160.6 450.6 160.5V161.9C450.2 162 449.8 162.3 449.6 162.7C449.2 163.4 449.4 164.4 450.2 165C450.3 165.1 450.5 165.2 450.7 165.2V169C450 168.8 449.3 169.1 448.9 169.7C448.4 170.4 448.6 171.4 449.3 172C449.7 172.3 450.2 172.4 450.7 172.3V173.7C450.3 173.8 449.9 174.1 449.7 174.5C449.3 175.2 449.5 176.2 450.3 176.8C450.4 176.9 450.6 177 450.8 177V181.9C450.1 181.7 449.4 182 449 182.6C448.5 183.3 448.7 184.3 449.4 184.9C449.8 185.2 450.3 185.3 450.8 185.2V186.6C450.4 186.7 450 187 449.8 187.4C449.4 188.1 449.6 189.1 450.4 189.7C450.5 189.8 450.7 189.9 450.9 189.9V194C450.2 193.8 449.5 194.1 449.1 194.7C448.6 195.4 448.8 196.4 449.5 197C449.9 197.3 450.4 197.4 450.9 197.3V198.7C450.5 198.8 450.1 199.1 449.9 199.5C449.5 200.2 449.7 201.2 450.5 201.8C450.6 201.9 450.8 202 451 202V206.1C450.3 205.9 449.6 206.2 449.2 206.8C448.7 207.5 448.9 208.5 449.6 209.1C450 209.4 450.5 209.5 451 209.4V210.8C450.6 210.9 450.2 211.2 450 211.6C449.6 212.3 449.8 213.3 450.6 213.9C450.7 214 450.9 214.1 451.1 214.1V218.2C450.4 218 449.7 218.3 449.3 218.9C448.8 219.6 449 220.6 449.7 221.2C450.1 221.5 450.6 221.6 451.1 221.5V222.9C450.7 223 450.3 223.3 450.1 223.7C449.7 224.4 449.9 225.4 450.7 226C450.8 226.1 451 226.2 451.2 226.2V230.3C450.5 230.1 449.8 230.4 449.4 231C448.9 231.7 449.1 232.7 449.8 233.3C450.2 233.6 450.7 233.7 451.2 233.6V235C450.8 235.1 450.4 235.4 450.2 235.8C449.8 236.5 450 237.5 450.8 238.1C450.9 238.2 451.1 238.3 451.3 238.3V242.4C450.6 242.2 449.9 242.5 449.5 243.1C449 243.8 449.2 244.8 449.9 245.4C450.3 245.7 450.8 245.8 451.3 245.7V247.1C450.9 247.2 450.5 247.5 450.3 247.9C449.9 248.6 450.1 249.6 450.9 250.2C451 250.3 451.2 250.4 451.4 250.4V254.5C451.4 254.5 451.3 254.5 451.3 254.4C450.5 253.9 449.5 254.2 449 254.9C448.5 255.6 448.7 256.6 449.4 257.2C450 257.7 450.8 257.7 451.4 257.2V259.2C450.6 259 449.7 259.3 449.4 260C449 260.7 449.2 261.7 450 262.3C450.3 262.5 450.7 262.6 451 262.6C447.6 275.9 423.5 286.2 394.4 286.2C382.4 286.2 371.3 284.4 362.1 281.5V284.7C371.4 287.6 382.4 289.3 394.4 289.3C421.4 289.3 443.6 280.9 451.4 268.9V289.1C451.4 291 451 292.8 450.2 294.5C449.4 296.3 448.3 298 446.9 299.6C446.7 299.7 446.5 300 446.3 300.2C443.5 303.1 439.6 305.8 434.8 308C434.7 308 434.6 308.1 434.6 308.1C427.1 311.6 417.4 314.2 406.7 315.3H406.4C402.5 315.7 398.5 315.9 394.4 315.9C390.3 315.9 386.3 315.7 382.4 315.3H382.1C378.5 314.9 374.9 314.3 371.6 313.7C368.3 313 365.1 312.2 362.1 311.2V314.4C367.7 316.2 373.9 317.4 380.6 318.2V325.9L381.2 326.5L393.5 333.5C393.5 333.6 393.9 333.6 394.2 333.6C394.5 333.6 394.9 333.6 394.9 333.5H395L407.3 326.5L408 325.7V318.2C415.7 317.3 422.7 315.8 428.9 313.6L434.5 316.8C434.6 316.9 435.3 316.9 435.3 316.9C435.4 316.9 435.8 316.9 435.9 316.8L448.3 309.8C448.3 309.8 448.5 309.5 448.7 309.3C448.9 309 449 308.8 449 308.7V301.6C450.7 299.8 452 297.8 452.8 295.7C453.7 293.6 454.2 291.5 454.2 289.3V259L453.3 107.3ZM393.2 134.2C386.1 134.2 379.1 133.6 372.5 132.3C350.8 128.3 336.2 118.2 336.2 107.3C336.2 92.5 361.8 80.4 393.2 80.4C424.6 80.4 450.2 92.5 450.2 107.3C450.3 122.2 424.7 134.2 393.2 134.2ZM391.7 329.4L382.4 324.1V318.2C385.4 318.5 388.5 318.7 391.7 318.7V329.4ZM404 324.1L394.7 329.4V318.7C397.9 318.7 401 318.5 404 318.2V324.1ZM432.7 312.6L431.6 312C432 311.8 432.4 311.7 432.7 311.5V312.6ZM445 307.3L435.7 312.6V310.1C439.3 308.3 442.4 306.3 445 304.1V307.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453.3 107.3C453.3 90.5 426.9 77.4 393.3 77.4C359.6 77.4 333.3 90.5 333.3 107.3V131.9L334.1 132.4L336.3 133.7V134.1C336.4 134.1 336.6 134 336.7 133.9C337.2 133.6 337.6 132.9 337.5 132.4C337.5 131.8 337 131.1 336.3 130.9V127.9C336.3 128 336.3 128 336.4 128.1C336.9 129 338 129.2 338.8 128.7C339.6 128.2 339.8 127.1 339.4 126.4C339 125.7 338 125.3 337.1 125.7C336.7 125.9 336.5 126.1 336.3 126.5V122C337.1 121.8 337.6 121 337.5 120.3C337.5 119.7 337 119 336.3 118.8V116.8C341.8 125.2 354.7 132.1 372.1 135.3C378.9 136.6 386 137.2 393.3 137.2C420.3 137.2 442.5 128.8 450.3 116.8V120.8C449.6 120.6 448.9 120.9 448.5 121.5C448 122.2 448.2 123.2 448.9 123.8C449.3 124.1 449.8 124.2 450.3 124.1V125.5C449.9 125.6 449.5 125.9 449.3 126.3C448.9 127 449.1 128 449.9 128.6C450 128.7 450.2 128.8 450.4 128.8V132.9C449.7 132.7 449 133 448.6 133.6C448.1 134.3 448.3 135.3 449 135.9C449.4 136.2 449.9 136.3 450.4 136.2V137.6C450 137.7 449.6 138 449.4 138.4C449 139.1 449.2 140.1 450 140.7C450.1 140.8 450.3 140.9 450.5 140.9V145.1C449.8 144.9 449.1 145.2 448.7 145.8C448.2 146.5 448.4 147.5 449.1 148.1C449.5 148.4 450 148.5 450.5 148.4V149.8C450.1 149.9 449.7 150.2 449.5 150.6C449.1 151.3 449.3 152.3 450.1 152.9C450.2 153 450.4 153.1 450.6 153.1V157.2C449.9 157 449.2 157.3 448.8 157.9C448.3 158.6 448.5 159.6 449.2 160.2C449.6 160.5 450.1 160.6 450.6 160.5V161.9C450.2 162 449.8 162.3 449.6 162.7C449.2 163.4 449.4 164.4 450.2 165C450.3 165.1 450.5 165.2 450.7 165.2V169C450 168.8 449.3 169.1 448.9 169.7C448.4 170.4 448.6 171.4 449.3 172C449.7 172.3 450.2 172.4 450.7 172.3V173.7C450.3 173.8 449.9 174.1 449.7 174.5C449.3 175.2 449.5 176.2 450.3 176.8C450.4 176.9 450.6 177 450.8 177V181.9C450.1 181.7 449.4 182 449 182.6C448.5 183.3 448.7 184.3 449.4 184.9C449.8 185.2 450.3 185.3 450.8 185.2V186.6C450.4 186.7 450 187 449.8 187.4C449.4 188.1 449.6 189.1 450.4 189.7C450.5 189.8 450.7 189.9 450.9 189.9V194C450.2 193.8 449.5 194.1 449.1 194.7C448.6 195.4 448.8 196.4 449.5 197C449.9 197.3 450.4 197.4 450.9 197.3V198.7C450.5 198.8 450.1 199.1 449.9 199.5C449.5 200.2 449.7 201.2 450.5 201.8C450.6 201.9 450.8 202 451 202V206.1C450.3 205.9 449.6 206.2 449.2 206.8C448.7 207.5 448.9 208.5 449.6 209.1C450 209.4 450.5 209.5 451 209.4V210.8C450.6 210.9 450.2 211.2 450 211.6C449.6 212.3 449.8 213.3 450.6 213.9C450.7 214 450.9 214.1 451.1 214.1V218.2C450.4 218 449.7 218.3 449.3 218.9C448.8 219.6 449 220.6 449.7 221.2C450.1 221.5 450.6 221.6 451.1 221.5V222.9C450.7 223 450.3 223.3 450.1 223.7C449.7 224.4 449.9 225.4 450.7 226C450.8 226.1 451 226.2 451.2 226.2V230.3C450.5 230.1 449.8 230.4 449.4 231C448.9 231.7 449.1 232.7 449.8 233.3C450.2 233.6 450.7 233.7 451.2 233.6V235C450.8 235.1 450.4 235.4 450.2 235.8C449.8 236.5 450 237.5 450.8 238.1C450.9 238.2 451.1 238.3 451.3 238.3V242.4C450.6 242.2 449.9 242.5 449.5 243.1C449 243.8 449.2 244.8 449.9 245.4C450.3 245.7 450.8 245.8 451.3 245.7V247.1C450.9 247.2 450.5 247.5 450.3 247.9C449.9 248.6 450.1 249.6 450.9 250.2C451 250.3 451.2 250.4 451.4 250.4V254.5C451.4 254.5 451.3 254.5 451.3 254.4C450.5 253.9 449.5 254.2 449 254.9C448.5 255.6 448.7 256.6 449.4 257.2C450 257.7 450.8 257.7 451.4 257.2V259.2C450.6 259 449.7 259.3 449.4 260C449 260.7 449.2 261.7 450 262.3C450.3 262.5 450.7 262.6 451 262.6C447.6 275.9 423.5 286.2 394.4 286.2C382.4 286.2 371.3 284.4 362.1 281.5V284.7C371.4 287.6 382.4 289.3 394.4 289.3C421.4 289.3 443.6 280.9 451.4 268.9V289.1C451.4 291 451 292.8 450.2 294.5C449.4 296.3 448.3 298 446.9 299.6C446.7 299.7 446.5 300 446.3 300.2C443.5 303.1 439.6 305.8 434.8 308C434.7 308 434.6 308.1 434.6 308.1C427.1 311.6 417.4 314.2 406.7 315.3H406.4C402.5 315.7 398.5 315.9 394.4 315.9C390.3 315.9 386.3 315.7 382.4 315.3H382.1C378.5 314.9 374.9 314.3 371.6 313.7C368.3 313 365.1 312.2 362.1 311.2V314.4C367.7 316.2 373.9 317.4 380.6 318.2V325.9L381.2 326.5L393.5 333.5C393.5 333.6 393.9 333.6 394.2 333.6C394.5 333.6 394.9 333.6 394.9 333.5H395L407.3 326.5L408 325.7V318.2C415.7 317.3 422.7 315.8 428.9 313.6L434.5 316.8C434.6 316.9 435.3 316.9 435.3 316.9C435.4 316.9 435.8 316.9 435.9 316.8L448.3 309.8C448.3 309.8 448.5 309.5 448.7 309.3C448.9 309 449 308.8 449 308.7V301.6C450.7 299.8 452 297.8 452.8 295.7C453.7 293.6 454.2 291.5 454.2 289.3V259L453.3 107.3ZM393.2 134.2C386.1 134.2 379.1 133.6 372.5 132.3C350.8 128.3 336.2 118.2 336.2 107.3C336.2 92.5 361.8 80.4 393.2 80.4C424.6 80.4 450.2 92.5 450.2 107.3C450.3 122.2 424.7 134.2 393.2 134.2ZM391.7 329.4L382.4 324.1V318.2C385.4 318.5 388.5 318.7 391.7 318.7V329.4ZM404 324.1L394.7 329.4V318.7C397.9 318.7 401 318.5 404 318.2V324.1ZM432.7 312.6L431.6 312C432 311.8 432.4 311.7 432.7 311.5V312.6ZM445 307.3L435.7 312.6V310.1C439.3 308.3 442.4 306.3 445 304.1V307.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M393.1 81.1C383.8 81.1 376.5 85 376.5 89.9C376.5 94.8 383.8 98.7 393.1 98.7C402.4 98.7 409.7 94.8 409.7 89.9C409.7 84.9 402.5 81.1 393.1 81.1ZM393.1 95.7C385.1 95.7 379.5 92.6 379.5 89.9C379.5 87.2 385.1 84.1 393.1 84.1C401.1 84.1 406.7 87.2 406.7 89.9C406.7 92.7 401.1 95.7 393.1 95.7ZM426.3 201.2C426.2 202.2 425.8 203.2 425 204.1C424.1 205.2 422.1 206.9 418.2 208.1C413.8 209.6 407.5 210.5 399.1 210.5C395.8 210.5 393.6 209.9 392.5 209.4C394.1 208.4 398.4 206.9 405.1 206.9C409.3 206.9 412.8 207.2 415.7 207.6C419.5 206.4 421.9 204.7 423.3 203.5C422.7 203.3 422.1 203.1 421.5 203C402.3 208.2 395.1 206.2 390.3 204.1C387.8 205.4 386.3 207.3 386.3 209.6C386.3 213.6 391.4 216.2 399.2 216.2C412.8 216.2 420.9 213.9 425.6 210.9C427.5 209.7 429.1 208.1 429.9 207.1C431.8 204.6 432.1 202.1 432.1 200.8C432.1 199.4 431.7 198.1 431 197C430.4 198.7 427.5 200.5 426.3 201.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M393.1 81.1C383.8 81.1 376.5 85 376.5 89.9C376.5 94.8 383.8 98.7 393.1 98.7C402.4 98.7 409.7 94.8 409.7 89.9C409.7 84.9 402.5 81.1 393.1 81.1ZM393.1 95.7C385.1 95.7 379.5 92.6 379.5 89.9C379.5 87.2 385.1 84.1 393.1 84.1C401.1 84.1 406.7 87.2 406.7 89.9C406.7 92.7 401.1 95.7 393.1 95.7ZM426.3 201.2C426.2 202.2 425.8 203.2 425 204.1C424.1 205.2 422.1 206.9 418.2 208.1C413.8 209.6 407.5 210.5 399.1 210.5C395.8 210.5 393.6 209.9 392.5 209.4C394.1 208.4 398.4 206.9 405.1 206.9C409.3 206.9 412.8 207.2 415.7 207.6C419.5 206.4 421.9 204.7 423.3 203.5C422.7 203.3 422.1 203.1 421.5 203C402.3 208.2 395.1 206.2 390.3 204.1C387.8 205.4 386.3 207.3 386.3 209.6C386.3 213.6 391.4 216.2 399.2 216.2C412.8 216.2 420.9 213.9 425.6 210.9C427.5 209.7 429.1 208.1 429.9 207.1C431.8 204.6 432.1 202.1 432.1 200.8C432.1 199.4 431.7 198.1 431 197C430.4 198.7 427.5 200.5 426.3 201.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M415.8 219.5C419.6 218.3 422 216.6 423.4 215.4C422.8 215.2 422.2 215 421.6 214.9C402.4 220.1 395.2 218.1 390.4 216C387.9 217.3 386.4 219.2 386.4 221.5C386.4 225.5 391.5 228.1 399.3 228.1C412.9 228.1 421 225.8 425.7 222.8C427.6 221.6 429.2 220 430 219C431.9 216.5 432.2 214 432.2 212.7C432.2 211.3 431.8 210 431.1 208.9C430.5 210.5 427.6 212.3 426.5 213C426.4 214 426 215 425.2 215.9C424.3 217 422.3 218.7 418.4 219.9C414 221.4 407.7 222.3 399.3 222.3C396 222.3 393.8 221.7 392.7 221.2C394.3 220.2 398.6 218.7 405.3 218.7C409.3 218.8 412.9 219.1 415.8 219.5ZM399.1 204.4C412.7 204.4 420.8 202.1 425.5 199.1C427.4 197.9 429 196.3 429.8 195.3C431.7 192.8 432 190.5 432 189.1V189C432 187.6 431.6 186.3 430.9 185.2V185.4C430.2 186.9 427.4 188.7 426.3 189.4C426.2 190.4 425.8 191.4 425 192.3C424.1 193.4 422 195.1 418.2 196.3C413.8 197.8 407.5 198.7 399.1 198.7C396 198.7 393.9 198.2 392.7 197.7C392.6 197.7 392.5 197.6 392.5 197.6C394.1 196.6 398.4 195.1 405.1 195.1C409.3 195.1 412.8 195.4 415.7 195.8C419.4 194.6 421.7 193.1 423.1 191.9L423.3 191.7C422.7 191.5 422.1 191.3 421.5 191.2C421.3 191.2 421.2 191.3 421 191.3C402.5 196.2 395.3 194.4 390.5 192.4C390.4 192.4 390.3 192.3 390.2 192.3C387.7 193.6 386.2 195.5 386.2 197.8V197.9C386.3 201.9 391.3 204.4 399.1 204.4Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M415.8 219.5C419.6 218.3 422 216.6 423.4 215.4C422.8 215.2 422.2 215 421.6 214.9C402.4 220.1 395.2 218.1 390.4 216C387.9 217.3 386.4 219.2 386.4 221.5C386.4 225.5 391.5 228.1 399.3 228.1C412.9 228.1 421 225.8 425.7 222.8C427.6 221.6 429.2 220 430 219C431.9 216.5 432.2 214 432.2 212.7C432.2 211.3 431.8 210 431.1 208.9C430.5 210.5 427.6 212.3 426.5 213C426.4 214 426 215 425.2 215.9C424.3 217 422.3 218.7 418.4 219.9C414 221.4 407.7 222.3 399.3 222.3C396 222.3 393.8 221.7 392.7 221.2C394.3 220.2 398.6 218.7 405.3 218.7C409.3 218.8 412.9 219.1 415.8 219.5ZM399.1 204.4C412.7 204.4 420.8 202.1 425.5 199.1C427.4 197.9 429 196.3 429.8 195.3C431.7 192.8 432 190.5 432 189.1V189C432 187.6 431.6 186.3 430.9 185.2V185.4C430.2 186.9 427.4 188.7 426.3 189.4C426.2 190.4 425.8 191.4 425 192.3C424.1 193.4 422 195.1 418.2 196.3C413.8 197.8 407.5 198.7 399.1 198.7C396 198.7 393.9 198.2 392.7 197.7C392.6 197.7 392.5 197.6 392.5 197.6C394.1 196.6 398.4 195.1 405.1 195.1C409.3 195.1 412.8 195.4 415.7 195.8C419.4 194.6 421.7 193.1 423.1 191.9L423.3 191.7C422.7 191.5 422.1 191.3 421.5 191.2C421.3 191.2 421.2 191.3 421 191.3C402.5 196.2 395.3 194.4 390.5 192.4C390.4 192.4 390.3 192.3 390.2 192.3C387.7 193.6 386.2 195.5 386.2 197.8V197.9C386.3 201.9 391.3 204.4 399.1 204.4Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M399.1 240.1C412.7 240.1 420.8 237.8 425.5 234.8C427.4 233.6 429 232 429.8 231C431.7 228.5 432 226 432 224.7C432 223.3 431.6 222 430.9 220.9C430.3 222.5 427.4 224.3 426.3 225C426.2 226 425.8 227 425 227.9C424.1 229 422.1 230.7 418.2 231.9C413.8 233.4 407.5 234.3 399.1 234.3C395.8 234.3 393.6 233.7 392.5 233.2C394.1 232.2 398.4 230.7 405.1 230.7C409.3 230.7 412.8 231 415.7 231.4C419.5 230.2 421.9 228.5 423.3 227.3C422.7 227.1 422.1 226.9 421.5 226.8C402.3 232 395.1 230 390.3 227.9C387.8 229.2 386.3 231.1 386.3 233.4C386.3 237.5 391.3 240.1 399.1 240.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M399.1 240.1C412.7 240.1 420.8 237.8 425.5 234.8C427.4 233.6 429 232 429.8 231C431.7 228.5 432 226 432 224.7C432 223.3 431.6 222 430.9 220.9C430.3 222.5 427.4 224.3 426.3 225C426.2 226 425.8 227 425 227.9C424.1 229 422.1 230.7 418.2 231.9C413.8 233.4 407.5 234.3 399.1 234.3C395.8 234.3 393.6 233.7 392.5 233.2C394.1 232.2 398.4 230.7 405.1 230.7C409.3 230.7 412.8 231 415.7 231.4C419.5 230.2 421.9 228.5 423.3 227.3C422.7 227.1 422.1 226.9 421.5 226.8C402.3 232 395.1 230 390.3 227.9C387.8 229.2 386.3 231.1 386.3 233.4C386.3 237.5 391.3 240.1 399.1 240.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430.4 236.5C430.4 235.1 430 233.9 429.3 232.7C428.7 234.3 425.8 236.2 424.6 236.9C424.2 241.2 410.4 244.8 397.4 244.8H387.1V249.8H397.7C428.5 249.8 430.4 239.1 430.4 236.5ZM415.7 184.5C419.6 183.3 422 181.6 423.3 180.4C418.8 178.9 412.7 178.1 405.2 178.1C403.2 178.1 401.1 178.2 399.2 178.5C396.6 178.9 394.5 179.3 391.5 180.5C388.4 181.9 386.3 183.9 386.3 186.6C386.3 188.4 387.4 190 389.3 191.1C392.8 192.9 397.1 193.5 401.4 193.5C409.4 193.5 417.6 191.3 421 190.1C421.1 190.1 421.2 190 421.3 190C422.9 189.4 424.3 188.7 425.5 187.9V187.8C427.4 186.6 429 185 429.8 184C431.7 181.5 432 179 432 177.7C432 170.6 422.3 167.2 405.3 167.2H387.2V172.2H405.4C419.7 172.2 426.3 175.5 426.3 177.7C426.3 178.8 425.8 179.9 424.9 181C424 182.1 422 183.8 418.1 185C413.7 186.5 407.4 187.4 399.1 187.4C395.8 187.4 393.6 186.8 392.5 186.3C394.1 185.3 398.4 183.8 405.1 183.8C409.3 183.8 412.8 184.1 415.7 184.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430.4 236.5C430.4 235.1 430 233.9 429.3 232.7C428.7 234.3 425.8 236.2 424.6 236.9C424.2 241.2 410.4 244.8 397.4 244.8H387.1V249.8H397.7C428.5 249.8 430.4 239.1 430.4 236.5ZM415.7 184.5C419.6 183.3 422 181.6 423.3 180.4C418.8 178.9 412.7 178.1 405.2 178.1C403.2 178.1 401.1 178.2 399.2 178.5C396.6 178.9 394.5 179.3 391.5 180.5C388.4 181.9 386.3 183.9 386.3 186.6C386.3 188.4 387.4 190 389.3 191.1C392.8 192.9 397.1 193.5 401.4 193.5C409.4 193.5 417.6 191.3 421 190.1C421.1 190.1 421.2 190 421.3 190C422.9 189.4 424.3 188.7 425.5 187.9V187.8C427.4 186.6 429 185 429.8 184C431.7 181.5 432 179 432 177.7C432 170.6 422.3 167.2 405.3 167.2H387.2V172.2H405.4C419.7 172.2 426.3 175.5 426.3 177.7C426.3 178.8 425.8 179.9 424.9 181C424 182.1 422 183.8 418.1 185C413.7 186.5 407.4 187.4 399.1 187.4C395.8 187.4 393.6 186.8 392.5 186.3C394.1 185.3 398.4 183.8 405.1 183.8C409.3 183.8 412.8 184.1 415.7 184.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392 259.7C406.5 260.4 420.7 258.6 432.5 253.7C434.7 252.8 436.1 250.7 436.1 248.3L436.5 157.9C436.4 156 435.6 154.3 434 153.2C432.4 152.1 430.5 151.8 428.7 152.5C416.7 156.8 402.6 157.7 388.3 157.1C386.7 157 385.2 157.6 384.1 158.8C383 159.9 382.3 161.4 382.3 163V253.9C382.3 257.1 384.8 259.6 387.9 259.7C389.3 259.7 390.7 259.6 392 259.7ZM384.4 253.7V162.7C384.4 161.7 384.8 160.7 385.5 160C386.2 159.4 387.1 159 388 159H388.1C401.8 160.4 417 158.7 429.4 154.3C430.5 153.9 431.8 154.1 432.8 154.7C433.8 155.4 434.3 156.5 434.3 157.7L433.9 248.2C433.9 249 433.7 249.7 433.3 250.2C432.9 250.8 432.4 251.2 431.7 251.5C421.8 256.1 404.6 258.2 387.9 257.2C386 257.3 384.4 255.7 384.4 253.7ZM158.4 301.9L183.2 287.6V283.8L157 299L158.4 301.9ZM95.8001 196.7L202 135.9L207.9 139.2L210.5 136.9L202.7 132.5C202.2 132.2 201.6 132.2 201 132.5L70.8001 207C70.5001 207 70.4001 207.2 70.3001 207.3L70.2001 207.4H70.0001V207.7C70.0001 207.7 69.9001 207.8 69.9001 207.9C69.8001 208 69.8001 208.1 69.8001 208.2V211.3C69.7001 211.5 69.6001 211.8 69.6001 212.1C69.6001 212.5 69.7001 212.8 69.8001 213V280.5C69.8001 280.7 69.9001 280.8 70.0001 280.9C70.1001 281.1 70.2001 281.3 70.5001 281.5V281.6L99.0001 297.9L101.2 295.4L99.0001 294.1C100 294.1 100.8 293.3 100.8 292.3C100.8 291.3 100 290.5 99.0001 290.5C98.0001 290.5 97.2001 291.3 97.2001 292.3C97.2001 292.6 97.3001 292.9 97.4001 293.1L97.3001 293L87.8001 287.5C87.7001 286.3 86.8001 285.4 85.6001 285.4C85.2001 285.4 84.9001 285.5 84.6001 285.6L82.8001 284.5C83.2001 284.1 83.4001 283.6 83.4001 283.1C83.4001 281.9 82.4001 280.9 81.2001 280.9C80.2001 280.9 79.4001 281.6 79.1001 282.5L73.2001 279.1V276.2C74.0001 275.9 74.5001 275.1 74.5001 274.2C74.5001 273.3 74.0001 272.5 73.2001 272.2V267.3C74.0001 267 74.5001 266.2 74.5001 265.3C74.5001 264.4 74.0001 263.6 73.2001 263.3V258.4C74.0001 258.1 74.5001 257.3 74.5001 256.4C74.5001 255.5 74.0001 254.7 73.2001 254.4V249.5C74.0001 249.2 74.5001 248.3 74.5001 247.5C74.5001 246.6 74.0001 245.8 73.2001 245.5V240.6C74.0001 240.3 74.5001 239.5 74.5001 238.6C74.5001 237.7 74.0001 236.9 73.2001 236.6V231.7C74.0001 231.4 74.5001 230.6 74.5001 229.7C74.5001 228.8 74.0001 228 73.2001 227.7V222.8C74.0001 222.5 74.5001 221.6 74.5001 220.8C74.5001 219.9 74.0001 219.1 73.2001 218.8V213.6C73.7001 213.2 74.0001 212.6 74.0001 211.9V211.6L88.1001 219.7C87.9001 220 87.8001 220.4 87.8001 220.8C87.8001 222 88.8001 223 90.0001 223C90.8001 223 91.5001 222.6 91.9001 221.9L105.7 229.8C105.7 231 106.7 232 107.9 232C108.3 232 108.7 231.9 109 231.7L110.8 232.8V233C110.6 233.3 110.5 233.6 110.5 233.9C110.5 234.9 111.3 235.7 112.3 235.7C112.9 235.7 113.4 235.4 113.7 235C114.1 235.1 114.4 235.1 114.4 234.9L128 242.6C127.9 242.8 127.9 243 127.9 243.2C127.9 244.4 128.9 245.4 130.1 245.4H130.3V250H130.1C128.9 250 127.9 251 127.9 252.2C127.9 253.4 128.9 254.4 130.1 254.4H130.3V259H130.1C128.9 259 127.9 260 127.9 261.2C127.9 262.4 128.9 263.4 130.1 263.4H130.3V268H130.1C128.9 268 127.9 269 127.9 270.2C127.9 271.4 128.9 272.4 130.1 272.4H130.3V277H130.1C128.9 277 127.9 278 127.9 279.2C127.9 280.4 128.9 281.4 130.1 281.4H130.3V286H130.1C128.9 286 127.9 287 127.9 288.2C127.9 289.4 128.9 290.4 130.1 290.4H130.3V292.3L133.7 292.7V244.5L151.2 234.6V296.8H154.5V232.6L183.3 216.2V212.4L153.1 229.6L95.8001 196.7ZM132.2 241.3L74.8001 208.5L92.2001 198.6L149.6 231.4L132.2 241.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M392 259.7C406.5 260.4 420.7 258.6 432.5 253.7C434.7 252.8 436.1 250.7 436.1 248.3L436.5 157.9C436.4 156 435.6 154.3 434 153.2C432.4 152.1 430.5 151.8 428.7 152.5C416.7 156.8 402.6 157.7 388.3 157.1C386.7 157 385.2 157.6 384.1 158.8C383 159.9 382.3 161.4 382.3 163V253.9C382.3 257.1 384.8 259.6 387.9 259.7C389.3 259.7 390.7 259.6 392 259.7ZM384.4 253.7V162.7C384.4 161.7 384.8 160.7 385.5 160C386.2 159.4 387.1 159 388 159H388.1C401.8 160.4 417 158.7 429.4 154.3C430.5 153.9 431.8 154.1 432.8 154.7C433.8 155.4 434.3 156.5 434.3 157.7L433.9 248.2C433.9 249 433.7 249.7 433.3 250.2C432.9 250.8 432.4 251.2 431.7 251.5C421.8 256.1 404.6 258.2 387.9 257.2C386 257.3 384.4 255.7 384.4 253.7ZM158.4 301.9L183.2 287.6V283.8L157 299L158.4 301.9ZM95.8001 196.7L202 135.9L207.9 139.2L210.5 136.9L202.7 132.5C202.2 132.2 201.6 132.2 201 132.5L70.8001 207C70.5001 207 70.4001 207.2 70.3001 207.3L70.2001 207.4H70.0001V207.7C70.0001 207.7 69.9001 207.8 69.9001 207.9C69.8001 208 69.8001 208.1 69.8001 208.2V211.3C69.7001 211.5 69.6001 211.8 69.6001 212.1C69.6001 212.5 69.7001 212.8 69.8001 213V280.5C69.8001 280.7 69.9001 280.8 70.0001 280.9C70.1001 281.1 70.2001 281.3 70.5001 281.5V281.6L99.0001 297.9L101.2 295.4L99.0001 294.1C100 294.1 100.8 293.3 100.8 292.3C100.8 291.3 100 290.5 99.0001 290.5C98.0001 290.5 97.2001 291.3 97.2001 292.3C97.2001 292.6 97.3001 292.9 97.4001 293.1L97.3001 293L87.8001 287.5C87.7001 286.3 86.8001 285.4 85.6001 285.4C85.2001 285.4 84.9001 285.5 84.6001 285.6L82.8001 284.5C83.2001 284.1 83.4001 283.6 83.4001 283.1C83.4001 281.9 82.4001 280.9 81.2001 280.9C80.2001 280.9 79.4001 281.6 79.1001 282.5L73.2001 279.1V276.2C74.0001 275.9 74.5001 275.1 74.5001 274.2C74.5001 273.3 74.0001 272.5 73.2001 272.2V267.3C74.0001 267 74.5001 266.2 74.5001 265.3C74.5001 264.4 74.0001 263.6 73.2001 263.3V258.4C74.0001 258.1 74.5001 257.3 74.5001 256.4C74.5001 255.5 74.0001 254.7 73.2001 254.4V249.5C74.0001 249.2 74.5001 248.3 74.5001 247.5C74.5001 246.6 74.0001 245.8 73.2001 245.5V240.6C74.0001 240.3 74.5001 239.5 74.5001 238.6C74.5001 237.7 74.0001 236.9 73.2001 236.6V231.7C74.0001 231.4 74.5001 230.6 74.5001 229.7C74.5001 228.8 74.0001 228 73.2001 227.7V222.8C74.0001 222.5 74.5001 221.6 74.5001 220.8C74.5001 219.9 74.0001 219.1 73.2001 218.8V213.6C73.7001 213.2 74.0001 212.6 74.0001 211.9V211.6L88.1001 219.7C87.9001 220 87.8001 220.4 87.8001 220.8C87.8001 222 88.8001 223 90.0001 223C90.8001 223 91.5001 222.6 91.9001 221.9L105.7 229.8C105.7 231 106.7 232 107.9 232C108.3 232 108.7 231.9 109 231.7L110.8 232.8V233C110.6 233.3 110.5 233.6 110.5 233.9C110.5 234.9 111.3 235.7 112.3 235.7C112.9 235.7 113.4 235.4 113.7 235C114.1 235.1 114.4 235.1 114.4 234.9L128 242.6C127.9 242.8 127.9 243 127.9 243.2C127.9 244.4 128.9 245.4 130.1 245.4H130.3V250H130.1C128.9 250 127.9 251 127.9 252.2C127.9 253.4 128.9 254.4 130.1 254.4H130.3V259H130.1C128.9 259 127.9 260 127.9 261.2C127.9 262.4 128.9 263.4 130.1 263.4H130.3V268H130.1C128.9 268 127.9 269 127.9 270.2C127.9 271.4 128.9 272.4 130.1 272.4H130.3V277H130.1C128.9 277 127.9 278 127.9 279.2C127.9 280.4 128.9 281.4 130.1 281.4H130.3V286H130.1C128.9 286 127.9 287 127.9 288.2C127.9 289.4 128.9 290.4 130.1 290.4H130.3V292.3L133.7 292.7V244.5L151.2 234.6V296.8H154.5V232.6L183.3 216.2V212.4L153.1 229.6L95.8001 196.7ZM132.2 241.3L74.8001 208.5L92.2001 198.6L149.6 231.4L132.2 241.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.7998 270C92.7998 271 93.5998 271.8 94.5998 271.8C94.9998 271.8 95.3998 271.7 95.6998 271.4C94.7998 270.6 93.9998 269.8 93.2998 268.8C92.9998 269.1 92.7998 269.5 92.7998 270ZM90.0998 267.3C90.7998 267.3 91.3998 266.9 91.6998 266.3C91.3998 265.8 91.1998 265.3 90.9998 264.8L90.6998 263.9C90.4998 263.8 90.2998 263.8 90.0998 263.8C89.0998 263.8 88.2998 264.6 88.2998 265.6C88.2998 266.5 89.0998 267.3 90.0998 267.3ZM89.8998 258.4C89.8998 257.2 90.1998 256 90.5998 254.9C90.4998 254.9 90.2998 254.8 90.1998 254.8C89.1998 254.8 88.3998 255.6 88.3998 256.6C88.3998 257.5 89.0998 258.3 89.8998 258.4ZM112.4 268.2H112.2C112 268.8 111.7 269.4 111.4 270L110.8 270.9C111.1 271.4 111.7 271.8 112.4 271.8C113.4 271.8 114.2 271 114.2 270C114.2 269 113.4 268.2 112.4 268.2ZM108.8 272.9C108 273.5 107.1 273.9 106.2 274.2V274.4C106.2 275.4 107 276.2 108 276.2C109 276.2 109.8 275.4 109.8 274.4C109.7 273.8 109.4 273.2 108.8 272.9ZM99.1998 248.8C99.5998 248.8 99.9998 248.8 100.4 248.9C100.7 248.6 100.9 248.2 100.9 247.7C100.9 246.7 100.1 245.9 99.0998 245.9C98.0998 245.9 97.2998 246.7 97.2998 247.7C97.2998 248.2 97.4998 248.6 97.7998 248.9C98.1998 248.9 98.6998 248.8 99.1998 248.8ZM97.1998 274.5C97.1998 275.5 97.9998 276.3 98.9998 276.3C99.9998 276.3 100.8 275.5 100.8 274.5V274.3C99.7998 274 98.8998 273.6 97.8998 273.1C97.4998 273.4 97.1998 273.9 97.1998 274.5ZM112.4 259.3C112.2 259.3 112 259.3 111.9 259.4C112.3 260.6 112.6 261.7 112.7 262.9C113.5 262.8 114.2 262 114.2 261.1C114.2 260.1 113.4 259.3 112.4 259.3ZM106.4 266.5C106.4 266.4 106.5 266.2 106.5 266.1C106.5 266 106.6 265.8 106.6 265.7V265.6C106.6 265.4 106.6 265.2 106.7 265.1V263.9C106.7 263.7 106.7 263.6 106.6 263.4V263C106.6 262.9 106.6 262.7 106.5 262.6C106.5 262.5 106.4 262.3 106.4 262.2C106.4 262 106.3 261.8 106.2 261.6C106.1 261.4 106.1 261.2 106 260.9C104.6 257.4 101.6 254.8 99.0998 254.8H98.4998C98.1998 254.8 97.8998 255 97.5998 255.1C97.3998 255.2 97.2998 255.3 97.0998 255.4C96.8998 255.5 96.7998 255.7 96.6998 255.8C96.5998 256 96.4998 256.1 96.3998 256.3L96.0998 256.9C96.0998 257 96.0998 257 95.9998 257.1C95.9998 257.2 95.8998 257.3 95.8998 257.4V258.1C95.7998 258.6 95.7998 259.2 95.8998 259.8C95.9998 260.3 96.0998 260.8 96.1998 261.4C96.2998 261.7 96.3998 262 96.4998 262.4C96.6998 262.8 96.8998 263.3 97.0998 263.7C97.1998 263.8 97.1998 263.9 97.2998 264C97.2998 264.1 97.3998 264.1 97.3998 264.2C97.3998 264.3 97.4998 264.3 97.4998 264.4C97.5998 264.5 97.6998 264.7 97.7998 264.8C97.8998 264.9 97.8998 265 97.9998 265.1C97.9998 265.1 97.9998 265.2 98.0998 265.2C98.2998 265.4 98.3998 265.6 98.5998 265.8C98.6998 265.9 98.7998 266.1 98.8998 266.2L99.1998 266.5L99.4998 266.8L99.7998 267.1C99.9998 267.3 100.2 267.4 100.4 267.6C100.5 267.7 100.6 267.8 100.7 267.8C100.9 267.9 101 268 101.2 268.1H101.3C101.5 268.2 101.6 268.3 101.8 268.3C101.9 268.3 102 268.4 102.1 268.4C102.2 268.4 102.3 268.5 102.4 268.5C102.5 268.5 102.7 268.6 102.9 268.6H104C104.1 268.6 104.2 268.5 104.4 268.5C104.5 268.5 104.6 268.4 104.7 268.4C104.8 268.4 104.9 268.3 105 268.3C105.1 268.3 105.1 268.2 105.2 268.2C105.3 268.1 105.4 268.1 105.4 268L105.7 267.7C105.8 267.6 105.9 267.5 106 267.3V267.2C106.1 267.1 106.1 267 106.2 266.9C106.3 266.7 106.4 266.6 106.4 266.5ZM353 150.8L350.7 149.5L295 117.7C294.5 117.4 293.9 117.4 293.4 117.7L284.9 122.5C284.8 122.4 284.6 122.3 284.5 122.1C282.9 120.9 280.7 120 278 119.6C276.9 119.4 275.7 119.3 274.5 119.3C270.3 119.3 266.7 120.4 264.5 122.1C264.4 122.2 264.2 122.3 264.1 122.5C262.8 123.6 262.1 125 262.1 126.4V135.5L251.9 141.3L251 141.8C250.6 141.5 250.2 141.2 249.7 140.9L247.9 139.8L234.1 131.9L233.9 131.8C233.2 131.4 232.5 131.2 231.7 131.2C230.8 131.2 229.9 131.5 229 132C228.6 132.2 228.2 132.5 227.9 132.8C226.1 134.4 224.9 136.9 224.9 139.2C224.9 140.2 225.1 141.1 225.5 141.8C225.9 142.5 226.4 143.1 227.2 143.5L237.4 149.4L226.5 155.6C225.9 155 208.8 144.9 208.8 144.9L208.6 144.8C207.9 144.4 207.2 144.2 206.4 144.2C205.5 144.2 204.5 144.5 203.7 145C201.3 146.4 199.5 149.5 199.5 152.3C199.5 153.1 199.6 153.8 199.9 154.4C200.3 155.3 200.9 156.1 201.8 156.6L213.2 163.2L190.6 176.1L190.3 176.4C190.2 176.6 190 176.7 190 177C189.9 177.2 189.9 177.3 189.9 177.5V234.4C189.9 234.5 189.9 234.5 190 234.5V234.6C190 234.7 190.1 234.8 190.1 234.8L190.3 235L190.5 235.2L191.7 235.9V245.6H190.8C190.7 245.6 190.6 245.7 190.5 245.7C190.4 245.7 190.3 245.8 190.3 245.8L190.1 246L189.9 246.2C189.9 246.3 189.8 246.3 189.8 246.3V246.5C189.8 246.6 189.8 246.7 189.7 246.8V378.7C189.7 378.8 189.8 378.9 189.8 379C189.8 379.1 189.9 379.2 189.9 379.3L190.1 379.5C190.2 379.6 190.3 379.6 190.4 379.7L215.2 393.9L247.8 412.5C248.1 412.9 248.5 413.1 249.1 413.1H249.4C249.7 413.1 249.9 413 250.2 412.9L353.1 354.2H353.2C353.2 354.2 353.3 354.2 353.3 354.1L353.4 354L353.5 353.9L353.6 353.8L353.7 353.7C353.7 353.7 353.7 353.6 353.8 353.6C353.8 353.5 353.8 353.5 353.9 353.4V221.3L353.8 220.9C353.8 220.8 353.7 220.7 353.6 220.6C353.5 220.5 353.3 220.3 353.2 220.3C353 220.2 352.8 220.1 352.6 220.1H352.3C352.2 220.1 351.6 220.3 351.6 220.3L351.1 220.6V211L353.3 209.8C353.4 209.8 353.5 209.7 353.6 209.6C353.7 209.5 353.8 209.5 353.8 209.4C353.9 209.2 354 209.1 354.1 208.9V152.2C354 151.5 353.6 151 353 150.8ZM266.1 126.3C266.2 124.5 270 123.1 274.5 123.1C278.6 123.1 282 124.2 282.8 125.7C282.9 125.8 282.9 125.8 282.9 125.9C283 126.1 283 126.2 283 126.4C283 128.2 279.2 129.7 274.5 129.7C269.8 129.7 266.1 128.2 266.1 126.3C266 126.2 266 126.1 266 126C266 126.1 266.1 126.2 266.1 126.3ZM266.2 131.6C266.7 131.9 267.2 132.1 267.7 132.3C268 132.4 268.3 132.5 268.7 132.6C268.9 132.6 270.2 132.8 270.2 132.8C270.2 132.8 272.1 133 272.4 133C273.1 133.1 273.8 133.1 274.6 133.1C277.9 133.1 280.9 132.4 283 131.3V163.3C283 164.4 279.8 166.4 274.6 166.4C269.4 166.4 266.2 164.4 266.2 163.3V131.6ZM237 146L228.5 141C228 140.7 227.7 140.1 227.7 139.3C227.7 137.6 228.9 135.5 230.4 134.7C230.8 134.5 231.2 134.3 231.6 134.3C231.8 134.3 231.9 134.3 232.1 134.4C232.2 134.4 232.3 134.4 232.4 134.5C232.5 134.5 232.5 134.6 232.6 134.6L248.2 143.5L248.4 143.6C248.8 143.8 249.2 144.1 249.5 144.4L249.6 144.5L250.1 145C250.2 145.1 250.3 145.2 250.3 145.3C250.4 145.4 250.4 145.5 250.5 145.6C250.6 145.7 250.6 145.7 250.6 145.9C250.8 146.2 250.9 146.4 251 146.7C251.3 147.4 251.4 148.2 251.4 149V156.8C251.4 157.4 251 157.9 250.3 158.3C249.7 158.7 248.8 158.9 247.9 158.9H246.8C246.6 158.9 246.3 158.8 246.1 158.8C245.9 158.7 245.7 158.7 245.4 158.6L244.8 158.3C244.1 157.9 243.7 157.3 243.7 156.8V156.5H243.6V151.3C243.6 151 243.5 150.7 243.5 150.4C243.5 150.3 243.4 150.2 243.4 150.1V150C243.3 149.9 243.3 149.8 243.2 149.7C243 149.4 242.7 149.2 242.4 149L241.6 148.6L241.3 148.4L240.2 147.8L237 146ZM203.1 154.2C202.6 153.9 202.3 153.3 202.3 152.5C202.3 150.8 203.5 148.7 205 147.9C205.4 147.7 205.8 147.5 206.2 147.5C206.5 147.5 206.7 147.6 206.9 147.7L207.1 147.8L207.6 148.1L214.1 151.8L222.9 156.8L223.8 157.4C224.7 158.1 225.3 159 225.7 160C226 160.7 226.1 161.5 226.1 162.3V170.1C226.1 170.7 225.7 171.2 225 171.6C224.4 172 223.5 172.2 222.6 172.2H221.5C221.3 172.2 221 172.1 220.8 172.1C220.6 172 220.4 172 220.1 171.9L219.5 171.6C218.8 171.2 218.4 170.6 218.4 170.1V164.7C218.4 164.5 218.4 164.3 218.3 164.1C218.2 163.4 217.7 162.7 217 162.3L216 161.7L203.1 154.2ZM247.3 285.2C247.4 285.2 247.6 285.2 247.7 285.1V290.9C247.6 290.9 247.4 290.8 247.3 290.8C246.3 290.8 245.4 291.7 245.4 292.7C245.4 293.7 246.3 294.6 247.3 294.6C247.4 294.6 247.6 294.6 247.7 294.5V300.3C247.6 300.3 247.4 300.2 247.3 300.2C246.3 300.2 245.4 301 245.4 302.1C245.4 303.2 246.3 304 247.3 304C247.4 304 247.6 304 247.7 303.9V309.7C247.6 309.7 247.4 309.6 247.3 309.6C246.3 309.6 245.4 310.4 245.4 311.5C245.4 312.6 246.3 313.4 247.3 313.4C247.4 313.4 247.6 313.4 247.7 313.3V319.1C247.6 319.1 247.4 319 247.3 319C246.3 319 245.4 319.8 245.4 320.9C245.4 321.9 246.3 322.8 247.3 322.8C247.4 322.8 247.6 322.8 247.7 322.7V328.5H247.3C246.3 328.5 245.4 329.3 245.4 330.4C245.4 331.5 246.3 332.3 247.3 332.3C247.4 332.3 247.6 332.3 247.7 332.2V338C247.6 338 247.4 337.9 247.3 337.9C246.3 337.9 245.4 338.8 245.4 339.8C245.4 340.8 246.3 341.7 247.3 341.7C247.4 341.7 247.6 341.7 247.7 341.6V347.4C247.6 347.4 247.4 347.3 247.3 347.3C246.3 347.3 245.4 348.1 245.4 349.2C245.4 350.2 246.3 351.1 247.3 351.1C247.4 351.1 247.6 351.1 247.7 351V356.8H247.3C246.3 356.8 245.4 357.6 245.4 358.7C245.4 359.8 246.3 360.6 247.3 360.6H247.7V366.4C247.6 366.4 247.4 366.3 247.3 366.3C246.3 366.3 245.4 367.1 245.4 368.2C245.4 369.2 246.3 370.1 247.3 370.1H247.7V375.9C247.6 375.9 247.4 375.8 247.3 375.8C246.3 375.8 245.4 376.6 245.4 377.7C245.4 378.8 246.3 379.6 247.3 379.6C247.4 379.6 247.6 379.6 247.7 379.5V385.3C247.6 385.3 247.4 385.2 247.3 385.2C246.3 385.2 245.4 386.1 245.4 387.1C245.4 388.1 246.3 389 247.3 389H247.7V394.8H247.3C246.3 394.8 245.4 395.6 245.4 396.7C245.4 397.8 246.3 398.6 247.3 398.6H247.7V404.4H247C246.1 404.5 245.4 405.3 245.4 406.3C245.4 407.3 246.3 408.2 247.3 408.2H247.7V409.5L234.9 402.2C235 402 235 401.8 235 401.6C235 400.6 234.2 399.7 233.1 399.7C232.5 399.7 232 400 231.7 400.4L228.8 398.7C229.7 398.5 230.3 397.8 230.3 396.9C230.3 395.9 229.5 395 228.4 395C227.4 395 226.5 395.8 226.5 396.9C226.5 397.1 226.5 397.3 226.6 397.5L216 391C216 390.9 216 390.9 215.9 390.8C215.9 390.8 215.9 390.7 215.8 390.7C215.5 390.2 214.9 389.9 214.2 389.9H214L211 388.2C211.3 387.9 211.4 387.5 211.4 387.1C211.4 386.1 210.5 385.2 209.5 385.2C208.7 385.2 208 385.7 207.7 386.4L192.8 377.9V250.9C192.9 250.9 193.1 251 193.2 251H193.6C193.8 251.8 194.6 252.3 195.4 252.3C195.7 252.3 195.9 252.2 196.1 252.1L196.8 252.5L198.8 253.7C198.4 254 198.2 254.5 198.2 255.1C198.2 256.1 199.1 257 200.1 257C201 257 201.8 256.3 201.9 255.5L217.1 264.1V264.5C217.1 264.7 217.1 264.9 217.2 265.1C217.4 265.9 218.1 266.4 219 266.4C219.5 266.4 219.9 266.2 220.3 265.9L220.6 266.1L223.1 267.5C222.4 267.8 221.9 268.4 221.9 269.3C221.9 270.3 222.7 271.2 223.8 271.2C224.8 271.2 225.7 270.4 225.7 269.3V269L236.5 275.1C236.8 275.5 237.3 275.8 237.9 275.9L241.2 277.8C241 278.1 240.9 278.4 240.9 278.8C240.9 279.8 241.7 280.7 242.8 280.7C243.5 280.7 244.1 280.3 244.5 279.7L247.7 281.5C247.6 281.5 247.4 281.4 247.3 281.4C246.3 281.4 245.4 282.2 245.4 283.3C245.4 284.4 246.3 285.2 247.3 285.2ZM247.7 277.8L223.8 264.2L221.3 262.8L196.9 248.9L194.9 247.8V238.2L196.9 239.3L229.7 258L232.2 259.4L247.7 268.2V277.8ZM247.7 215.7C247 216 246.4 216.6 246.4 217.5C246.4 218.3 246.9 219 247.7 219.3V225.2C247 225.5 246.4 226.1 246.4 227C246.4 227.8 246.9 228.5 247.7 228.8V234.7C247 235 246.4 235.6 246.4 236.5C246.4 237.3 246.9 238 247.7 238.3V244.2C247 244.5 246.4 245.2 246.4 246C246.4 246.6 246.7 247.2 247.2 247.5C247.3 247.6 247.5 247.7 247.7 247.7V254C247 254.3 246.4 255 246.4 255.8C246.4 256.6 246.9 257.3 247.7 257.6V263.5C247.4 263.6 247.1 263.8 246.8 264.1L243.8 262.4C244.7 262.3 245.4 261.5 245.4 260.5C245.4 259.5 244.5 258.6 243.5 258.6C242.5 258.6 241.6 259.4 241.6 260.5C241.6 260.8 241.6 261 241.7 261.2L235.3 257.5L232.8 256.1L231.2 255.2C230.9 254.5 230.2 253.9 229.4 253.9H229.1L226.2 252.2C226.5 251.9 226.7 251.5 226.7 251C226.7 249.9 225.8 249.1 224.8 249.1C224 249.1 223.3 249.6 223 250.4L207.8 241.7V241.6C207.8 240.6 207 239.7 205.9 239.7C205.5 239.7 205.1 239.8 204.8 240L202.1 238.5C202.7 238.2 203 237.6 203 236.9C203 235.9 202.2 235 201.1 235C200.1 235 199.2 235.9 199.2 236.9L196.8 235.5L192.9 233.2V229C193.3 228.6 193.6 228.1 193.6 227.5C193.6 226.9 193.3 226.4 192.9 226V219.5C193.3 219.2 193.6 218.6 193.6 218C193.6 217.4 193.3 216.9 192.9 216.5V210C193 209.9 193.1 209.9 193.1 209.8C193.4 209.5 193.6 209 193.6 208.5C193.6 207.9 193.3 207.4 192.9 207V200.5C193.3 200.2 193.6 199.6 193.6 199C193.6 198.4 193.3 197.9 192.9 197.5V191C193.3 190.7 193.6 190.1 193.6 189.5C193.6 188.9 193.3 188.4 192.9 188V181.5C193.2 181.2 193.4 180.9 193.5 180.5L196.8 182.4L208.7 189.2V189.5C208.7 190.5 209.5 191.4 210.6 191.4C211.1 191.4 211.5 191.2 211.8 191L214.5 192.5C213.9 192.8 213.4 193.5 213.4 194.2C213.4 194.5 213.5 194.8 213.6 195C213.9 195.6 214.5 196.1 215.3 196.1C216.3 196.1 217.2 195.3 217.2 194.2V194L218.8 194.9L228.1 200.2C228.3 200.4 228.6 200.6 228.9 200.6L232.5 202.6C232.4 202.9 232.3 203.1 232.3 203.5C232.3 204.5 233.2 205.4 234.2 205.4C234.9 205.4 235.5 205 235.8 204.5L239 206.3H238.9C238.1 206.3 237.4 206.8 237.2 207.4C237.1 207.6 237.1 207.9 237.1 208.1C237.1 208.4 237.1 208.6 237.2 208.8C237.5 209.5 238.2 209.9 238.9 209.9C239.5 209.9 240.1 209.6 240.5 209.1C240.7 208.8 240.8 208.4 240.8 208.1C240.8 207.7 240.7 207.3 240.5 207L247.7 211.1V215.7ZM249.6 209.1L222 193.4L219.5 192L199 180.3L194.5 177.8L214.6 166.3L215.5 165.8V170.1C215.5 171.8 216.4 173.3 218.1 174.3C219.3 175 220.8 175.4 222.3 175.4C223.8 175.4 225.3 175 226.5 174.4C228.2 173.4 229.1 171.9 229.1 170.2V162.4C229.1 161.1 228.8 159.8 228.3 158.6L235.2 154.7L237.7 153.3L240.6 151.7L240.9 151.9V157.2C240.9 157.5 240.9 157.9 241 158.2C241.3 159.5 242.2 160.6 243.5 161.4C244.7 162.1 246.2 162.5 247.7 162.5H248.3C249.6 162.4 250.7 162.1 251.7 161.6C251.7 161.6 251.8 161.6 251.8 161.5C253.5 160.5 254.4 159 254.4 157.3V149.5C254.4 147.8 253.9 146.1 253.1 144.7L262.1 139.6V164.1C262.1 168.1 267.4 171.1 274.5 171.1C281.6 171.1 286.9 168.1 286.9 164.1V125.5L294.3 121.3L349.4 152.7L249.6 209.1ZM250.9 268.5L275.3 254.6V264.2L250.9 278.1V268.5ZM350.8 352.2L250.8 409.3V281.7L350 225.1C350.2 225 350.3 225 350.4 224.8L350.8 224.6V352.2ZM278.4 262.3V253.2L325.4 226.1V235.3L292.3 254.4L278.4 262.3ZM328.5 233.7V224.1L347.9 213.1V222.7L328.5 233.7ZM350.8 207.8L250.9 264.8V212L350.8 155V207.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.7998 270C92.7998 271 93.5998 271.8 94.5998 271.8C94.9998 271.8 95.3998 271.7 95.6998 271.4C94.7998 270.6 93.9998 269.8 93.2998 268.8C92.9998 269.1 92.7998 269.5 92.7998 270ZM90.0998 267.3C90.7998 267.3 91.3998 266.9 91.6998 266.3C91.3998 265.8 91.1998 265.3 90.9998 264.8L90.6998 263.9C90.4998 263.8 90.2998 263.8 90.0998 263.8C89.0998 263.8 88.2998 264.6 88.2998 265.6C88.2998 266.5 89.0998 267.3 90.0998 267.3ZM89.8998 258.4C89.8998 257.2 90.1998 256 90.5998 254.9C90.4998 254.9 90.2998 254.8 90.1998 254.8C89.1998 254.8 88.3998 255.6 88.3998 256.6C88.3998 257.5 89.0998 258.3 89.8998 258.4ZM112.4 268.2H112.2C112 268.8 111.7 269.4 111.4 270L110.8 270.9C111.1 271.4 111.7 271.8 112.4 271.8C113.4 271.8 114.2 271 114.2 270C114.2 269 113.4 268.2 112.4 268.2ZM108.8 272.9C108 273.5 107.1 273.9 106.2 274.2V274.4C106.2 275.4 107 276.2 108 276.2C109 276.2 109.8 275.4 109.8 274.4C109.7 273.8 109.4 273.2 108.8 272.9ZM99.1998 248.8C99.5998 248.8 99.9998 248.8 100.4 248.9C100.7 248.6 100.9 248.2 100.9 247.7C100.9 246.7 100.1 245.9 99.0998 245.9C98.0998 245.9 97.2998 246.7 97.2998 247.7C97.2998 248.2 97.4998 248.6 97.7998 248.9C98.1998 248.9 98.6998 248.8 99.1998 248.8ZM97.1998 274.5C97.1998 275.5 97.9998 276.3 98.9998 276.3C99.9998 276.3 100.8 275.5 100.8 274.5V274.3C99.7998 274 98.8998 273.6 97.8998 273.1C97.4998 273.4 97.1998 273.9 97.1998 274.5ZM112.4 259.3C112.2 259.3 112 259.3 111.9 259.4C112.3 260.6 112.6 261.7 112.7 262.9C113.5 262.8 114.2 262 114.2 261.1C114.2 260.1 113.4 259.3 112.4 259.3ZM106.4 266.5C106.4 266.4 106.5 266.2 106.5 266.1C106.5 266 106.6 265.8 106.6 265.7V265.6C106.6 265.4 106.6 265.2 106.7 265.1V263.9C106.7 263.7 106.7 263.6 106.6 263.4V263C106.6 262.9 106.6 262.7 106.5 262.6C106.5 262.5 106.4 262.3 106.4 262.2C106.4 262 106.3 261.8 106.2 261.6C106.1 261.4 106.1 261.2 106 260.9C104.6 257.4 101.6 254.8 99.0998 254.8H98.4998C98.1998 254.8 97.8998 255 97.5998 255.1C97.3998 255.2 97.2998 255.3 97.0998 255.4C96.8998 255.5 96.7998 255.7 96.6998 255.8C96.5998 256 96.4998 256.1 96.3998 256.3L96.0998 256.9C96.0998 257 96.0998 257 95.9998 257.1C95.9998 257.2 95.8998 257.3 95.8998 257.4V258.1C95.7998 258.6 95.7998 259.2 95.8998 259.8C95.9998 260.3 96.0998 260.8 96.1998 261.4C96.2998 261.7 96.3998 262 96.4998 262.4C96.6998 262.8 96.8998 263.3 97.0998 263.7C97.1998 263.8 97.1998 263.9 97.2998 264C97.2998 264.1 97.3998 264.1 97.3998 264.2C97.3998 264.3 97.4998 264.3 97.4998 264.4C97.5998 264.5 97.6998 264.7 97.7998 264.8C97.8998 264.9 97.8998 265 97.9998 265.1C97.9998 265.1 97.9998 265.2 98.0998 265.2C98.2998 265.4 98.3998 265.6 98.5998 265.8C98.6998 265.9 98.7998 266.1 98.8998 266.2L99.1998 266.5L99.4998 266.8L99.7998 267.1C99.9998 267.3 100.2 267.4 100.4 267.6C100.5 267.7 100.6 267.8 100.7 267.8C100.9 267.9 101 268 101.2 268.1H101.3C101.5 268.2 101.6 268.3 101.8 268.3C101.9 268.3 102 268.4 102.1 268.4C102.2 268.4 102.3 268.5 102.4 268.5C102.5 268.5 102.7 268.6 102.9 268.6H104C104.1 268.6 104.2 268.5 104.4 268.5C104.5 268.5 104.6 268.4 104.7 268.4C104.8 268.4 104.9 268.3 105 268.3C105.1 268.3 105.1 268.2 105.2 268.2C105.3 268.1 105.4 268.1 105.4 268L105.7 267.7C105.8 267.6 105.9 267.5 106 267.3V267.2C106.1 267.1 106.1 267 106.2 266.9C106.3 266.7 106.4 266.6 106.4 266.5ZM353 150.8L350.7 149.5L295 117.7C294.5 117.4 293.9 117.4 293.4 117.7L284.9 122.5C284.8 122.4 284.6 122.3 284.5 122.1C282.9 120.9 280.7 120 278 119.6C276.9 119.4 275.7 119.3 274.5 119.3C270.3 119.3 266.7 120.4 264.5 122.1C264.4 122.2 264.2 122.3 264.1 122.5C262.8 123.6 262.1 125 262.1 126.4V135.5L251.9 141.3L251 141.8C250.6 141.5 250.2 141.2 249.7 140.9L247.9 139.8L234.1 131.9L233.9 131.8C233.2 131.4 232.5 131.2 231.7 131.2C230.8 131.2 229.9 131.5 229 132C228.6 132.2 228.2 132.5 227.9 132.8C226.1 134.4 224.9 136.9 224.9 139.2C224.9 140.2 225.1 141.1 225.5 141.8C225.9 142.5 226.4 143.1 227.2 143.5L237.4 149.4L226.5 155.6C225.9 155 208.8 144.9 208.8 144.9L208.6 144.8C207.9 144.4 207.2 144.2 206.4 144.2C205.5 144.2 204.5 144.5 203.7 145C201.3 146.4 199.5 149.5 199.5 152.3C199.5 153.1 199.6 153.8 199.9 154.4C200.3 155.3 200.9 156.1 201.8 156.6L213.2 163.2L190.6 176.1L190.3 176.4C190.2 176.6 190 176.7 190 177C189.9 177.2 189.9 177.3 189.9 177.5V234.4C189.9 234.5 189.9 234.5 190 234.5V234.6C190 234.7 190.1 234.8 190.1 234.8L190.3 235L190.5 235.2L191.7 235.9V245.6H190.8C190.7 245.6 190.6 245.7 190.5 245.7C190.4 245.7 190.3 245.8 190.3 245.8L190.1 246L189.9 246.2C189.9 246.3 189.8 246.3 189.8 246.3V246.5C189.8 246.6 189.8 246.7 189.7 246.8V378.7C189.7 378.8 189.8 378.9 189.8 379C189.8 379.1 189.9 379.2 189.9 379.3L190.1 379.5C190.2 379.6 190.3 379.6 190.4 379.7L215.2 393.9L247.8 412.5C248.1 412.9 248.5 413.1 249.1 413.1H249.4C249.7 413.1 249.9 413 250.2 412.9L353.1 354.2H353.2C353.2 354.2 353.3 354.2 353.3 354.1L353.4 354L353.5 353.9L353.6 353.8L353.7 353.7C353.7 353.7 353.7 353.6 353.8 353.6C353.8 353.5 353.8 353.5 353.9 353.4V221.3L353.8 220.9C353.8 220.8 353.7 220.7 353.6 220.6C353.5 220.5 353.3 220.3 353.2 220.3C353 220.2 352.8 220.1 352.6 220.1H352.3C352.2 220.1 351.6 220.3 351.6 220.3L351.1 220.6V211L353.3 209.8C353.4 209.8 353.5 209.7 353.6 209.6C353.7 209.5 353.8 209.5 353.8 209.4C353.9 209.2 354 209.1 354.1 208.9V152.2C354 151.5 353.6 151 353 150.8ZM266.1 126.3C266.2 124.5 270 123.1 274.5 123.1C278.6 123.1 282 124.2 282.8 125.7C282.9 125.8 282.9 125.8 282.9 125.9C283 126.1 283 126.2 283 126.4C283 128.2 279.2 129.7 274.5 129.7C269.8 129.7 266.1 128.2 266.1 126.3C266 126.2 266 126.1 266 126C266 126.1 266.1 126.2 266.1 126.3ZM266.2 131.6C266.7 131.9 267.2 132.1 267.7 132.3C268 132.4 268.3 132.5 268.7 132.6C268.9 132.6 270.2 132.8 270.2 132.8C270.2 132.8 272.1 133 272.4 133C273.1 133.1 273.8 133.1 274.6 133.1C277.9 133.1 280.9 132.4 283 131.3V163.3C283 164.4 279.8 166.4 274.6 166.4C269.4 166.4 266.2 164.4 266.2 163.3V131.6ZM237 146L228.5 141C228 140.7 227.7 140.1 227.7 139.3C227.7 137.6 228.9 135.5 230.4 134.7C230.8 134.5 231.2 134.3 231.6 134.3C231.8 134.3 231.9 134.3 232.1 134.4C232.2 134.4 232.3 134.4 232.4 134.5C232.5 134.5 232.5 134.6 232.6 134.6L248.2 143.5L248.4 143.6C248.8 143.8 249.2 144.1 249.5 144.4L249.6 144.5L250.1 145C250.2 145.1 250.3 145.2 250.3 145.3C250.4 145.4 250.4 145.5 250.5 145.6C250.6 145.7 250.6 145.7 250.6 145.9C250.8 146.2 250.9 146.4 251 146.7C251.3 147.4 251.4 148.2 251.4 149V156.8C251.4 157.4 251 157.9 250.3 158.3C249.7 158.7 248.8 158.9 247.9 158.9H246.8C246.6 158.9 246.3 158.8 246.1 158.8C245.9 158.7 245.7 158.7 245.4 158.6L244.8 158.3C244.1 157.9 243.7 157.3 243.7 156.8V156.5H243.6V151.3C243.6 151 243.5 150.7 243.5 150.4C243.5 150.3 243.4 150.2 243.4 150.1V150C243.3 149.9 243.3 149.8 243.2 149.7C243 149.4 242.7 149.2 242.4 149L241.6 148.6L241.3 148.4L240.2 147.8L237 146ZM203.1 154.2C202.6 153.9 202.3 153.3 202.3 152.5C202.3 150.8 203.5 148.7 205 147.9C205.4 147.7 205.8 147.5 206.2 147.5C206.5 147.5 206.7 147.6 206.9 147.7L207.1 147.8L207.6 148.1L214.1 151.8L222.9 156.8L223.8 157.4C224.7 158.1 225.3 159 225.7 160C226 160.7 226.1 161.5 226.1 162.3V170.1C226.1 170.7 225.7 171.2 225 171.6C224.4 172 223.5 172.2 222.6 172.2H221.5C221.3 172.2 221 172.1 220.8 172.1C220.6 172 220.4 172 220.1 171.9L219.5 171.6C218.8 171.2 218.4 170.6 218.4 170.1V164.7C218.4 164.5 218.4 164.3 218.3 164.1C218.2 163.4 217.7 162.7 217 162.3L216 161.7L203.1 154.2ZM247.3 285.2C247.4 285.2 247.6 285.2 247.7 285.1V290.9C247.6 290.9 247.4 290.8 247.3 290.8C246.3 290.8 245.4 291.7 245.4 292.7C245.4 293.7 246.3 294.6 247.3 294.6C247.4 294.6 247.6 294.6 247.7 294.5V300.3C247.6 300.3 247.4 300.2 247.3 300.2C246.3 300.2 245.4 301 245.4 302.1C245.4 303.2 246.3 304 247.3 304C247.4 304 247.6 304 247.7 303.9V309.7C247.6 309.7 247.4 309.6 247.3 309.6C246.3 309.6 245.4 310.4 245.4 311.5C245.4 312.6 246.3 313.4 247.3 313.4C247.4 313.4 247.6 313.4 247.7 313.3V319.1C247.6 319.1 247.4 319 247.3 319C246.3 319 245.4 319.8 245.4 320.9C245.4 321.9 246.3 322.8 247.3 322.8C247.4 322.8 247.6 322.8 247.7 322.7V328.5H247.3C246.3 328.5 245.4 329.3 245.4 330.4C245.4 331.5 246.3 332.3 247.3 332.3C247.4 332.3 247.6 332.3 247.7 332.2V338C247.6 338 247.4 337.9 247.3 337.9C246.3 337.9 245.4 338.8 245.4 339.8C245.4 340.8 246.3 341.7 247.3 341.7C247.4 341.7 247.6 341.7 247.7 341.6V347.4C247.6 347.4 247.4 347.3 247.3 347.3C246.3 347.3 245.4 348.1 245.4 349.2C245.4 350.2 246.3 351.1 247.3 351.1C247.4 351.1 247.6 351.1 247.7 351V356.8H247.3C246.3 356.8 245.4 357.6 245.4 358.7C245.4 359.8 246.3 360.6 247.3 360.6H247.7V366.4C247.6 366.4 247.4 366.3 247.3 366.3C246.3 366.3 245.4 367.1 245.4 368.2C245.4 369.2 246.3 370.1 247.3 370.1H247.7V375.9C247.6 375.9 247.4 375.8 247.3 375.8C246.3 375.8 245.4 376.6 245.4 377.7C245.4 378.8 246.3 379.6 247.3 379.6C247.4 379.6 247.6 379.6 247.7 379.5V385.3C247.6 385.3 247.4 385.2 247.3 385.2C246.3 385.2 245.4 386.1 245.4 387.1C245.4 388.1 246.3 389 247.3 389H247.7V394.8H247.3C246.3 394.8 245.4 395.6 245.4 396.7C245.4 397.8 246.3 398.6 247.3 398.6H247.7V404.4H247C246.1 404.5 245.4 405.3 245.4 406.3C245.4 407.3 246.3 408.2 247.3 408.2H247.7V409.5L234.9 402.2C235 402 235 401.8 235 401.6C235 400.6 234.2 399.7 233.1 399.7C232.5 399.7 232 400 231.7 400.4L228.8 398.7C229.7 398.5 230.3 397.8 230.3 396.9C230.3 395.9 229.5 395 228.4 395C227.4 395 226.5 395.8 226.5 396.9C226.5 397.1 226.5 397.3 226.6 397.5L216 391C216 390.9 216 390.9 215.9 390.8C215.9 390.8 215.9 390.7 215.8 390.7C215.5 390.2 214.9 389.9 214.2 389.9H214L211 388.2C211.3 387.9 211.4 387.5 211.4 387.1C211.4 386.1 210.5 385.2 209.5 385.2C208.7 385.2 208 385.7 207.7 386.4L192.8 377.9V250.9C192.9 250.9 193.1 251 193.2 251H193.6C193.8 251.8 194.6 252.3 195.4 252.3C195.7 252.3 195.9 252.2 196.1 252.1L196.8 252.5L198.8 253.7C198.4 254 198.2 254.5 198.2 255.1C198.2 256.1 199.1 257 200.1 257C201 257 201.8 256.3 201.9 255.5L217.1 264.1V264.5C217.1 264.7 217.1 264.9 217.2 265.1C217.4 265.9 218.1 266.4 219 266.4C219.5 266.4 219.9 266.2 220.3 265.9L220.6 266.1L223.1 267.5C222.4 267.8 221.9 268.4 221.9 269.3C221.9 270.3 222.7 271.2 223.8 271.2C224.8 271.2 225.7 270.4 225.7 269.3V269L236.5 275.1C236.8 275.5 237.3 275.8 237.9 275.9L241.2 277.8C241 278.1 240.9 278.4 240.9 278.8C240.9 279.8 241.7 280.7 242.8 280.7C243.5 280.7 244.1 280.3 244.5 279.7L247.7 281.5C247.6 281.5 247.4 281.4 247.3 281.4C246.3 281.4 245.4 282.2 245.4 283.3C245.4 284.4 246.3 285.2 247.3 285.2ZM247.7 277.8L223.8 264.2L221.3 262.8L196.9 248.9L194.9 247.8V238.2L196.9 239.3L229.7 258L232.2 259.4L247.7 268.2V277.8ZM247.7 215.7C247 216 246.4 216.6 246.4 217.5C246.4 218.3 246.9 219 247.7 219.3V225.2C247 225.5 246.4 226.1 246.4 227C246.4 227.8 246.9 228.5 247.7 228.8V234.7C247 235 246.4 235.6 246.4 236.5C246.4 237.3 246.9 238 247.7 238.3V244.2C247 244.5 246.4 245.2 246.4 246C246.4 246.6 246.7 247.2 247.2 247.5C247.3 247.6 247.5 247.7 247.7 247.7V254C247 254.3 246.4 255 246.4 255.8C246.4 256.6 246.9 257.3 247.7 257.6V263.5C247.4 263.6 247.1 263.8 246.8 264.1L243.8 262.4C244.7 262.3 245.4 261.5 245.4 260.5C245.4 259.5 244.5 258.6 243.5 258.6C242.5 258.6 241.6 259.4 241.6 260.5C241.6 260.8 241.6 261 241.7 261.2L235.3 257.5L232.8 256.1L231.2 255.2C230.9 254.5 230.2 253.9 229.4 253.9H229.1L226.2 252.2C226.5 251.9 226.7 251.5 226.7 251C226.7 249.9 225.8 249.1 224.8 249.1C224 249.1 223.3 249.6 223 250.4L207.8 241.7V241.6C207.8 240.6 207 239.7 205.9 239.7C205.5 239.7 205.1 239.8 204.8 240L202.1 238.5C202.7 238.2 203 237.6 203 236.9C203 235.9 202.2 235 201.1 235C200.1 235 199.2 235.9 199.2 236.9L196.8 235.5L192.9 233.2V229C193.3 228.6 193.6 228.1 193.6 227.5C193.6 226.9 193.3 226.4 192.9 226V219.5C193.3 219.2 193.6 218.6 193.6 218C193.6 217.4 193.3 216.9 192.9 216.5V210C193 209.9 193.1 209.9 193.1 209.8C193.4 209.5 193.6 209 193.6 208.5C193.6 207.9 193.3 207.4 192.9 207V200.5C193.3 200.2 193.6 199.6 193.6 199C193.6 198.4 193.3 197.9 192.9 197.5V191C193.3 190.7 193.6 190.1 193.6 189.5C193.6 188.9 193.3 188.4 192.9 188V181.5C193.2 181.2 193.4 180.9 193.5 180.5L196.8 182.4L208.7 189.2V189.5C208.7 190.5 209.5 191.4 210.6 191.4C211.1 191.4 211.5 191.2 211.8 191L214.5 192.5C213.9 192.8 213.4 193.5 213.4 194.2C213.4 194.5 213.5 194.8 213.6 195C213.9 195.6 214.5 196.1 215.3 196.1C216.3 196.1 217.2 195.3 217.2 194.2V194L218.8 194.9L228.1 200.2C228.3 200.4 228.6 200.6 228.9 200.6L232.5 202.6C232.4 202.9 232.3 203.1 232.3 203.5C232.3 204.5 233.2 205.4 234.2 205.4C234.9 205.4 235.5 205 235.8 204.5L239 206.3H238.9C238.1 206.3 237.4 206.8 237.2 207.4C237.1 207.6 237.1 207.9 237.1 208.1C237.1 208.4 237.1 208.6 237.2 208.8C237.5 209.5 238.2 209.9 238.9 209.9C239.5 209.9 240.1 209.6 240.5 209.1C240.7 208.8 240.8 208.4 240.8 208.1C240.8 207.7 240.7 207.3 240.5 207L247.7 211.1V215.7ZM249.6 209.1L222 193.4L219.5 192L199 180.3L194.5 177.8L214.6 166.3L215.5 165.8V170.1C215.5 171.8 216.4 173.3 218.1 174.3C219.3 175 220.8 175.4 222.3 175.4C223.8 175.4 225.3 175 226.5 174.4C228.2 173.4 229.1 171.9 229.1 170.2V162.4C229.1 161.1 228.8 159.8 228.3 158.6L235.2 154.7L237.7 153.3L240.6 151.7L240.9 151.9V157.2C240.9 157.5 240.9 157.9 241 158.2C241.3 159.5 242.2 160.6 243.5 161.4C244.7 162.1 246.2 162.5 247.7 162.5H248.3C249.6 162.4 250.7 162.1 251.7 161.6C251.7 161.6 251.8 161.6 251.8 161.5C253.5 160.5 254.4 159 254.4 157.3V149.5C254.4 147.8 253.9 146.1 253.1 144.7L262.1 139.6V164.1C262.1 168.1 267.4 171.1 274.5 171.1C281.6 171.1 286.9 168.1 286.9 164.1V125.5L294.3 121.3L349.4 152.7L249.6 209.1ZM250.9 268.5L275.3 254.6V264.2L250.9 278.1V268.5ZM350.8 352.2L250.8 409.3V281.7L350 225.1C350.2 225 350.3 225 350.4 224.8L350.8 224.6V352.2ZM278.4 262.3V253.2L325.4 226.1V235.3L292.3 254.4L278.4 262.3ZM328.5 233.7V224.1L347.9 213.1V222.7L328.5 233.7ZM350.8 207.8L250.9 264.8V212L350.8 155V207.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M304.8 239.8C304.6 239.7 304.4 239.7 304.3 239.8L297 244C296.8 244.1 296.7 244.3 296.7 244.5V249.8C296.7 250 296.8 250.2 297 250.3H297.2C297.3 250.3 297.4 250.3 297.5 250.2L304.8 246C305 245.9 305.1 245.7 305.1 245.5V240.2C305.1 240 305 239.8 304.8 239.8ZM300.3 247.4L297.7 248.9V244.8L300.3 243.3V247.4ZM304 245.3L301.4 246.8V242.7L304 241.2V245.3ZM204.9 257.8C203.9 257.8 203 258.7 203 259.7C203 260.7 203.8 261.6 204.9 261.6C206 261.6 206.8 260.8 206.8 259.7C206.8 258.6 205.9 257.8 204.9 257.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M304.8 239.8C304.6 239.7 304.4 239.7 304.3 239.8L297 244C296.8 244.1 296.7 244.3 296.7 244.5V249.8C296.7 250 296.8 250.2 297 250.3H297.2C297.3 250.3 297.4 250.3 297.5 250.2L304.8 246C305 245.9 305.1 245.7 305.1 245.5V240.2C305.1 240 305 239.8 304.8 239.8ZM300.3 247.4L297.7 248.9V244.8L300.3 243.3V247.4ZM304 245.3L301.4 246.8V242.7L304 241.2V245.3ZM204.9 257.8C203.9 257.8 203 258.7 203 259.7C203 260.7 203.8 261.6 204.9 261.6C206 261.6 206.8 260.8 206.8 259.7C206.8 258.6 205.9 257.8 204.9 257.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.9 249.5C108.894 249.5 109.7 248.694 109.7 247.7C109.7 246.706 108.894 245.9 107.9 245.9C106.906 245.9 106.1 246.706 106.1 247.7C106.1 248.694 106.906 249.5 107.9 249.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.9 249.5C108.894 249.5 109.7 248.694 109.7 247.7C109.7 246.706 108.894 245.9 107.9 245.9C106.906 245.9 106.1 246.706 106.1 247.7C106.1 248.694 106.906 249.5 107.9 249.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.9 285.2C108.894 285.2 109.7 284.394 109.7 283.4C109.7 282.406 108.894 281.6 107.9 281.6C106.906 281.6 106.1 282.406 106.1 283.4C106.1 284.394 106.906 285.2 107.9 285.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.9 285.2C108.894 285.2 109.7 284.394 109.7 283.4C109.7 282.406 108.894 281.6 107.9 281.6C106.906 281.6 106.1 282.406 106.1 283.4C106.1 284.394 106.906 285.2 107.9 285.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M201.4 154.7L201.1 150.2L206.4 145.6L226.2 156.7L228.6 162.8L228.2 171.6L223.8 174.2L217.1 172.4L217 167.9L216.3 163.6L201.4 154.7ZM226.6 141.9L226.3 137.4L231.7 132.8L251.4 143.9L253.8 150L253.5 158.8L249.1 161.3L242.3 159.6L242.2 155.1L241.5 150.8L226.6 141.9Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M201.4 154.7L201.1 150.2L206.4 145.6L226.2 156.7L228.6 162.8L228.2 171.6L223.8 174.2L217.1 172.4L217 167.9L216.3 163.6L201.4 154.7ZM226.6 141.9L226.3 137.4L231.7 132.8L251.4 143.9L253.8 150L253.5 158.8L249.1 161.3L242.3 159.6L242.2 155.1L241.5 150.8L226.6 141.9Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M243.4 150.1C243.2 149.7 242.8 149.3 242.4 149.1L241.6 148.7L242.4 149.1C242.7 149.3 243 149.5 243.2 149.8C243.3 149.9 243.3 150 243.4 150.1ZM250.5 145.7C250.4 145.6 250.4 145.5 250.3 145.4C250.4 145.5 250.5 145.6 250.5 145.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M243.4 150.1C243.2 149.7 242.8 149.3 242.4 149.1L241.6 148.7L242.4 149.1C242.7 149.3 243 149.5 243.2 149.8C243.3 149.9 243.3 150 243.4 150.1ZM250.5 145.7C250.4 145.6 250.4 145.5 250.3 145.4C250.4 145.5 250.5 145.6 250.5 145.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		})
	]
});
export default SvgMaintenance;
